/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/hacktobercount/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 50);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return h; });
/* unused harmony export createElement */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return cloneElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* unused harmony export rerender */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return options; });
/** Virtual DOM Node */
function VNode() {}

/** Global options
 *	@public
 *	@namespace options {Object}
 */
var options = {

	/** If `true`, `prop` changes trigger synchronous component updates.
  *	@name syncComponentUpdates
  *	@type Boolean
  *	@default true
  */
	//syncComponentUpdates: true,

	/** Processes all created VNodes.
  *	@param {VNode} vnode	A newly-created VNode to normalize/process
  */
	//vnode(vnode) { }

	/** Hook invoked after a component is mounted. */
	// afterMount(component) { }

	/** Hook invoked after the DOM is updated with a component's latest render. */
	// afterUpdate(component) { }

	/** Hook invoked immediately before a component is unmounted. */
	// beforeUnmount(component) { }
};

var stack = [];

var EMPTY_CHILDREN = [];

/** JSX/hyperscript reviver
*	Benchmarks: https://esbench.com/bench/57ee8f8e330ab09900a1a1a0
 *	@see http://jasonformat.com/wtf-is-jsx
 *	@public
 */
function h(nodeName, attributes) {
	var children = EMPTY_CHILDREN,
	    lastSimple,
	    child,
	    simple,
	    i;
	for (i = arguments.length; i-- > 2;) {
		stack.push(arguments[i]);
	}
	if (attributes && attributes.children != null) {
		if (!stack.length) stack.push(attributes.children);
		delete attributes.children;
	}
	while (stack.length) {
		if ((child = stack.pop()) && child.pop !== undefined) {
			for (i = child.length; i--;) {
				stack.push(child[i]);
			}
		} else {
			if (typeof child === 'boolean') child = null;

			if (simple = typeof nodeName !== 'function') {
				if (child == null) child = '';else if (typeof child === 'number') child = String(child);else if (typeof child !== 'string') simple = false;
			}

			if (simple && lastSimple) {
				children[children.length - 1] += child;
			} else if (children === EMPTY_CHILDREN) {
				children = [child];
			} else {
				children.push(child);
			}

			lastSimple = simple;
		}
	}

	var p = new VNode();
	p.nodeName = nodeName;
	p.children = children;
	p.attributes = attributes == null ? undefined : attributes;
	p.key = attributes == null ? undefined : attributes.key;

	// if a "vnode hook" is defined, pass every created VNode to it
	if (options.vnode !== undefined) options.vnode(p);

	return p;
}

/** Copy own-properties from `props` onto `obj`.
 *	@returns obj
 *	@private
 */
function extend(obj, props) {
  for (var i in props) {
    obj[i] = props[i];
  }return obj;
}

/** Call a function asynchronously, as soon as possible.
 *	@param {Function} callback
 */
var defer = typeof Promise == 'function' ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout;

function cloneElement(vnode, props) {
	return h(vnode.nodeName, extend(extend({}, vnode.attributes), props), arguments.length > 2 ? [].slice.call(arguments, 2) : vnode.children);
}

// DOM properties that should NOT have "px" added when numeric
var IS_NON_DIMENSIONAL = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i;

/** Managed queue of dirty components to be re-rendered */

var items = [];

function enqueueRender(component) {
	if (!component._dirty && (component._dirty = true) && items.push(component) == 1) {
		(options.debounceRendering || defer)(rerender);
	}
}

function rerender() {
	var p,
	    list = items;
	items = [];
	while (p = list.pop()) {
		if (p._dirty) renderComponent(p);
	}
}

/** Check if two nodes are equivalent.
 *	@param {Element} node
 *	@param {VNode} vnode
 *	@private
 */
function isSameNodeType(node, vnode, hydrating) {
	if (typeof vnode === 'string' || typeof vnode === 'number') {
		return node.splitText !== undefined;
	}
	if (typeof vnode.nodeName === 'string') {
		return !node._componentConstructor && isNamedNode(node, vnode.nodeName);
	}
	return hydrating || node._componentConstructor === vnode.nodeName;
}

/** Check if an Element has a given normalized name.
*	@param {Element} node
*	@param {String} nodeName
 */
function isNamedNode(node, nodeName) {
	return node.normalizedNodeName === nodeName || node.nodeName.toLowerCase() === nodeName.toLowerCase();
}

/**
 * Reconstruct Component-style `props` from a VNode.
 * Ensures default/fallback values from `defaultProps`:
 * Own-properties of `defaultProps` not present in `vnode.attributes` are added.
 * @param {VNode} vnode
 * @returns {Object} props
 */
function getNodeProps(vnode) {
	var props = extend({}, vnode.attributes);
	props.children = vnode.children;

	var defaultProps = vnode.nodeName.defaultProps;
	if (defaultProps !== undefined) {
		for (var i in defaultProps) {
			if (props[i] === undefined) {
				props[i] = defaultProps[i];
			}
		}
	}

	return props;
}

/** Create an element with the given nodeName.
 *	@param {String} nodeName
 *	@param {Boolean} [isSvg=false]	If `true`, creates an element within the SVG namespace.
 *	@returns {Element} node
 */
function createNode(nodeName, isSvg) {
	var node = isSvg ? document.createElementNS('http://www.w3.org/2000/svg', nodeName) : document.createElement(nodeName);
	node.normalizedNodeName = nodeName;
	return node;
}

/** Remove a child node from its parent if attached.
 *	@param {Element} node		The node to remove
 */
function removeNode(node) {
	var parentNode = node.parentNode;
	if (parentNode) parentNode.removeChild(node);
}

/** Set a named attribute on the given Node, with special behavior for some names and event handlers.
 *	If `value` is `null`, the attribute/handler will be removed.
 *	@param {Element} node	An element to mutate
 *	@param {string} name	The name/key to set, such as an event or attribute name
 *	@param {any} old	The last value that was set for this name/node pair
 *	@param {any} value	An attribute value, such as a function to be used as an event handler
 *	@param {Boolean} isSvg	Are we currently diffing inside an svg?
 *	@private
 */
function setAccessor(node, name, old, value, isSvg) {
	if (name === 'className') name = 'class';

	if (name === 'key') {
		// ignore
	} else if (name === 'ref') {
		if (old) old(null);
		if (value) value(node);
	} else if (name === 'class' && !isSvg) {
		node.className = value || '';
	} else if (name === 'style') {
		if (!value || typeof value === 'string' || typeof old === 'string') {
			node.style.cssText = value || '';
		}
		if (value && typeof value === 'object') {
			if (typeof old !== 'string') {
				for (var i in old) {
					if (!(i in value)) node.style[i] = '';
				}
			}
			for (var i in value) {
				node.style[i] = typeof value[i] === 'number' && IS_NON_DIMENSIONAL.test(i) === false ? value[i] + 'px' : value[i];
			}
		}
	} else if (name === 'dangerouslySetInnerHTML') {
		if (value) node.innerHTML = value.__html || '';
	} else if (name[0] == 'o' && name[1] == 'n') {
		var useCapture = name !== (name = name.replace(/Capture$/, ''));
		name = name.toLowerCase().substring(2);
		if (value) {
			if (!old) node.addEventListener(name, eventProxy, useCapture);
		} else {
			node.removeEventListener(name, eventProxy, useCapture);
		}
		(node._listeners || (node._listeners = {}))[name] = value;
	} else if (name !== 'list' && name !== 'type' && !isSvg && name in node) {
		setProperty(node, name, value == null ? '' : value);
		if (value == null || value === false) node.removeAttribute(name);
	} else {
		var ns = isSvg && name !== (name = name.replace(/^xlink\:?/, ''));
		if (value == null || value === false) {
			if (ns) node.removeAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase());else node.removeAttribute(name);
		} else if (typeof value !== 'function') {
			if (ns) node.setAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase(), value);else node.setAttribute(name, value);
		}
	}
}

/** Attempt to set a DOM property to the given value.
 *	IE & FF throw for certain property-value combinations.
 */
function setProperty(node, name, value) {
	try {
		node[name] = value;
	} catch (e) {}
}

/** Proxy an event to hooked event handlers
 *	@private
 */
function eventProxy(e) {
	return this._listeners[e.type](options.event && options.event(e) || e);
}

/** Queue of components that have been mounted and are awaiting componentDidMount */
var mounts = [];

/** Diff recursion count, used to track the end of the diff cycle. */
var diffLevel = 0;

/** Global flag indicating if the diff is currently within an SVG */
var isSvgMode = false;

/** Global flag indicating if the diff is performing hydration */
var hydrating = false;

/** Invoke queued componentDidMount lifecycle methods */
function flushMounts() {
	var c;
	while (c = mounts.pop()) {
		if (options.afterMount) options.afterMount(c);
		if (c.componentDidMount) c.componentDidMount();
	}
}

/** Apply differences in a given vnode (and it's deep children) to a real DOM Node.
 *	@param {Element} [dom=null]		A DOM node to mutate into the shape of the `vnode`
 *	@param {VNode} vnode			A VNode (with descendants forming a tree) representing the desired DOM structure
 *	@returns {Element} dom			The created/mutated element
 *	@private
 */
function diff(dom, vnode, context, mountAll, parent, componentRoot) {
	// diffLevel having been 0 here indicates initial entry into the diff (not a subdiff)
	if (!diffLevel++) {
		// when first starting the diff, check if we're diffing an SVG or within an SVG
		isSvgMode = parent != null && parent.ownerSVGElement !== undefined;

		// hydration is indicated by the existing element to be diffed not having a prop cache
		hydrating = dom != null && !('__preactattr_' in dom);
	}

	var ret = idiff(dom, vnode, context, mountAll, componentRoot);

	// append the element if its a new parent
	if (parent && ret.parentNode !== parent) parent.appendChild(ret);

	// diffLevel being reduced to 0 means we're exiting the diff
	if (! --diffLevel) {
		hydrating = false;
		// invoke queued componentDidMount lifecycle methods
		if (!componentRoot) flushMounts();
	}

	return ret;
}

/** Internals of `diff()`, separated to allow bypassing diffLevel / mount flushing. */
function idiff(dom, vnode, context, mountAll, componentRoot) {
	var out = dom,
	    prevSvgMode = isSvgMode;

	// empty values (null, undefined, booleans) render as empty Text nodes
	if (vnode == null || typeof vnode === 'boolean') vnode = '';

	// Fast case: Strings & Numbers create/update Text nodes.
	if (typeof vnode === 'string' || typeof vnode === 'number') {

		// update if it's already a Text node:
		if (dom && dom.splitText !== undefined && dom.parentNode && (!dom._component || componentRoot)) {
			/* istanbul ignore if */ /* Browser quirk that can't be covered: https://github.com/developit/preact/commit/fd4f21f5c45dfd75151bd27b4c217d8003aa5eb9 */
			if (dom.nodeValue != vnode) {
				dom.nodeValue = vnode;
			}
		} else {
			// it wasn't a Text node: replace it with one and recycle the old Element
			out = document.createTextNode(vnode);
			if (dom) {
				if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
				recollectNodeTree(dom, true);
			}
		}

		out['__preactattr_'] = true;

		return out;
	}

	// If the VNode represents a Component, perform a component diff:
	var vnodeName = vnode.nodeName;
	if (typeof vnodeName === 'function') {
		return buildComponentFromVNode(dom, vnode, context, mountAll);
	}

	// Tracks entering and exiting SVG namespace when descending through the tree.
	isSvgMode = vnodeName === 'svg' ? true : vnodeName === 'foreignObject' ? false : isSvgMode;

	// If there's no existing element or it's the wrong type, create a new one:
	vnodeName = String(vnodeName);
	if (!dom || !isNamedNode(dom, vnodeName)) {
		out = createNode(vnodeName, isSvgMode);

		if (dom) {
			// move children into the replacement node
			while (dom.firstChild) {
				out.appendChild(dom.firstChild);
			} // if the previous Element was mounted into the DOM, replace it inline
			if (dom.parentNode) dom.parentNode.replaceChild(out, dom);

			// recycle the old element (skips non-Element node types)
			recollectNodeTree(dom, true);
		}
	}

	var fc = out.firstChild,
	    props = out['__preactattr_'],
	    vchildren = vnode.children;

	if (props == null) {
		props = out['__preactattr_'] = {};
		for (var a = out.attributes, i = a.length; i--;) {
			props[a[i].name] = a[i].value;
		}
	}

	// Optimization: fast-path for elements containing a single TextNode:
	if (!hydrating && vchildren && vchildren.length === 1 && typeof vchildren[0] === 'string' && fc != null && fc.splitText !== undefined && fc.nextSibling == null) {
		if (fc.nodeValue != vchildren[0]) {
			fc.nodeValue = vchildren[0];
		}
	}
	// otherwise, if there are existing or new children, diff them:
	else if (vchildren && vchildren.length || fc != null) {
			innerDiffNode(out, vchildren, context, mountAll, hydrating || props.dangerouslySetInnerHTML != null);
		}

	// Apply attributes/props from VNode to the DOM Element:
	diffAttributes(out, vnode.attributes, props);

	// restore previous SVG mode: (in case we're exiting an SVG namespace)
	isSvgMode = prevSvgMode;

	return out;
}

/** Apply child and attribute changes between a VNode and a DOM Node to the DOM.
 *	@param {Element} dom			Element whose children should be compared & mutated
 *	@param {Array} vchildren		Array of VNodes to compare to `dom.childNodes`
 *	@param {Object} context			Implicitly descendant context object (from most recent `getChildContext()`)
 *	@param {Boolean} mountAll
 *	@param {Boolean} isHydrating	If `true`, consumes externally created elements similar to hydration
 */
function innerDiffNode(dom, vchildren, context, mountAll, isHydrating) {
	var originalChildren = dom.childNodes,
	    children = [],
	    keyed = {},
	    keyedLen = 0,
	    min = 0,
	    len = originalChildren.length,
	    childrenLen = 0,
	    vlen = vchildren ? vchildren.length : 0,
	    j,
	    c,
	    f,
	    vchild,
	    child;

	// Build up a map of keyed children and an Array of unkeyed children:
	if (len !== 0) {
		for (var i = 0; i < len; i++) {
			var _child = originalChildren[i],
			    props = _child['__preactattr_'],
			    key = vlen && props ? _child._component ? _child._component.__key : props.key : null;
			if (key != null) {
				keyedLen++;
				keyed[key] = _child;
			} else if (props || (_child.splitText !== undefined ? isHydrating ? _child.nodeValue.trim() : true : isHydrating)) {
				children[childrenLen++] = _child;
			}
		}
	}

	if (vlen !== 0) {
		for (var i = 0; i < vlen; i++) {
			vchild = vchildren[i];
			child = null;

			// attempt to find a node based on key matching
			var key = vchild.key;
			if (key != null) {
				if (keyedLen && keyed[key] !== undefined) {
					child = keyed[key];
					keyed[key] = undefined;
					keyedLen--;
				}
			}
			// attempt to pluck a node of the same type from the existing children
			else if (!child && min < childrenLen) {
					for (j = min; j < childrenLen; j++) {
						if (children[j] !== undefined && isSameNodeType(c = children[j], vchild, isHydrating)) {
							child = c;
							children[j] = undefined;
							if (j === childrenLen - 1) childrenLen--;
							if (j === min) min++;
							break;
						}
					}
				}

			// morph the matched/found/created DOM child to match vchild (deep)
			child = idiff(child, vchild, context, mountAll);

			f = originalChildren[i];
			if (child && child !== dom && child !== f) {
				if (f == null) {
					dom.appendChild(child);
				} else if (child === f.nextSibling) {
					removeNode(f);
				} else {
					dom.insertBefore(child, f);
				}
			}
		}
	}

	// remove unused keyed children:
	if (keyedLen) {
		for (var i in keyed) {
			if (keyed[i] !== undefined) recollectNodeTree(keyed[i], false);
		}
	}

	// remove orphaned unkeyed children:
	while (min <= childrenLen) {
		if ((child = children[childrenLen--]) !== undefined) recollectNodeTree(child, false);
	}
}

/** Recursively recycle (or just unmount) a node and its descendants.
 *	@param {Node} node						DOM node to start unmount/removal from
 *	@param {Boolean} [unmountOnly=false]	If `true`, only triggers unmount lifecycle, skips removal
 */
function recollectNodeTree(node, unmountOnly) {
	var component = node._component;
	if (component) {
		// if node is owned by a Component, unmount that component (ends up recursing back here)
		unmountComponent(component);
	} else {
		// If the node's VNode had a ref function, invoke it with null here.
		// (this is part of the React spec, and smart for unsetting references)
		if (node['__preactattr_'] != null && node['__preactattr_'].ref) node['__preactattr_'].ref(null);

		if (unmountOnly === false || node['__preactattr_'] == null) {
			removeNode(node);
		}

		removeChildren(node);
	}
}

/** Recollect/unmount all children.
 *	- we use .lastChild here because it causes less reflow than .firstChild
 *	- it's also cheaper than accessing the .childNodes Live NodeList
 */
function removeChildren(node) {
	node = node.lastChild;
	while (node) {
		var next = node.previousSibling;
		recollectNodeTree(node, true);
		node = next;
	}
}

/** Apply differences in attributes from a VNode to the given DOM Element.
 *	@param {Element} dom		Element with attributes to diff `attrs` against
 *	@param {Object} attrs		The desired end-state key-value attribute pairs
 *	@param {Object} old			Current/previous attributes (from previous VNode or element's prop cache)
 */
function diffAttributes(dom, attrs, old) {
	var name;

	// remove attributes no longer present on the vnode by setting them to undefined
	for (name in old) {
		if (!(attrs && attrs[name] != null) && old[name] != null) {
			setAccessor(dom, name, old[name], old[name] = undefined, isSvgMode);
		}
	}

	// add new & update changed attributes
	for (name in attrs) {
		if (name !== 'children' && name !== 'innerHTML' && (!(name in old) || attrs[name] !== (name === 'value' || name === 'checked' ? dom[name] : old[name]))) {
			setAccessor(dom, name, old[name], old[name] = attrs[name], isSvgMode);
		}
	}
}

/** Retains a pool of Components for re-use, keyed on component name.
 *	Note: since component names are not unique or even necessarily available, these are primarily a form of sharding.
 *	@private
 */
var components = {};

/** Reclaim a component for later re-use by the recycler. */
function collectComponent(component) {
	var name = component.constructor.name;
	(components[name] || (components[name] = [])).push(component);
}

/** Create a component. Normalizes differences between PFC's and classful Components. */
function createComponent(Ctor, props, context) {
	var list = components[Ctor.name],
	    inst;

	if (Ctor.prototype && Ctor.prototype.render) {
		inst = new Ctor(props, context);
		Component.call(inst, props, context);
	} else {
		inst = new Component(props, context);
		inst.constructor = Ctor;
		inst.render = doRender;
	}

	if (list) {
		for (var i = list.length; i--;) {
			if (list[i].constructor === Ctor) {
				inst.nextBase = list[i].nextBase;
				list.splice(i, 1);
				break;
			}
		}
	}
	return inst;
}

/** The `.render()` method for a PFC backing instance. */
function doRender(props, state, context) {
	return this.constructor(props, context);
}

/** Set a component's `props` (generally derived from JSX attributes).
 *	@param {Object} props
 *	@param {Object} [opts]
 *	@param {boolean} [opts.renderSync=false]	If `true` and {@link options.syncComponentUpdates} is `true`, triggers synchronous rendering.
 *	@param {boolean} [opts.render=true]			If `false`, no render will be triggered.
 */
function setComponentProps(component, props, opts, context, mountAll) {
	if (component._disable) return;
	component._disable = true;

	if (component.__ref = props.ref) delete props.ref;
	if (component.__key = props.key) delete props.key;

	if (!component.base || mountAll) {
		if (component.componentWillMount) component.componentWillMount();
	} else if (component.componentWillReceiveProps) {
		component.componentWillReceiveProps(props, context);
	}

	if (context && context !== component.context) {
		if (!component.prevContext) component.prevContext = component.context;
		component.context = context;
	}

	if (!component.prevProps) component.prevProps = component.props;
	component.props = props;

	component._disable = false;

	if (opts !== 0) {
		if (opts === 1 || options.syncComponentUpdates !== false || !component.base) {
			renderComponent(component, 1, mountAll);
		} else {
			enqueueRender(component);
		}
	}

	if (component.__ref) component.__ref(component);
}

/** Render a Component, triggering necessary lifecycle events and taking High-Order Components into account.
 *	@param {Component} component
 *	@param {Object} [opts]
 *	@param {boolean} [opts.build=false]		If `true`, component will build and store a DOM node if not already associated with one.
 *	@private
 */
function renderComponent(component, opts, mountAll, isChild) {
	if (component._disable) return;

	var props = component.props,
	    state = component.state,
	    context = component.context,
	    previousProps = component.prevProps || props,
	    previousState = component.prevState || state,
	    previousContext = component.prevContext || context,
	    isUpdate = component.base,
	    nextBase = component.nextBase,
	    initialBase = isUpdate || nextBase,
	    initialChildComponent = component._component,
	    skip = false,
	    rendered,
	    inst,
	    cbase;

	// if updating
	if (isUpdate) {
		component.props = previousProps;
		component.state = previousState;
		component.context = previousContext;
		if (opts !== 2 && component.shouldComponentUpdate && component.shouldComponentUpdate(props, state, context) === false) {
			skip = true;
		} else if (component.componentWillUpdate) {
			component.componentWillUpdate(props, state, context);
		}
		component.props = props;
		component.state = state;
		component.context = context;
	}

	component.prevProps = component.prevState = component.prevContext = component.nextBase = null;
	component._dirty = false;

	if (!skip) {
		rendered = component.render(props, state, context);

		// context to pass to the child, can be updated via (grand-)parent component
		if (component.getChildContext) {
			context = extend(extend({}, context), component.getChildContext());
		}

		var childComponent = rendered && rendered.nodeName,
		    toUnmount,
		    base;

		if (typeof childComponent === 'function') {
			// set up high order component link

			var childProps = getNodeProps(rendered);
			inst = initialChildComponent;

			if (inst && inst.constructor === childComponent && childProps.key == inst.__key) {
				setComponentProps(inst, childProps, 1, context, false);
			} else {
				toUnmount = inst;

				component._component = inst = createComponent(childComponent, childProps, context);
				inst.nextBase = inst.nextBase || nextBase;
				inst._parentComponent = component;
				setComponentProps(inst, childProps, 0, context, false);
				renderComponent(inst, 1, mountAll, true);
			}

			base = inst.base;
		} else {
			cbase = initialBase;

			// destroy high order component link
			toUnmount = initialChildComponent;
			if (toUnmount) {
				cbase = component._component = null;
			}

			if (initialBase || opts === 1) {
				if (cbase) cbase._component = null;
				base = diff(cbase, rendered, context, mountAll || !isUpdate, initialBase && initialBase.parentNode, true);
			}
		}

		if (initialBase && base !== initialBase && inst !== initialChildComponent) {
			var baseParent = initialBase.parentNode;
			if (baseParent && base !== baseParent) {
				baseParent.replaceChild(base, initialBase);

				if (!toUnmount) {
					initialBase._component = null;
					recollectNodeTree(initialBase, false);
				}
			}
		}

		if (toUnmount) {
			unmountComponent(toUnmount);
		}

		component.base = base;
		if (base && !isChild) {
			var componentRef = component,
			    t = component;
			while (t = t._parentComponent) {
				(componentRef = t).base = base;
			}
			base._component = componentRef;
			base._componentConstructor = componentRef.constructor;
		}
	}

	if (!isUpdate || mountAll) {
		mounts.unshift(component);
	} else if (!skip) {
		// Ensure that pending componentDidMount() hooks of child components
		// are called before the componentDidUpdate() hook in the parent.
		// Note: disabled as it causes duplicate hooks, see https://github.com/developit/preact/issues/750
		// flushMounts();

		if (component.componentDidUpdate) {
			component.componentDidUpdate(previousProps, previousState, previousContext);
		}
		if (options.afterUpdate) options.afterUpdate(component);
	}

	if (component._renderCallbacks != null) {
		while (component._renderCallbacks.length) {
			component._renderCallbacks.pop().call(component);
		}
	}

	if (!diffLevel && !isChild) flushMounts();
}

/** Apply the Component referenced by a VNode to the DOM.
 *	@param {Element} dom	The DOM node to mutate
 *	@param {VNode} vnode	A Component-referencing VNode
 *	@returns {Element} dom	The created/mutated element
 *	@private
 */
function buildComponentFromVNode(dom, vnode, context, mountAll) {
	var c = dom && dom._component,
	    originalComponent = c,
	    oldDom = dom,
	    isDirectOwner = c && dom._componentConstructor === vnode.nodeName,
	    isOwner = isDirectOwner,
	    props = getNodeProps(vnode);
	while (c && !isOwner && (c = c._parentComponent)) {
		isOwner = c.constructor === vnode.nodeName;
	}

	if (c && isOwner && (!mountAll || c._component)) {
		setComponentProps(c, props, 3, context, mountAll);
		dom = c.base;
	} else {
		if (originalComponent && !isDirectOwner) {
			unmountComponent(originalComponent);
			dom = oldDom = null;
		}

		c = createComponent(vnode.nodeName, props, context);
		if (dom && !c.nextBase) {
			c.nextBase = dom;
			// passing dom/oldDom as nextBase will recycle it if unused, so bypass recycling on L229:
			oldDom = null;
		}
		setComponentProps(c, props, 1, context, mountAll);
		dom = c.base;

		if (oldDom && dom !== oldDom) {
			oldDom._component = null;
			recollectNodeTree(oldDom, false);
		}
	}

	return dom;
}

/** Remove a component from the DOM and recycle it.
 *	@param {Component} component	The Component instance to unmount
 *	@private
 */
function unmountComponent(component) {
	if (options.beforeUnmount) options.beforeUnmount(component);

	var base = component.base;

	component._disable = true;

	if (component.componentWillUnmount) component.componentWillUnmount();

	component.base = null;

	// recursively tear down & recollect high-order component children:
	var inner = component._component;
	if (inner) {
		unmountComponent(inner);
	} else if (base) {
		if (base['__preactattr_'] && base['__preactattr_'].ref) base['__preactattr_'].ref(null);

		component.nextBase = base;

		removeNode(base);
		collectComponent(component);

		removeChildren(base);
	}

	if (component.__ref) component.__ref(null);
}

/** Base Component class.
 *	Provides `setState()` and `forceUpdate()`, which trigger rendering.
 *	@public
 *
 *	@example
 *	class MyFoo extends Component {
 *		render(props, state) {
 *			return <div />;
 *		}
 *	}
 */
function Component(props, context) {
	this._dirty = true;

	/** @public
  *	@type {object}
  */
	this.context = context;

	/** @public
  *	@type {object}
  */
	this.props = props;

	/** @public
  *	@type {object}
  */
	this.state = this.state || {};
}

extend(Component.prototype, {

	/** Returns a `boolean` indicating if the component should re-render when receiving the given `props` and `state`.
  *	@param {object} nextProps
  *	@param {object} nextState
  *	@param {object} nextContext
  *	@returns {Boolean} should the component re-render
  *	@name shouldComponentUpdate
  *	@function
  */

	/** Update component state by copying properties from `state` to `this.state`.
  *	@param {object} state		A hash of state properties to update with new values
  *	@param {function} callback	A function to be called once component state is updated
  */
	setState: function setState(state, callback) {
		var s = this.state;
		if (!this.prevState) this.prevState = extend({}, s);
		extend(s, typeof state === 'function' ? state(s, this.props) : state);
		if (callback) (this._renderCallbacks = this._renderCallbacks || []).push(callback);
		enqueueRender(this);
	},


	/** Immediately perform a synchronous re-render of the component.
  *	@param {function} callback		A function to be called after component is re-rendered.
  *	@private
  */
	forceUpdate: function forceUpdate(callback) {
		if (callback) (this._renderCallbacks = this._renderCallbacks || []).push(callback);
		renderComponent(this, 2);
	},


	/** Accepts `props` and `state`, and returns a new Virtual DOM tree to build.
  *	Virtual DOM is generally constructed via [JSX](http://jasonformat.com/wtf-is-jsx).
  *	@param {object} props		Props (eg: JSX attributes) received from parent element/component
  *	@param {object} state		The component's current state
  *	@param {object} context		Context object (if a parent component has provided context)
  *	@returns VNode
  */
	render: function render() {}
});

/** Render JSX into a `parent` Element.
 *	@param {VNode} vnode		A (JSX) VNode to render
 *	@param {Element} parent		DOM element to render into
 *	@param {Element} [merge]	Attempt to re-use an existing DOM tree rooted at `merge`
 *	@public
 *
 *	@example
 *	// render a div into <body>:
 *	render(<div id="hello">hello!</div>, document.body);
 *
 *	@example
 *	// render a "Thing" component into #foo:
 *	const Thing = ({ name }) => <span>{ name }</span>;
 *	render(<Thing name="one" />, document.querySelector('#foo'));
 */
function render(vnode, parent, merge) {
  return diff(merge, vnode, {}, false, parent, false);
}

var preact = {
	h: h,
	createElement: h,
	cloneElement: cloneElement,
	Component: Component,
	render: render,
	rerender: rerender,
	options: options
};


/* unused harmony default export */ var _unused_webpack_default_export = (preact);
//# sourceMappingURL=preact.esm.js.map


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(41);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.unicodeToCodepoint = exports.codepointToUnicode = exports.shortToCodepoint = exports.codepointToShort = exports.unicodes = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _emojiData = __webpack_require__(40);

var _emojiData2 = _interopRequireDefault(_emojiData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var unicodes = exports.unicodes = [];
var codepointToShort = exports.codepointToShort = new Map();
var shortToCodepoint = exports.shortToCodepoint = new Map();
var codepointToUnicode = exports.codepointToUnicode = new Map();
var unicodeToCodepoint = exports.unicodeToCodepoint = new Map();

_emojiData2.default.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 3),
        codepoint = _ref2[0],
        unicode = _ref2[1],
        shortname = _ref2[2];

    unicodes.push(unicode);
    codepointToShort.set(codepoint, shortname);
    shortToCodepoint.set(shortname, codepoint);
    codepointToUnicode.set(codepoint, unicode);
    unicodeToCodepoint.set(unicode, codepoint);
});

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "version", function() { return version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOM", function() { return DOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Children", function() { return Children; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createClass", function() { return createClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createFactory", function() { return createFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return createElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneElement", function() { return cloneElement$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isValidElement", function() { return isValidElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findDOMNode", function() { return findDOMNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unmountComponentAtNode", function() { return unmountComponentAtNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Component", function() { return Component$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PureComponent", function() { return PureComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unstable_renderSubtreeIntoContainer", function() { return renderSubtreeIntoContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return extend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__(0);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "PropTypes", function() { return __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a; });



var version = '15.1.0'; // trick libraries to think we are react

var ELEMENTS = 'a abbr address area article aside audio b base bdi bdo big blockquote body br button canvas caption cite code col colgroup data datalist dd del details dfn dialog div dl dt em embed fieldset figcaption figure footer form h1 h2 h3 h4 h5 h6 head header hgroup hr html i iframe img input ins kbd keygen label legend li link main map mark menu menuitem meta meter nav noscript object ol optgroup option output p param picture pre progress q rp rt ruby s samp script section select small source span strong style sub summary sup table tbody td textarea tfoot th thead time title tr track u ul var video wbr circle clipPath defs ellipse g image line linearGradient mask path pattern polygon polyline radialGradient rect stop svg text tspan'.split(' ');

var REACT_ELEMENT_TYPE = (typeof Symbol!=='undefined' && Symbol.for && Symbol.for('react.element')) || 0xeac7;

var COMPONENT_WRAPPER_KEY = typeof Symbol!=='undefined' ? Symbol.for('__preactCompatWrapper') : '__preactCompatWrapper';

// don't autobind these methods since they already have guaranteed context.
var AUTOBIND_BLACKLIST = {
	constructor: 1,
	render: 1,
	shouldComponentUpdate: 1,
	componentWillReceiveProps: 1,
	componentWillUpdate: 1,
	componentDidUpdate: 1,
	componentWillMount: 1,
	componentDidMount: 1,
	componentWillUnmount: 1,
	componentDidUnmount: 1
};


var CAMEL_PROPS = /^(?:accent|alignment|arabic|baseline|cap|clip|color|fill|flood|font|glyph|horiz|marker|overline|paint|stop|strikethrough|stroke|text|underline|unicode|units|v|vector|vert|word|writing|x)[A-Z]/;


var BYPASS_HOOK = {};

/*global process*/
var DEV = typeof process==='undefined' || !__webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":"/hacktobercount"}) || "production"!=='production';

// a component that renders nothing. Used to replace components for unmountComponentAtNode.
function EmptyComponent() { return null; }



// make react think we're react.
var VNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */])('a', null).constructor;
VNode.prototype.$$typeof = REACT_ELEMENT_TYPE;
VNode.prototype.preactCompatUpgraded = false;
VNode.prototype.preactCompatNormalized = false;

Object.defineProperty(VNode.prototype, 'type', {
	get: function() { return this.nodeName; },
	set: function(v) { this.nodeName = v; },
	configurable:true
});

Object.defineProperty(VNode.prototype, 'props', {
	get: function() { return this.attributes; },
	set: function(v) { this.attributes = v; },
	configurable:true
});



var oldEventHook = __WEBPACK_IMPORTED_MODULE_1_preact__["d" /* options */].event;
__WEBPACK_IMPORTED_MODULE_1_preact__["d" /* options */].event = function (e) {
	if (oldEventHook) { e = oldEventHook(e); }
	e.persist = Object;
	e.nativeEvent = e;
	return e;
};


var oldVnodeHook = __WEBPACK_IMPORTED_MODULE_1_preact__["d" /* options */].vnode;
__WEBPACK_IMPORTED_MODULE_1_preact__["d" /* options */].vnode = function (vnode) {
	if (!vnode.preactCompatUpgraded) {
		vnode.preactCompatUpgraded = true;

		var tag = vnode.nodeName,
			attrs = vnode.attributes = extend({}, vnode.attributes);

		if (typeof tag==='function') {
			if (tag[COMPONENT_WRAPPER_KEY]===true || (tag.prototype && 'isReactComponent' in tag.prototype)) {
				if (vnode.children && String(vnode.children)==='') { vnode.children = undefined; }
				if (vnode.children) { attrs.children = vnode.children; }

				if (!vnode.preactCompatNormalized) {
					normalizeVNode(vnode);
				}
				handleComponentVNode(vnode);
			}
		}
		else {
			if (vnode.children && String(vnode.children)==='') { vnode.children = undefined; }
			if (vnode.children) { attrs.children = vnode.children; }

			if (attrs.defaultValue) {
				if (!attrs.value && attrs.value!==0) {
					attrs.value = attrs.defaultValue;
				}
				delete attrs.defaultValue;
			}

			handleElementVNode(vnode, attrs);
		}
	}

	if (oldVnodeHook) { oldVnodeHook(vnode); }
};

function handleComponentVNode(vnode) {
	var tag = vnode.nodeName,
		a = vnode.attributes;

	vnode.attributes = {};
	if (tag.defaultProps) { extend(vnode.attributes, tag.defaultProps); }
	if (a) { extend(vnode.attributes, a); }
}

function handleElementVNode(vnode, a) {
	var shouldSanitize, attrs, i;
	if (a) {
		for (i in a) { if ((shouldSanitize = CAMEL_PROPS.test(i))) { break; } }
		if (shouldSanitize) {
			attrs = vnode.attributes = {};
			for (i in a) {
				if (a.hasOwnProperty(i)) {
					attrs[ CAMEL_PROPS.test(i) ? i.replace(/([A-Z0-9])/, '-$1').toLowerCase() : i ] = a[i];
				}
			}
		}
	}
}



// proxy render() since React returns a Component reference.
function render$1(vnode, parent, callback) {
	var prev = parent && parent._preactCompatRendered && parent._preactCompatRendered.base;

	// ignore impossible previous renders
	if (prev && prev.parentNode!==parent) { prev = null; }

	// default to first Element child
	if (!prev && parent) { prev = parent.firstElementChild; }

	// remove unaffected siblings
	for (var i=parent.childNodes.length; i--; ) {
		if (parent.childNodes[i]!==prev) {
			parent.removeChild(parent.childNodes[i]);
		}
	}

	var out = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_preact__["a" /* render */])(vnode, parent, prev);
	if (parent) { parent._preactCompatRendered = out && (out._component || { base: out }); }
	if (typeof callback==='function') { callback(); }
	return out && out._component || out;
}


var ContextProvider = function () {};

ContextProvider.prototype.getChildContext = function () {
	return this.props.context;
};
ContextProvider.prototype.render = function (props) {
	return props.children[0];
};

function renderSubtreeIntoContainer(parentComponent, vnode, container, callback) {
	var wrap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */])(ContextProvider, { context: parentComponent.context }, vnode);
	var renderContainer = render$1(wrap, container);
	var component = renderContainer._component || renderContainer.base;
	if (callback) { callback.call(component, renderContainer); }
	return component;
}


function unmountComponentAtNode(container) {
	var existing = container._preactCompatRendered && container._preactCompatRendered.base;
	if (existing && existing.parentNode===container) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_preact__["a" /* render */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */])(EmptyComponent), container, existing);
		return true;
	}
	return false;
}



var ARR = [];

// This API is completely unnecessary for Preact, so it's basically passthrough.
var Children = {
	map: function(children, fn, ctx) {
		if (children == null) { return null; }
		children = Children.toArray(children);
		if (ctx && ctx!==children) { fn = fn.bind(ctx); }
		return children.map(fn);
	},
	forEach: function(children, fn, ctx) {
		if (children == null) { return null; }
		children = Children.toArray(children);
		if (ctx && ctx!==children) { fn = fn.bind(ctx); }
		children.forEach(fn);
	},
	count: function(children) {
		return children && children.length || 0;
	},
	only: function(children) {
		children = Children.toArray(children);
		if (children.length!==1) { throw new Error('Children.only() expects only one child.'); }
		return children[0];
	},
	toArray: function(children) {
		if (children == null) { return []; }
		return ARR.concat(children);
	}
};


/** Track current render() component for ref assignment */
var currentComponent;


function createFactory(type) {
	return createElement.bind(null, type);
}


var DOM = {};
for (var i=ELEMENTS.length; i--; ) {
	DOM[ELEMENTS[i]] = createFactory(ELEMENTS[i]);
}

function upgradeToVNodes(arr, offset) {
	for (var i=offset || 0; i<arr.length; i++) {
		var obj = arr[i];
		if (Array.isArray(obj)) {
			upgradeToVNodes(obj);
		}
		else if (obj && typeof obj==='object' && !isValidElement(obj) && ((obj.props && obj.type) || (obj.attributes && obj.nodeName) || obj.children)) {
			arr[i] = createElement(obj.type || obj.nodeName, obj.props || obj.attributes, obj.children);
		}
	}
}

function isStatelessComponent(c) {
	return typeof c==='function' && !(c.prototype && c.prototype.render);
}


// wraps stateless functional components in a PropTypes validator
function wrapStatelessComponent(WrappedComponent) {
	return createClass({
		displayName: WrappedComponent.displayName || WrappedComponent.name,
		render: function() {
			return WrappedComponent(this.props, this.context);
		}
	});
}


function statelessComponentHook(Ctor) {
	var Wrapped = Ctor[COMPONENT_WRAPPER_KEY];
	if (Wrapped) { return Wrapped===true ? Ctor : Wrapped; }

	Wrapped = wrapStatelessComponent(Ctor);

	Object.defineProperty(Wrapped, COMPONENT_WRAPPER_KEY, { configurable:true, value:true });
	Wrapped.displayName = Ctor.displayName;
	Wrapped.propTypes = Ctor.propTypes;
	Wrapped.defaultProps = Ctor.defaultProps;

	Object.defineProperty(Ctor, COMPONENT_WRAPPER_KEY, { configurable:true, value:Wrapped });

	return Wrapped;
}


function createElement() {
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	upgradeToVNodes(args, 2);
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */].apply(void 0, args));
}


function normalizeVNode(vnode) {
	vnode.preactCompatNormalized = true;

	applyClassName(vnode);

	if (isStatelessComponent(vnode.nodeName)) {
		vnode.nodeName = statelessComponentHook(vnode.nodeName);
	}

	var ref = vnode.attributes.ref,
		type = ref && typeof ref;
	if (currentComponent && (type==='string' || type==='number')) {
		vnode.attributes.ref = createStringRefProxy(ref, currentComponent);
	}

	applyEventNormalization(vnode);

	return vnode;
}


function cloneElement$1(element, props) {
	var children = [], len = arguments.length - 2;
	while ( len-- > 0 ) children[ len ] = arguments[ len + 2 ];

	if (!isValidElement(element)) { return element; }
	var elementProps = element.attributes || element.props;
	var node = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_preact__["b" /* h */])(
		element.nodeName || element.type,
		elementProps,
		element.children || elementProps && elementProps.children
	);
	// Only provide the 3rd argument if needed.
	// Arguments 3+ overwrite element.children in preactCloneElement
	var cloneArgs = [node, props];
	if (children && children.length) {
		cloneArgs.push(children);
	}
	else if (props && props.children) {
		cloneArgs.push(props.children);
	}
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["e" /* cloneElement */].apply(void 0, cloneArgs));
}


function isValidElement(element) {
	return element && ((element instanceof VNode) || element.$$typeof===REACT_ELEMENT_TYPE);
}


function createStringRefProxy(name, component) {
	return component._refProxies[name] || (component._refProxies[name] = function (resolved) {
		if (component && component.refs) {
			component.refs[name] = resolved;
			if (resolved===null) {
				delete component._refProxies[name];
				component = null;
			}
		}
	});
}


function applyEventNormalization(ref) {
	var nodeName = ref.nodeName;
	var attributes = ref.attributes;

	if (!attributes || typeof nodeName!=='string') { return; }
	var props = {};
	for (var i in attributes) {
		props[i.toLowerCase()] = i;
	}
	if (props.ondoubleclick) {
		attributes.ondblclick = attributes[props.ondoubleclick];
		delete attributes[props.ondoubleclick];
	}
	// for *textual inputs* (incl textarea), normalize `onChange` -> `onInput`:
	if (props.onchange && (nodeName==='textarea' || (nodeName.toLowerCase()==='input' && !/^fil|che|rad/i.test(attributes.type)))) {
		var normalized = props.oninput || 'oninput';
		if (!attributes[normalized]) {
			attributes[normalized] = multihook([attributes[normalized], attributes[props.onchange]]);
			delete attributes[props.onchange];
		}
	}
}


function applyClassName(vnode) {
	var a = vnode.attributes || (vnode.attributes = {});
	classNameDescriptor.enumerable = 'className' in a;
	if (a.className) { a.class = a.className; }
	Object.defineProperty(a, 'className', classNameDescriptor);
}


var classNameDescriptor = {
	configurable: true,
	get: function() { return this.class; },
	set: function(v) { this.class = v; }
};

function extend(base, props) {
	var arguments$1 = arguments;

	for (var i=1, obj = (void 0); i<arguments.length; i++) {
		if ((obj = arguments$1[i])) {
			for (var key in obj) {
				if (obj.hasOwnProperty(key)) {
					base[key] = obj[key];
				}
			}
		}
	}
	return base;
}


function shallowDiffers(a, b) {
	for (var i in a) { if (!(i in b)) { return true; } }
	for (var i$1 in b) { if (a[i$1]!==b[i$1]) { return true; } }
	return false;
}


function findDOMNode(component) {
	return component && component.base || component;
}


function F(){}

function createClass(obj) {
	function cl(props, context) {
		bindAll(this);
		Component$1.call(this, props, context, BYPASS_HOOK);
		newComponentHook.call(this, props, context);
	}

	obj = extend({ constructor: cl }, obj);

	// We need to apply mixins here so that getDefaultProps is correctly mixed
	if (obj.mixins) {
		applyMixins(obj, collateMixins(obj.mixins));
	}
	if (obj.statics) {
		extend(cl, obj.statics);
	}
	if (obj.propTypes) {
		cl.propTypes = obj.propTypes;
	}
	if (obj.defaultProps) {
		cl.defaultProps = obj.defaultProps;
	}
	if (obj.getDefaultProps) {
		cl.defaultProps = obj.getDefaultProps();
	}

	F.prototype = Component$1.prototype;
	cl.prototype = extend(new F(), obj);

	cl.displayName = obj.displayName || 'Component';

	return cl;
}


// Flatten an Array of mixins to a map of method name to mixin implementations
function collateMixins(mixins) {
	var keyed = {};
	for (var i=0; i<mixins.length; i++) {
		var mixin = mixins[i];
		for (var key in mixin) {
			if (mixin.hasOwnProperty(key) && typeof mixin[key]==='function') {
				(keyed[key] || (keyed[key]=[])).push(mixin[key]);
			}
		}
	}
	return keyed;
}


// apply a mapping of Arrays of mixin methods to a component prototype
function applyMixins(proto, mixins) {
	for (var key in mixins) { if (mixins.hasOwnProperty(key)) {
		proto[key] = multihook(
			mixins[key].concat(proto[key] || ARR),
			key==='getDefaultProps' || key==='getInitialState' || key==='getChildContext'
		);
	} }
}


function bindAll(ctx) {
	for (var i in ctx) {
		var v = ctx[i];
		if (typeof v==='function' && !v.__bound && !AUTOBIND_BLACKLIST.hasOwnProperty(i)) {
			(ctx[i] = v.bind(ctx)).__bound = true;
		}
	}
}


function callMethod(ctx, m, args) {
	if (typeof m==='string') {
		m = ctx.constructor.prototype[m];
	}
	if (typeof m==='function') {
		return m.apply(ctx, args);
	}
}

function multihook(hooks, skipDuplicates) {
	return function() {
		var arguments$1 = arguments;
		var this$1 = this;

		var ret;
		for (var i=0; i<hooks.length; i++) {
			var r = callMethod(this$1, hooks[i], arguments$1);

			if (skipDuplicates && r!=null) {
				if (!ret) { ret = {}; }
				for (var key in r) { if (r.hasOwnProperty(key)) {
					ret[key] = r[key];
				} }
			}
			else if (typeof r!=='undefined') { ret = r; }
		}
		return ret;
	};
}


function newComponentHook(props, context) {
	propsHook.call(this, props, context);
	this.componentWillReceiveProps = multihook([propsHook, this.componentWillReceiveProps || 'componentWillReceiveProps']);
	this.render = multihook([propsHook, beforeRender, this.render || 'render', afterRender]);
}


function propsHook(props, context) {
	if (!props) { return; }

	// React annoyingly special-cases single children, and some react components are ridiculously strict about this.
	var c = props.children;
	if (c && Array.isArray(c) && c.length===1 && (typeof c[0]==='string' || typeof c[0]==='function' || c[0] instanceof VNode)) {
		props.children = c[0];

		// but its totally still going to be an Array.
		if (props.children && typeof props.children==='object') {
			props.children.length = 1;
			props.children[0] = props.children;
		}
	}

	// add proptype checking
	if (DEV) {
		var ctor = typeof this==='function' ? this : this.constructor,
			propTypes = this.propTypes || ctor.propTypes;
		var displayName = this.displayName || ctor.name;

		if (propTypes) {
			__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.checkPropTypes(propTypes, props, 'prop', displayName);
		}
	}
}


function beforeRender(props) {
	currentComponent = this;
}

function afterRender() {
	if (currentComponent===this) {
		currentComponent = null;
	}
}



function Component$1(props, context, opts) {
	__WEBPACK_IMPORTED_MODULE_1_preact__["c" /* Component */].call(this, props, context);
	this.state = this.getInitialState ? this.getInitialState() : {};
	this.refs = {};
	this._refProxies = {};
	if (opts!==BYPASS_HOOK) {
		newComponentHook.call(this, props, context);
	}
}
extend(Component$1.prototype = new __WEBPACK_IMPORTED_MODULE_1_preact__["c" /* Component */](), {
	constructor: Component$1,

	isReactComponent: {},

	replaceState: function(state, callback) {
		var this$1 = this;

		this.setState(state, callback);
		for (var i in this$1.state) {
			if (!(i in state)) {
				delete this$1.state[i];
			}
		}
	},

	getDOMNode: function() {
		return this.base;
	},

	isMounted: function() {
		return !!this.base;
	}
});



function PureComponent(props, context) {
	Component$1.call(this, props, context);
}
F.prototype = Component$1.prototype;
PureComponent.prototype = new F();
PureComponent.prototype.isPureReactComponent = true;
PureComponent.prototype.shouldComponentUpdate = function(props, state) {
	return shallowDiffers(this.props, props) || shallowDiffers(this.state, state);
};

var index = {
	version: version,
	DOM: DOM,
	PropTypes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a,
	Children: Children,
	render: render$1,
	createClass: createClass,
	createFactory: createFactory,
	createElement: createElement,
	cloneElement: cloneElement$1,
	isValidElement: isValidElement,
	findDOMNode: findDOMNode,
	unmountComponentAtNode: unmountComponentAtNode,
	Component: Component$1,
	PureComponent: PureComponent,
	unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer,
	__spread: extend
};

/* harmony default export */ __webpack_exports__["default"] = (index);
//# sourceMappingURL=preact-compat.es.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(32)))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(19);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('not a function');
  }
  this._45 = 0;
  this._81 = 0;
  this._65 = null;
  this._54 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._10 = null;
Promise._97 = null;
Promise._61 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
};
function handle(self, deferred) {
  while (self._81 === 3) {
    self = self._65;
  }
  if (Promise._10) {
    Promise._10(self);
  }
  if (self._81 === 0) {
    if (self._45 === 0) {
      self._45 = 1;
      self._54 = deferred;
      return;
    }
    if (self._45 === 1) {
      self._45 = 2;
      self._54 = [self._54, deferred];
      return;
    }
    self._54.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._81 === 1) {
        resolve(deferred.promise, self._65);
      } else {
        reject(deferred.promise, self._65);
      }
      return;
    }
    var ret = tryCallOne(cb, self._65);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._81 = 3;
      self._65 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._81 = 1;
  self._65 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._81 = 2;
  self._65 = newValue;
  if (Promise._97) {
    Promise._97(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._45 === 1) {
    handle(self, self._54);
    self._54 = null;
  }
  if (self._45 === 2) {
    for (var i = 0; i < self._54.length; i++) {
      handle(self, self._54[i]);
    }
    self._54 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  })
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(34).enable();
  window.Promise = __webpack_require__(33);
}

// fetch() polyfill for making API calls.
__webpack_require__(49);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(3);


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_App__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__registerServiceWorker__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_css__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_css__);





__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["a" /* render */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_1__App_App__["a" /* default */], null), document.getElementById('root'));
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_emojione__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_emojione___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_emojione__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form_Form__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormInput_FormInput__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormSubmit_FormSubmit__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PullRequestList_PullRequestList__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PullRequestListItem_PullRequestListItem__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ResultBox_ResultBox__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ErrorMessage_ErrorMessage__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_motivation__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_errors__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__App_css__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__App_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var API_URL = 'https://api.github.com/search/issues';

var NUMBER_OF_PULL_REQUESTS_NEEDED = 4;

var App = function (_Component) {
  _inherits(App, _Component);

  function App() {
    _classCallCheck(this, App);

    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this));

    _this.state = {
      username: '',
      isLoading: false,
      error: null,
      pullRequests: [],
      motivation: ''
    };
    return _this;
  }

  _createClass(App, [{
    key: 'onInputChange',
    value: function onInputChange(e) {
      if (e.key === 'Enter') {
        this.getPullRequests();
        return;
      }

      this.setState({ username: e.target.value });
    }
  }, {
    key: 'getPullRequests',
    value: function getPullRequests() {
      var _this2 = this;

      this.setState({
        isLoading: true,
        error: null,
        complete: false,
        pullRequests: []
      });

      var year = new Date().getFullYear();
      var queryParams = {
        type: 'pr', // filter results to pull requests,
        q: 'is:pr author:' + this.state.username + ' is:public created:' + year + '-10-01..' + year + '-10-31 sort:created-desc'
      };

      fetch(API_URL + '?' + __WEBPACK_IMPORTED_MODULE_2_query_string___default.a.stringify(queryParams), { cache: 'default' }).then(function (response) {
        _this2.setState({ isLoading: false });

        if (!response.ok) {
          switch (response.status) {
            case 422:
              throw new __WEBPACK_IMPORTED_MODULE_11__utils_errors__["a" /* UserNotFoundError */](_this2.state.username);
            default:
              throw new __WEBPACK_IMPORTED_MODULE_11__utils_errors__["b" /* GitHubAPIError */]();
          }
        }

        return response.json();
      }).then(function (data) {
        var prsToSave = data.items.slice(0, NUMBER_OF_PULL_REQUESTS_NEEDED);

        _this2.setState({
          pullRequests: prsToSave,
          complete: true,
          motivation: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_motivation__["a" /* getMotivationMessage */])(prsToSave.length)
        });
      }).catch(function (err) {
        _this2.setState({ error: err.message });
        console.error(err);
      });
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      e.preventDefault();

      this.getPullRequests();
    }
  }, {
    key: 'render',
    value: function render() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'App' },
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'div',
          { className: 'App__inner' },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
            'h1',
            { className: 'App__title' },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
              __WEBPACK_IMPORTED_MODULE_1_react_emojione___default.a,
              { style: { width: 64, height: 64 } },
              ':jack_o_lantern:'
            ),
            'Hacktobercount'
          ),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
            'p',
            { className: 'App__lead' },
            'Check your Hacktoberfest progress easily.'
          ),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
            __WEBPACK_IMPORTED_MODULE_3__Form_Form__["a" /* default */],
            { className: 'Form', onSubmit: this.handleSubmit.bind(this) },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
              'p',
              { className: 'Form__instruction' },
              'Just insert your GitHub username in this input and press enter to fetch your PR count in October.'
            ),
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_4__FormInput_FormInput__["a" /* default */], { onKeyUp: this.onInputChange.bind(this), value: this.state.username }),
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_5__FormSubmit_FormSubmit__["a" /* default */], { text: 'Let\'s see!',
              onClick: this.handleSubmit.bind(this),
              disabled: this.state.isLoading || this.state.username.length < 1 })
          ),
          this.state.error ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
            __WEBPACK_IMPORTED_MODULE_9__ErrorMessage_ErrorMessage__["a" /* default */],
            null,
            this.state.error
          ) : null,
          this.state.complete ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
            'div',
            null,
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_8__ResultBox_ResultBox__["a" /* default */], { count: this.state.pullRequests.length, needed: NUMBER_OF_PULL_REQUESTS_NEEDED, motivation: this.state.motivation }),
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
              __WEBPACK_IMPORTED_MODULE_6__PullRequestList_PullRequestList__["a" /* default */],
              null,
              this.state.pullRequests.map(function (pullRequest) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_7__PullRequestListItem_PullRequestListItem__["a" /* default */], pullRequest);
              })
            )
          ) : null
        ),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'div',
          { className: 'App__footer' },
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
            'span',
            { className: 'App__footer__block' },
            'This website is in no way related to or associated with DigitalOcean or GitHub.'
          ),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
            'span',
            { className: 'App__footer__block' },
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
              'a',
              { href: 'https://hacktoberfest.digitalocean.com/', target: '_blank', rel: 'noopener noreferrer' },
              'What is Hacktoberfest?'
            )
          ),
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
            'span',
            { className: 'App__footer__block' },
            'Made with ',
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
              'span',
              { role: 'img', 'aria-label': 'love' },
              '\u2764'
            ),
            '\uFE0F (and Preact) by ',
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
              'a',
              { href: 'https://github.com/wolfika/', target: '_blank', rel: 'noopener noreferrer' },
              'M\xE1t\xE9 Farkas'
            ),
            '.'
          )
        )
      );
    }
  }]);

  return App;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* Component */]);

/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ErrorMessage_css__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ErrorMessage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ErrorMessage_css__);



/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    'div',
    { className: 'ErrorMessage' },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'span',
      { className: 'ErrorMessage__message' },
      props.children
    )
  );
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form_css__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Form_css__);



/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    'form',
    { className: 'Form', onSubmit: props.onSubmit },
    props.children
  );
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormInput_css__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormInput_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__FormInput_css__);



/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('input', { className: 'FormInput',
    type: 'text',
    placeholder: 'johndoe',
    title: 'GitHub username',
    'aria-label': 'GitHub username',
    required: true,
    autofocus: true,
    value: props.value,
    onKeyUp: props.onKeyUp });
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormSubmit_css__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormSubmit_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__FormSubmit_css__);



/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    'button',
    { className: 'FormSubmit', type: 'submit', onClick: props.onClick, disabled: props.disabled },
    props.text
  );
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PullRequestList_css__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PullRequestList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__PullRequestList_css__);



/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    'ul',
    { className: 'PullRequestList' },
    props.children
  );
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_emojione__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_emojione___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_emojione__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PullRequestListItem_css__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PullRequestListItem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PullRequestListItem_css__);




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    'li',
    { className: 'PullRequestListItem' },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { className: 'PullRequestListItem__emoji' },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        __WEBPACK_IMPORTED_MODULE_1_react_emojione___default.a,
        { style: { width: 32, height: 32 } },
        ':white_check_mark:'
      )
    ),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { className: 'PullRequestListItem__text' },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'a',
        { href: props.html_url,
          target: '_blank',
          rel: 'noopener noreferrer' },
        props.title
      )
    )
  );
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_emojione__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_emojione___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_emojione__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResultBox_css__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ResultBox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ResultBox_css__);




/* harmony default export */ __webpack_exports__["a"] = (function (props) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    'div',
    { className: 'ResultBox' },
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'span',
      { className: 'ResultBox__title' },
      'Your Hacktoberfest progress is:'
    ),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'span',
      { className: 'ResultBox__count' },
      props.count,
      '/',
      props.needed
    ),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'span',
      { className: 'ResultBox__motivation' },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        __WEBPACK_IMPORTED_MODULE_1_react_emojione___default.a,
        null,
        props.motivation
      )
    )
  );
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.

// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.

function register() {
  if ("production" === 'production' && 'serviceWorker' in navigator) {
    window.addEventListener('load', function () {
      var swUrl = "/hacktobercount" + '/service-worker.js';
      navigator.serviceWorker.register(swUrl).then(function (registration) {
        registration.onupdatefound = function () {
          var installingWorker = registration.installing;
          installingWorker.onstatechange = function () {
            if (installingWorker.state === 'installed') {
              if (navigator.serviceWorker.controller) {
                // At this point, the old content will have been purged and
                // the fresh content will have been added to the cache.
                // It's the perfect time to display a "New content is
                // available; please refresh." message in your web app.
                console.log('New content is available; please refresh.');
              } else {
                // At this point, everything has been precached.
                // It's the perfect time to display a
                // "Content is cached for offline use." message.
                console.log('Content is cached for offline use.');
              }
            }
          };
        };
      }).catch(function (error) {
        console.error('Error during service worker registration:', error);
      });
    });
  }
}

function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(function (registration) {
      registration.unregister();
    });
  }
}

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserNotFoundError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GitHubAPIError; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserNotFoundError = function (_Error) {
  _inherits(UserNotFoundError, _Error);

  function UserNotFoundError(username) {
    _classCallCheck(this, UserNotFoundError);

    var _this = _possibleConstructorReturn(this, (UserNotFoundError.__proto__ || Object.getPrototypeOf(UserNotFoundError)).call(this));

    _this.name = 'UserNotFoundError';
    _this.message = 'No user could be found on GitHub using the provided username ' + username + '.';
    _this.username = username;
    return _this;
  }

  return UserNotFoundError;
}(Error);

var GitHubAPIError = function (_Error2) {
  _inherits(GitHubAPIError, _Error2);

  function GitHubAPIError() {
    _classCallCheck(this, GitHubAPIError);

    var _this2 = _possibleConstructorReturn(this, (GitHubAPIError.__proto__ || Object.getPrototypeOf(GitHubAPIError)).call(this));

    _this2.name = 'GitHubAPIError';
    _this2.message = 'There was an error talking to GitHub API. Please try again later.';
    return _this2;
  }

  return GitHubAPIError;
}(Error);

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMotivationMessage; });
var messages = {
  0: ['Not lookin\' so good yet, but you have time, right?', 'Go ahead, make your first PR!', 'You can do better!', 'They say it\'s never too late to start!'],
  1: ['That wasn\'t so hard after all, was it?', 'That\'s right. It\'s 20% progress already.', 'Wonderful! Keep bustin\' those issues!', 'Hope you enjoyed that one. Go ahead!'],
  2: [':pray: You\'re doing great, keep going!', ':pray: Nice job, 3 more left.', ':pray: 2 done, 3 to go!'],
  3: [':sunglasses: Just two more!', ':sunglasses: You ain\'t gonna stop now, huh?', ':sunglasses: Two more, come on!', ':sunglasses: 3 done, lovely!'],
  4: [':raised_hands: Just one more!', ':raised_hands: Squeeze that last one out!', ':raised_hands: Finish line, don\'t stop now!', ':raised_hands: Keep going!'],
  5: [':checkered_flag: Wow! You made it! Nice job, mate!', ':checkered_flag: Congrats! You have beaten Hacktoberfest!', ':checkered_flag: Done! Now sit back and wait for those stickers to arrive.', ':checkered_flag: Coolio! You did all 5 PRs. Grab a beer and celebrate!']
};

var getMotivationMessage = function getMotivationMessage(count) {

  if (count < 0 || count > 5) {
    return 'Ayy, something\'s wrong.';
  }

  return messages[count][Math.floor(Math.random() * messages[count].length)];
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 25 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 26 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 27 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 28 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 29 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 32 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(5);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._61);
  p._81 = 1;
  p._65 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._81 === 3) {
            val = val._65;
          }
          if (val._81 === 1) return res(i, val._65);
          if (val._81 === 2) reject(val._65);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(5);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._10 = null;
  Promise._97 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._10 = function (promise) {
    if (
      promise._81 === 2 && // IS REJECTED
      rejections[promise._72]
    ) {
      if (rejections[promise._72].logged) {
        onHandled(promise._72);
      } else {
        clearTimeout(rejections[promise._72].timeout);
      }
      delete rejections[promise._72];
    }
  };
  Promise._97 = function (promise, err) {
    if (promise._45 === 0) { // not yet handled
      promise._72 = id++;
      rejections[promise._72] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._72),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(30);
var invariant = __webpack_require__(31);
var ReactPropTypesSecret = __webpack_require__(37);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(35)();
}


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(47);
var objectAssign = __webpack_require__(3);
var decodeComponent = __webpack_require__(20);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeComponent(val);

		formatter(decodeComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Ascii smiley to unicode table
 *
 * The order is important! O:) must be before :)
 */
exports.default = [
// angry
['>?:-?\\[', '😡'], // >:[ >:-[ :[ :-[
['>:-?\\(', '😠'], // >:( >:-(
['\\]:-?[\\/]', '👿'], // ]:\ ]:/ ]:-\ ]:-/
// sweat
['-_+-[uU]', '😓'], // -_-u -__-u ...
["':-?\\|", '😓'], // ':| ':-|
["':-?\\[", '😰'], // ':[ ':-[
["':-?\\(", '😥'], // ':( ':-(
["':-?\\)", '😅'], // ':) ':-)
['\\^_*\\^[uU]', '😅'], // ^_^u ^__^U ...
["'=-?\\)", '😅'], // '=) '=-)
// cool
['B-?\\)', '😎'], // B) B-)
[']:-?\\)', '😈'], [':-?,', '😏'], // :, :-,
['[oO]:-?\\)', '😇'], // o:) O:) o:-) ...
// happy
[':-?\\)', '🙂'], // :) :-)
[':-?D', '😃'], // :D :-D
['=-?\\)', '😊'], // =) =-)
[':-?>', '😁'], // :> :->
['[xX]-?DD+', '😂'], // xDDD x-DDD
['[xX]-?D', '😆'], // xD x-D
['[xX]\'D', '😂'], // x'D
['\\^_*\\^', '😄'], // ^^ ^_^ ^__^ ...
// sad
[':-?\\(', '🙁'], // :( :-(
// wink
[';-?\\)', '😉'], // ;) ;-)
// tonge
[':-?[pPÞþ]', '😛'], // :p :P :Þ :þ :-p :-P :-Þ :-þ
[';-?[pPÞþ]', '😜'], // ;p ;P ;Þ ;þ ;-p ;-P ;-Þ ;-þ
['[:;]-?[d]', '😋'], // :d :-d ;d ;-d
['[xX]-[pPÞþd]', '😝'], // x-p X-P
// love
['<3', '❤'], // <3
['<[\\\\/]3', '💔'], // <\3 </3
['=-?\\*', '😙'], //  =* =-*
[';-?\\*+', '😘'], // ;* ;-* ;** ;-** ...
[':-?\\*\\*+', '😘'], // :* :-*
[':-?\\*+', '😗'], // :* :-*
// cry
['[:;=][\'_]-?\\(', '😢'], ['[xX][\'_]-?\\(', '😭'], ['T_+T', '😭'], // T_T T__T ...
// confused / surprise
[':-?[sS]', '😖'], // :s :-s :S :-S
[':-?[oO]', '😮'], // :o :O :-o :-O
// sleep
['-_+-[zZ]+', '😪'], // -_-zZz ...
['u_+u[zZ]+', '😴'], // u_uzZz ...
// scared
['D-?:', '😦'], // D: D-:
[':-?[cC]', '😦'], // :c :-c :C :-C
['D-X', '😫'], // D-X
['[x]_+[xX]', '😲'], // x_x x__x ...
['[X]_+[xX]', '😵'], // X_X X__X ...
['[oO]_+[oO]', '😱'], // o_o o__O O___O ...
// misc
['-_+-', '😑'], // -_- -__- -___- ...
[':-?\\\\', '😕'], // :\ :-\
[':-?/(?!\\/)', '😕'], // :/ :-/
[':-?\\|', '😐'], // :| :-|
['[uv]_+[uv]', '😔'], // u_u v_v u__u v___v ...
['[xX]-?\\(', '😣'], // x( x-( X( X-(
['¬_*¬', '😒'] // ¬¬ ¬_¬ ¬__¬ ...
];

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*eslint-disable*/
// Do not edit!
// This file was auto-generated by create-emoji-data.js
exports.default = [["1f468-1f469-1f466-1f466", "👨👩👦👦", ":family_mwbb:"], ["1f469-1f469-1f467-1f467", "👩👩👧👧", ":family_wwgg:"], ["1f469-1f469-1f466-1f466", "👩👩👦👦", ":family_wwbb:"], ["1f469-1f469-1f467-1f466", "👩👩👧👦", ":family_wwgb:"], ["1f468-1f469-1f467-1f466", "👨👩👧👦", ":family_mwgb:"], ["1f468-1f468-1f466-1f466", "👨👨👦👦", ":family_mmbb:"], ["1f468-1f469-1f467-1f467", "👨👩👧👧", ":family_mwgg:"], ["1f468-1f468-1f467-1f466", "👨👨👧👦", ":family_mmgb:"], ["1f468-1f468-1f467-1f467", "👨👨👧👧", ":family_mmgg:"], ["1f468-2764-1f48b-1f468", "👨❤💋👨", ":kiss_mm:"], ["1f469-2764-1f48b-1f469", "👩❤💋👩", ":kiss_ww:"], ["1f468-1f468-1f466", "👨👨👦", ":family_mmb:"], ["1f468-1f469-1f467", "👨👩👧", ":family_mwg:"], ["1f468-1f468-1f467", "👨👨👧", ":family_mmg:"], ["1f469-1f469-1f466", "👩👩👦", ":family_wwb:"], ["1f469-1f469-1f467", "👩👩👧", ":family_wwg:"], ["1f469-2764-1f469", "👩❤👩", ":couple_ww:"], ["1f468-2764-1f468", "👨❤👨", ":couple_mm:"], ["1f44e-1f3fc", "👎🏼", ":thumbsdown_tone2:"], ["1f469-1f3fe", "👩🏾", ":woman_tone4:"], ["1f469-1f3ff", "👩🏿", ":woman_tone5:"], ["1f474-1f3fb", "👴🏻", ":older_man_tone1:"], ["1f474-1f3fc", "👴🏼", ":older_man_tone2:"], ["1f474-1f3fd", "👴🏽", ":older_man_tone3:"], ["1f474-1f3fe", "👴🏾", ":older_man_tone4:"], ["1f474-1f3ff", "👴🏿", ":older_man_tone5:"], ["1f475-1f3fb", "👵🏻", ":older_woman_tone1:"], ["1f475-1f3fc", "👵🏼", ":older_woman_tone2:"], ["1f475-1f3fd", "👵🏽", ":older_woman_tone3:"], ["1f475-1f3fe", "👵🏾", ":older_woman_tone4:"], ["1f475-1f3ff", "👵🏿", ":older_woman_tone5:"], ["1f476-1f3fb", "👶🏻", ":baby_tone1:"], ["1f476-1f3fc", "👶🏼", ":baby_tone2:"], ["1f476-1f3fd", "👶🏽", ":baby_tone3:"], ["1f476-1f3fe", "👶🏾", ":baby_tone4:"], ["1f476-1f3ff", "👶🏿", ":baby_tone5:"], ["1f47c-1f3fb", "👼🏻", ":angel_tone1:"], ["1f47c-1f3fc", "👼🏼", ":angel_tone2:"], ["1f47c-1f3fd", "👼🏽", ":angel_tone3:"], ["1f47c-1f3fe", "👼🏾", ":angel_tone4:"], ["1f47c-1f3ff", "👼🏿", ":angel_tone5:"], ["1f46e-1f3fb", "👮🏻", ":cop_tone1:"], ["1f46e-1f3fc", "👮🏼", ":cop_tone2:"], ["1f46e-1f3fd", "👮🏽", ":cop_tone3:"], ["1f46e-1f3fe", "👮🏾", ":cop_tone4:"], ["1f46e-1f3ff", "👮🏿", ":cop_tone5:"], ["1f575-1f3fb", "🕵🏻", ":spy_tone1:"], ["1f575-1f3fc", "🕵🏼", ":spy_tone2:"], ["1f575-1f3fd", "🕵🏽", ":spy_tone3:"], ["1f575-1f3fe", "🕵🏾", ":spy_tone4:"], ["1f575-1f3ff", "🕵🏿", ":spy_tone5:"], ["1f482-1f3fb", "💂🏻", ":guardsman_tone1:"], ["1f482-1f3fc", "💂🏼", ":guardsman_tone2:"], ["1f482-1f3fd", "💂🏽", ":guardsman_tone3:"], ["1f482-1f3fe", "💂🏾", ":guardsman_tone4:"], ["1f482-1f3ff", "💂🏿", ":guardsman_tone5:"], ["1f477-1f3fb", "👷🏻", ":construction_worker_tone1:"], ["1f477-1f3fc", "👷🏼", ":construction_worker_tone2:"], ["1f477-1f3fd", "👷🏽", ":construction_worker_tone3:"], ["1f477-1f3fe", "👷🏾", ":construction_worker_tone4:"], ["1f477-1f3ff", "👷🏿", ":construction_worker_tone5:"], ["1f473-1f3fb", "👳🏻", ":man_with_turban_tone1:"], ["1f473-1f3fc", "👳🏼", ":man_with_turban_tone2:"], ["1f473-1f3fd", "👳🏽", ":man_with_turban_tone3:"], ["1f473-1f3fe", "👳🏾", ":man_with_turban_tone4:"], ["1f473-1f3ff", "👳🏿", ":man_with_turban_tone5:"], ["1f471-1f3fb", "👱🏻", ":person_with_blond_hair_tone1:"], ["1f471-1f3fc", "👱🏼", ":person_with_blond_hair_tone2:"], ["1f471-1f3fd", "👱🏽", ":person_with_blond_hair_tone3:"], ["1f471-1f3fe", "👱🏾", ":person_with_blond_hair_tone4:"], ["1f471-1f3ff", "👱🏿", ":person_with_blond_hair_tone5:"], ["1f385-1f3fb", "🎅🏻", ":santa_tone1:"], ["1f385-1f3fc", "🎅🏼", ":santa_tone2:"], ["1f385-1f3fd", "🎅🏽", ":santa_tone3:"], ["1f385-1f3fe", "🎅🏾", ":santa_tone4:"], ["1f385-1f3ff", "🎅🏿", ":santa_tone5:"], ["1f936-1f3fb", "🤶🏻", ":mrs_claus_tone1:"], ["1f936-1f3fc", "🤶🏼", ":mrs_claus_tone2:"], ["1f936-1f3fd", "🤶🏽", ":mrs_claus_tone3:"], ["1f936-1f3fe", "🤶🏾", ":mrs_claus_tone4:"], ["1f936-1f3ff", "🤶🏿", ":mrs_claus_tone5:"], ["1f478-1f3fb", "👸🏻", ":princess_tone1:"], ["1f478-1f3fc", "👸🏼", ":princess_tone2:"], ["1f478-1f3fd", "👸🏽", ":princess_tone3:"], ["1f478-1f3fe", "👸🏾", ":princess_tone4:"], ["1f478-1f3ff", "👸🏿", ":princess_tone5:"], ["1f934-1f3fb", "🤴🏻", ":prince_tone1:"], ["1f934-1f3fc", "🤴🏼", ":prince_tone2:"], ["1f934-1f3fd", "🤴🏽", ":prince_tone3:"], ["1f934-1f3fe", "🤴🏾", ":prince_tone4:"], ["1f934-1f3ff", "🤴🏿", ":prince_tone5:"], ["1f470-1f3fb", "👰🏻", ":bride_with_veil_tone1:"], ["1f470-1f3fc", "👰🏼", ":bride_with_veil_tone2:"], ["1f470-1f3fd", "👰🏽", ":bride_with_veil_tone3:"], ["1f470-1f3fe", "👰🏾", ":bride_with_veil_tone4:"], ["1f470-1f3ff", "👰🏿", ":bride_with_veil_tone5:"], ["1f935-1f3fb", "🤵🏻", ":man_in_tuxedo_tone1:"], ["1f935-1f3fc", "🤵🏼", ":man_in_tuxedo_tone2:"], ["1f935-1f3fd", "🤵🏽", ":man_in_tuxedo_tone3:"], ["1f935-1f3fe", "🤵🏾", ":man_in_tuxedo_tone4:"], ["1f935-1f3ff", "🤵🏿", ":man_in_tuxedo_tone5:"], ["1f930-1f3fb", "🤰🏻", ":pregnant_woman_tone1:"], ["1f930-1f3fc", "🤰🏼", ":pregnant_woman_tone2:"], ["1f930-1f3fd", "🤰🏽", ":pregnant_woman_tone3:"], ["1f930-1f3fe", "🤰🏾", ":pregnant_woman_tone4:"], ["1f930-1f3ff", "🤰🏿", ":pregnant_woman_tone5:"], ["1f472-1f3fb", "👲🏻", ":man_with_gua_pi_mao_tone1:"], ["1f472-1f3fc", "👲🏼", ":man_with_gua_pi_mao_tone2:"], ["1f472-1f3fd", "👲🏽", ":man_with_gua_pi_mao_tone3:"], ["1f472-1f3fe", "👲🏾", ":man_with_gua_pi_mao_tone4:"], ["1f472-1f3ff", "👲🏿", ":man_with_gua_pi_mao_tone5:"], ["1f64d-1f3fb", "🙍🏻", ":person_frowning_tone1:"], ["1f64d-1f3fc", "🙍🏼", ":person_frowning_tone2:"], ["1f64d-1f3fd", "🙍🏽", ":person_frowning_tone3:"], ["1f64d-1f3fe", "🙍🏾", ":person_frowning_tone4:"], ["1f64d-1f3ff", "🙍🏿", ":person_frowning_tone5:"], ["1f64e-1f3fb", "🙎🏻", ":person_with_pouting_face_tone1:"], ["1f64e-1f3fc", "🙎🏼", ":person_with_pouting_face_tone2:"], ["1f64e-1f3fd", "🙎🏽", ":person_with_pouting_face_tone3:"], ["1f64e-1f3fe", "🙎🏾", ":person_with_pouting_face_tone4:"], ["1f64e-1f3ff", "🙎🏿", ":person_with_pouting_face_tone5:"], ["1f645-1f3fb", "🙅🏻", ":no_good_tone1:"], ["1f645-1f3fc", "🙅🏼", ":no_good_tone2:"], ["1f645-1f3fd", "🙅🏽", ":no_good_tone3:"], ["1f645-1f3fe", "🙅🏾", ":no_good_tone4:"], ["1f645-1f3ff", "🙅🏿", ":no_good_tone5:"], ["1f646-1f3fb", "🙆🏻", ":ok_woman_tone1:"], ["1f646-1f3fc", "🙆🏼", ":ok_woman_tone2:"], ["1f646-1f3fd", "🙆🏽", ":ok_woman_tone3:"], ["1f646-1f3fe", "🙆🏾", ":ok_woman_tone4:"], ["1f646-1f3ff", "🙆🏿", ":ok_woman_tone5:"], ["1f481-1f3fb", "💁🏻", ":information_desk_person_tone1:"], ["1f481-1f3fc", "💁🏼", ":information_desk_person_tone2:"], ["1f481-1f3fd", "💁🏽", ":information_desk_person_tone3:"], ["1f481-1f3fe", "💁🏾", ":information_desk_person_tone4:"], ["1f481-1f3ff", "💁🏿", ":information_desk_person_tone5:"], ["1f64b-1f3fb", "🙋🏻", ":raising_hand_tone1:"], ["1f64b-1f3fc", "🙋🏼", ":raising_hand_tone2:"], ["1f64b-1f3fd", "🙋🏽", ":raising_hand_tone3:"], ["1f64b-1f3fe", "🙋🏾", ":raising_hand_tone4:"], ["1f64b-1f3ff", "🙋🏿", ":raising_hand_tone5:"], ["1f647-1f3fb", "🙇🏻", ":bow_tone1:"], ["1f647-1f3fc", "🙇🏼", ":bow_tone2:"], ["1f647-1f3fd", "🙇🏽", ":bow_tone3:"], ["1f647-1f3fe", "🙇🏾", ":bow_tone4:"], ["1f647-1f3ff", "🙇🏿", ":bow_tone5:"], ["1f926-1f3fb", "🤦🏻", ":face_palm_tone1:"], ["1f926-1f3fc", "🤦🏼", ":face_palm_tone2:"], ["1f926-1f3fd", "🤦🏽", ":face_palm_tone3:"], ["1f926-1f3fe", "🤦🏾", ":face_palm_tone4:"], ["1f926-1f3ff", "🤦🏿", ":face_palm_tone5:"], ["1f937-1f3fb", "🤷🏻", ":shrug_tone1:"], ["1f937-1f3fc", "🤷🏼", ":shrug_tone2:"], ["1f937-1f3fd", "🤷🏽", ":shrug_tone3:"], ["1f937-1f3fe", "🤷🏾", ":shrug_tone4:"], ["1f937-1f3ff", "🤷🏿", ":shrug_tone5:"], ["1f486-1f3fb", "💆🏻", ":massage_tone1:"], ["1f486-1f3fc", "💆🏼", ":massage_tone2:"], ["1f486-1f3fd", "💆🏽", ":massage_tone3:"], ["1f486-1f3fe", "💆🏾", ":massage_tone4:"], ["1f486-1f3ff", "💆🏿", ":massage_tone5:"], ["1f487-1f3fb", "💇🏻", ":haircut_tone1:"], ["1f487-1f3fc", "💇🏼", ":haircut_tone2:"], ["1f487-1f3fd", "💇🏽", ":haircut_tone3:"], ["1f487-1f3fe", "💇🏾", ":haircut_tone4:"], ["1f487-1f3ff", "💇🏿", ":haircut_tone5:"], ["1f6b6-1f3fb", "🚶🏻", ":walking_tone1:"], ["1f6b6-1f3fc", "🚶🏼", ":walking_tone2:"], ["1f6b6-1f3fd", "🚶🏽", ":walking_tone3:"], ["1f6b6-1f3fe", "🚶🏾", ":walking_tone4:"], ["1f6b6-1f3ff", "🚶🏿", ":walking_tone5:"], ["1f3c3-1f3fb", "🏃🏻", ":runner_tone1:"], ["1f3c3-1f3fc", "🏃🏼", ":runner_tone2:"], ["1f3c3-1f3fd", "🏃🏽", ":runner_tone3:"], ["1f3c3-1f3fe", "🏃🏾", ":runner_tone4:"], ["1f3c3-1f3ff", "🏃🏿", ":runner_tone5:"], ["1f483-1f3fb", "💃🏻", ":dancer_tone1:"], ["1f483-1f3fc", "💃🏼", ":dancer_tone2:"], ["1f483-1f3fd", "💃🏽", ":dancer_tone3:"], ["1f483-1f3fe", "💃🏾", ":dancer_tone4:"], ["1f483-1f3ff", "💃🏿", ":dancer_tone5:"], ["1f57a-1f3fb", "🕺🏻", ":man_dancing_tone1:"], ["1f57a-1f3fc", "🕺🏼", ":man_dancing_tone2:"], ["1f57a-1f3fd", "🕺🏽", ":man_dancing_tone3:"], ["1f57a-1f3fe", "🕺🏾", ":man_dancing_tone4:"], ["1f57a-1f3ff", "🕺🏿", ":man_dancing_tone5:"], ["1f3c7-1f3fb", "🏇🏻", ":horse_racing_tone1:"], ["1f3c7-1f3fc", "🏇🏼", ":horse_racing_tone2:"], ["1f3c7-1f3fd", "🏇🏽", ":horse_racing_tone3:"], ["1f3c7-1f3fe", "🏇🏾", ":horse_racing_tone4:"], ["1f3c7-1f3ff", "🏇🏿", ":horse_racing_tone5:"], ["1f3c4-1f3fb", "🏄🏻", ":surfer_tone1:"], ["1f3c4-1f3fc", "🏄🏼", ":surfer_tone2:"], ["1f3c4-1f3fd", "🏄🏽", ":surfer_tone3:"], ["1f3c4-1f3fe", "🏄🏾", ":surfer_tone4:"], ["1f3c4-1f3ff", "🏄🏿", ":surfer_tone5:"], ["1f6a3-1f3fb", "🚣🏻", ":rowboat_tone1:"], ["1f6a3-1f3fc", "🚣🏼", ":rowboat_tone2:"], ["1f6a3-1f3fd", "🚣🏽", ":rowboat_tone3:"], ["1f6a3-1f3fe", "🚣🏾", ":rowboat_tone4:"], ["1f6a3-1f3ff", "🚣🏿", ":rowboat_tone5:"], ["1f3ca-1f3fb", "🏊🏻", ":swimmer_tone1:"], ["1f3ca-1f3fc", "🏊🏼", ":swimmer_tone2:"], ["1f3ca-1f3fd", "🏊🏽", ":swimmer_tone3:"], ["1f3ca-1f3fe", "🏊🏾", ":swimmer_tone4:"], ["1f3ca-1f3ff", "🏊🏿", ":swimmer_tone5:"], ["1f1ef-1f1ea", "🇯🇪", ":flag_je:"], ["1f1ee-1f1f9", "🇮🇹", ":flag_it:"], ["1f1ee-1f1f8", "🇮🇸", ":flag_is:"], ["1f1ee-1f1f7", "🇮🇷", ":flag_ir:"], ["1f1ee-1f1f6", "🇮🇶", ":flag_iq:"], ["1f3cb-1f3fb", "🏋🏻", ":lifter_tone1:"], ["1f3cb-1f3fc", "🏋🏼", ":lifter_tone2:"], ["1f3cb-1f3fd", "🏋🏽", ":lifter_tone3:"], ["1f3cb-1f3fe", "🏋🏾", ":lifter_tone4:"], ["1f3cb-1f3ff", "🏋🏿", ":lifter_tone5:"], ["1f6b4-1f3fb", "🚴🏻", ":bicyclist_tone1:"], ["1f6b4-1f3fc", "🚴🏼", ":bicyclist_tone2:"], ["1f6b4-1f3fd", "🚴🏽", ":bicyclist_tone3:"], ["1f6b4-1f3fe", "🚴🏾", ":bicyclist_tone4:"], ["1f6b4-1f3ff", "🚴🏿", ":bicyclist_tone5:"], ["1f6b5-1f3fb", "🚵🏻", ":mountain_bicyclist_tone1:"], ["1f6b5-1f3fc", "🚵🏼", ":mountain_bicyclist_tone2:"], ["1f6b5-1f3fd", "🚵🏽", ":mountain_bicyclist_tone3:"], ["1f6b5-1f3fe", "🚵🏾", ":mountain_bicyclist_tone4:"], ["1f6b5-1f3ff", "🚵🏿", ":mountain_bicyclist_tone5:"], ["1f938-1f3fb", "🤸🏻", ":cartwheel_tone1:"], ["1f938-1f3fc", "🤸🏼", ":cartwheel_tone2:"], ["1f938-1f3fd", "🤸🏽", ":cartwheel_tone3:"], ["1f938-1f3fe", "🤸🏾", ":cartwheel_tone4:"], ["1f938-1f3ff", "🤸🏿", ":cartwheel_tone5:"], ["1f93c-1f3fb", "🤼🏻", ":wrestlers_tone1:"], ["1f93c-1f3fc", "🤼🏼", ":wrestlers_tone2:"], ["1f93c-1f3fd", "🤼🏽", ":wrestlers_tone3:"], ["1f93c-1f3fe", "🤼🏾", ":wrestlers_tone4:"], ["1f93c-1f3ff", "🤼🏿", ":wrestlers_tone5:"], ["1f93d-1f3fb", "🤽🏻", ":water_polo_tone1:"], ["1f93d-1f3fc", "🤽🏼", ":water_polo_tone2:"], ["1f93d-1f3fd", "🤽🏽", ":water_polo_tone3:"], ["1f93d-1f3fe", "🤽🏾", ":water_polo_tone4:"], ["1f93d-1f3ff", "🤽🏿", ":water_polo_tone5:"], ["1f93e-1f3fb", "🤾🏻", ":handball_tone1:"], ["1f93e-1f3fc", "🤾🏼", ":handball_tone2:"], ["1f93e-1f3fd", "🤾🏽", ":handball_tone3:"], ["1f93e-1f3fe", "🤾🏾", ":handball_tone4:"], ["1f93e-1f3ff", "🤾🏿", ":handball_tone5:"], ["1f939-1f3fb", "🤹🏻", ":juggling_tone1:"], ["1f939-1f3fc", "🤹🏼", ":juggling_tone2:"], ["1f939-1f3fd", "🤹🏽", ":juggling_tone3:"], ["1f939-1f3fe", "🤹🏾", ":juggling_tone4:"], ["1f939-1f3ff", "🤹🏿", ":juggling_tone5:"], ["1f1ef-1f1f2", "🇯🇲", ":flag_jm:"], ["1f466-1f3fc", "👦🏼", ":boy_tone2:"], ["1f466-1f3fd", "👦🏽", ":boy_tone3:"], ["1f466-1f3fe", "👦🏾", ":boy_tone4:"], ["1f466-1f3ff", "👦🏿", ":boy_tone5:"], ["1f467-1f3fb", "👧🏻", ":girl_tone1:"], ["1f467-1f3fc", "👧🏼", ":girl_tone2:"], ["1f467-1f3fd", "👧🏽", ":girl_tone3:"], ["1f467-1f3fe", "👧🏾", ":girl_tone4:"], ["1f467-1f3ff", "👧🏿", ":girl_tone5:"], ["1f468-1f3fb", "👨🏻", ":man_tone1:"], ["1f468-1f3fc", "👨🏼", ":man_tone2:"], ["1f468-1f3fd", "👨🏽", ":man_tone3:"], ["1f468-1f3fe", "👨🏾", ":man_tone4:"], ["1f468-1f3ff", "👨🏿", ":man_tone5:"], ["1f469-1f3fb", "👩🏻", ":woman_tone1:"], ["1f469-1f3fc", "👩🏼", ":woman_tone2:"], ["1f469-1f3fd", "👩🏽", ":woman_tone3:"], ["1f4aa-1f3fb", "💪🏻", ":muscle_tone1:"], ["1f4aa-1f3fc", "💪🏼", ":muscle_tone2:"], ["1f4aa-1f3fd", "💪🏽", ":muscle_tone3:"], ["1f4aa-1f3fe", "💪🏾", ":muscle_tone4:"], ["1f4aa-1f3ff", "💪🏿", ":muscle_tone5:"], ["1f933-1f3fb", "🤳🏻", ":selfie_tone1:"], ["1f933-1f3fc", "🤳🏼", ":selfie_tone2:"], ["1f933-1f3fd", "🤳🏽", ":selfie_tone3:"], ["1f933-1f3fe", "🤳🏾", ":selfie_tone4:"], ["1f933-1f3ff", "🤳🏿", ":selfie_tone5:"], ["1f448-1f3fb", "👈🏻", ":point_left_tone1:"], ["1f448-1f3fc", "👈🏼", ":point_left_tone2:"], ["1f448-1f3fd", "👈🏽", ":point_left_tone3:"], ["1f448-1f3fe", "👈🏾", ":point_left_tone4:"], ["1f448-1f3ff", "👈🏿", ":point_left_tone5:"], ["1f449-1f3fb", "👉🏻", ":point_right_tone1:"], ["1f449-1f3fc", "👉🏼", ":point_right_tone2:"], ["1f449-1f3fd", "👉🏽", ":point_right_tone3:"], ["1f449-1f3fe", "👉🏾", ":point_right_tone4:"], ["1f449-1f3ff", "👉🏿", ":point_right_tone5:"], ["1f1ee-1f1f4", "🇮🇴", ":flag_io:"], ["1f1ee-1f1f3", "🇮🇳", ":flag_in:"], ["1f1ee-1f1f2", "🇮🇲", ":flag_im:"], ["1f1ee-1f1f1", "🇮🇱", ":flag_il:"], ["1f1ee-1f1ea", "🇮🇪", ":flag_ie:"], ["1f446-1f3fb", "👆🏻", ":point_up_2_tone1:"], ["1f446-1f3fc", "👆🏼", ":point_up_2_tone2:"], ["1f446-1f3fd", "👆🏽", ":point_up_2_tone3:"], ["1f446-1f3fe", "👆🏾", ":point_up_2_tone4:"], ["1f446-1f3ff", "👆🏿", ":point_up_2_tone5:"], ["1f595-1f3fb", "🖕🏻", ":middle_finger_tone1:"], ["1f595-1f3fc", "🖕🏼", ":middle_finger_tone2:"], ["1f595-1f3fd", "🖕🏽", ":middle_finger_tone3:"], ["1f595-1f3fe", "🖕🏾", ":middle_finger_tone4:"], ["1f595-1f3ff", "🖕🏿", ":middle_finger_tone5:"], ["1f447-1f3fb", "👇🏻", ":point_down_tone1:"], ["1f447-1f3fc", "👇🏼", ":point_down_tone2:"], ["1f447-1f3fd", "👇🏽", ":point_down_tone3:"], ["1f447-1f3fe", "👇🏾", ":point_down_tone4:"], ["1f447-1f3ff", "👇🏿", ":point_down_tone5:"], ["1f1ee-1f1e9", "🇮🇩", ":flag_id:"], ["1f1ee-1f1e8", "🇮🇨", ":flag_ic:"], ["1f1ed-1f1fa", "🇭🇺", ":flag_hu:"], ["1f1ed-1f1f9", "🇭🇹", ":flag_ht:"], ["1f1ed-1f1f7", "🇭🇷", ":flag_hr:"], ["1f91e-1f3fb", "🤞🏻", ":fingers_crossed_tone1:"], ["1f91e-1f3fc", "🤞🏼", ":fingers_crossed_tone2:"], ["1f91e-1f3fd", "🤞🏽", ":fingers_crossed_tone3:"], ["1f91e-1f3fe", "🤞🏾", ":fingers_crossed_tone4:"], ["1f91e-1f3ff", "🤞🏿", ":fingers_crossed_tone5:"], ["1f596-1f3fb", "🖖🏻", ":vulcan_tone1:"], ["1f596-1f3fc", "🖖🏼", ":vulcan_tone2:"], ["1f596-1f3fd", "🖖🏽", ":vulcan_tone3:"], ["1f596-1f3fe", "🖖🏾", ":vulcan_tone4:"], ["1f596-1f3ff", "🖖🏿", ":vulcan_tone5:"], ["1f918-1f3fb", "🤘🏻", ":metal_tone1:"], ["1f918-1f3fc", "🤘🏼", ":metal_tone2:"], ["1f918-1f3fd", "🤘🏽", ":metal_tone3:"], ["1f918-1f3fe", "🤘🏾", ":metal_tone4:"], ["1f918-1f3ff", "🤘🏿", ":metal_tone5:"], ["1f919-1f3fb", "🤙🏻", ":call_me_tone1:"], ["1f919-1f3fc", "🤙🏼", ":call_me_tone2:"], ["1f919-1f3fd", "🤙🏽", ":call_me_tone3:"], ["1f919-1f3fe", "🤙🏾", ":call_me_tone4:"], ["1f919-1f3ff", "🤙🏿", ":call_me_tone5:"], ["1f590-1f3fb", "🖐🏻", ":hand_splayed_tone1:"], ["1f590-1f3fc", "🖐🏼", ":hand_splayed_tone2:"], ["1f590-1f3fd", "🖐🏽", ":hand_splayed_tone3:"], ["1f590-1f3fe", "🖐🏾", ":hand_splayed_tone4:"], ["1f590-1f3ff", "🖐🏿", ":hand_splayed_tone5:"], ["1f1ed-1f1f3", "🇭🇳", ":flag_hn:"], ["1f1ed-1f1f2", "🇭🇲", ":flag_hm:"], ["1f1ed-1f1f0", "🇭🇰", ":flag_hk:"], ["1f1ec-1f1fe", "🇬🇾", ":flag_gy:"], ["1f1ec-1f1fc", "🇬🇼", ":flag_gw:"], ["1f44c-1f3fb", "👌🏻", ":ok_hand_tone1:"], ["1f44c-1f3fc", "👌🏼", ":ok_hand_tone2:"], ["1f44c-1f3fd", "👌🏽", ":ok_hand_tone3:"], ["1f44c-1f3fe", "👌🏾", ":ok_hand_tone4:"], ["1f44c-1f3ff", "👌🏿", ":ok_hand_tone5:"], ["1f44d-1f3fb", "👍🏻", ":thumbsup_tone1:"], ["1f44d-1f3fc", "👍🏼", ":thumbsup_tone2:"], ["1f44d-1f3fd", "👍🏽", ":thumbsup_tone3:"], ["1f44d-1f3fe", "👍🏾", ":thumbsup_tone4:"], ["1f44d-1f3ff", "👍🏿", ":thumbsup_tone5:"], ["1f44e-1f3fb", "👎🏻", ":thumbsdown_tone1:"], ["1f466-1f3fb", "👦🏻", ":boy_tone1:"], ["1f44e-1f3fd", "👎🏽", ":thumbsdown_tone3:"], ["1f44e-1f3fe", "👎🏾", ":thumbsdown_tone4:"], ["1f44e-1f3ff", "👎🏿", ":thumbsdown_tone5:"], ["1f1ec-1f1fa", "🇬🇺", ":flag_gu:"], ["1f1ec-1f1f9", "🇬🇹", ":flag_gt:"], ["1f1ec-1f1f8", "🇬🇸", ":flag_gs:"], ["1f1ec-1f1f7", "🇬🇷", ":flag_gr:"], ["1f1ec-1f1f6", "🇬🇶", ":flag_gq:"], ["1f44a-1f3fb", "👊🏻", ":punch_tone1:"], ["1f44a-1f3fc", "👊🏼", ":punch_tone2:"], ["1f44a-1f3fd", "👊🏽", ":punch_tone3:"], ["1f44a-1f3fe", "👊🏾", ":punch_tone4:"], ["1f44a-1f3ff", "👊🏿", ":punch_tone5:"], ["1f91b-1f3fb", "🤛🏻", ":left_facing_fist_tone1:"], ["1f91b-1f3fc", "🤛🏼", ":left_facing_fist_tone2:"], ["1f91b-1f3fd", "🤛🏽", ":left_facing_fist_tone3:"], ["1f91b-1f3fe", "🤛🏾", ":left_facing_fist_tone4:"], ["1f91b-1f3ff", "🤛🏿", ":left_facing_fist_tone5:"], ["1f91c-1f3fb", "🤜🏻", ":right_facing_fist_tone1:"], ["1f91c-1f3fc", "🤜🏼", ":right_facing_fist_tone2:"], ["1f91c-1f3fd", "🤜🏽", ":right_facing_fist_tone3:"], ["1f91c-1f3fe", "🤜🏾", ":right_facing_fist_tone4:"], ["1f91c-1f3ff", "🤜🏿", ":right_facing_fist_tone5:"], ["1f91a-1f3fb", "🤚🏻", ":raised_back_of_hand_tone1:"], ["1f91a-1f3fc", "🤚🏼", ":raised_back_of_hand_tone2:"], ["1f91a-1f3fd", "🤚🏽", ":raised_back_of_hand_tone3:"], ["1f91a-1f3fe", "🤚🏾", ":raised_back_of_hand_tone4:"], ["1f91a-1f3ff", "🤚🏿", ":raised_back_of_hand_tone5:"], ["1f44b-1f3fb", "👋🏻", ":wave_tone1:"], ["1f44b-1f3fc", "👋🏼", ":wave_tone2:"], ["1f44b-1f3fd", "👋🏽", ":wave_tone3:"], ["1f44b-1f3fe", "👋🏾", ":wave_tone4:"], ["1f44b-1f3ff", "👋🏿", ":wave_tone5:"], ["1f44f-1f3fb", "👏🏻", ":clap_tone1:"], ["1f44f-1f3fc", "👏🏼", ":clap_tone2:"], ["1f44f-1f3fd", "👏🏽", ":clap_tone3:"], ["1f44f-1f3fe", "👏🏾", ":clap_tone4:"], ["1f44f-1f3ff", "👏🏿", ":clap_tone5:"], ["1f1ec-1f1f5", "🇬🇵", ":flag_gp:"], ["1f1ec-1f1f3", "🇬🇳", ":flag_gn:"], ["1f1ec-1f1f2", "🇬🇲", ":flag_gm:"], ["1f1ec-1f1f1", "🇬🇱", ":flag_gl:"], ["1f1ec-1f1ee", "🇬🇮", ":flag_gi:"], ["1f450-1f3fb", "👐🏻", ":open_hands_tone1:"], ["1f450-1f3fc", "👐🏼", ":open_hands_tone2:"], ["1f450-1f3fd", "👐🏽", ":open_hands_tone3:"], ["1f450-1f3fe", "👐🏾", ":open_hands_tone4:"], ["1f450-1f3ff", "👐🏿", ":open_hands_tone5:"], ["1f64c-1f3fb", "🙌🏻", ":raised_hands_tone1:"], ["1f64c-1f3fc", "🙌🏼", ":raised_hands_tone2:"], ["1f64c-1f3fd", "🙌🏽", ":raised_hands_tone3:"], ["1f64c-1f3fe", "🙌🏾", ":raised_hands_tone4:"], ["1f64c-1f3ff", "🙌🏿", ":raised_hands_tone5:"], ["1f64f-1f3fb", "🙏🏻", ":pray_tone1:"], ["1f64f-1f3fc", "🙏🏼", ":pray_tone2:"], ["1f64f-1f3fd", "🙏🏽", ":pray_tone3:"], ["1f64f-1f3fe", "🙏🏾", ":pray_tone4:"], ["1f64f-1f3ff", "🙏🏿", ":pray_tone5:"], ["1f91d-1f3fb", "🤝🏻", ":handshake_tone1:"], ["1f91d-1f3fc", "🤝🏼", ":handshake_tone2:"], ["1f91d-1f3fd", "🤝🏽", ":handshake_tone3:"], ["1f91d-1f3fe", "🤝🏾", ":handshake_tone4:"], ["1f91d-1f3ff", "🤝🏿", ":handshake_tone5:"], ["1f485-1f3fb", "💅🏻", ":nail_care_tone1:"], ["1f485-1f3fc", "💅🏼", ":nail_care_tone2:"], ["1f485-1f3fd", "💅🏽", ":nail_care_tone3:"], ["1f485-1f3fe", "💅🏾", ":nail_care_tone4:"], ["1f485-1f3ff", "💅🏿", ":nail_care_tone5:"], ["1f442-1f3fb", "👂🏻", ":ear_tone1:"], ["1f442-1f3fc", "👂🏼", ":ear_tone2:"], ["1f442-1f3fd", "👂🏽", ":ear_tone3:"], ["1f442-1f3fe", "👂🏾", ":ear_tone4:"], ["1f442-1f3ff", "👂🏿", ":ear_tone5:"], ["1f443-1f3fb", "👃🏻", ":nose_tone1:"], ["1f443-1f3fc", "👃🏼", ":nose_tone2:"], ["1f443-1f3fd", "👃🏽", ":nose_tone3:"], ["1f443-1f3fe", "👃🏾", ":nose_tone4:"], ["1f443-1f3ff", "👃🏿", ":nose_tone5:"], ["1f441-1f5e8", "👁🗨", ":eye_in_speech_bubble:"], ["1f1ff-1f1fc", "🇿🇼", ":flag_zw:"], ["1f6c0-1f3fb", "🛀🏻", ":bath_tone1:"], ["1f6c0-1f3fc", "🛀🏼", ":bath_tone2:"], ["1f6c0-1f3fd", "🛀🏽", ":bath_tone3:"], ["1f6c0-1f3fe", "🛀🏾", ":bath_tone4:"], ["1f6c0-1f3ff", "🛀🏿", ":bath_tone5:"], ["1f1ff-1f1f2", "🇿🇲", ":flag_zm:"], ["1f1ff-1f1e6", "🇿🇦", ":flag_za:"], ["1f1fe-1f1f9", "🇾🇹", ":flag_yt:"], ["1f1fe-1f1ea", "🇾🇪", ":flag_ye:"], ["1f1fd-1f1f0", "🇽🇰", ":flag_xk:"], ["1f1fc-1f1f8", "🇼🇸", ":flag_ws:"], ["1f1fc-1f1eb", "🇼🇫", ":flag_wf:"], ["1f1fb-1f1fa", "🇻🇺", ":flag_vu:"], ["1f1fb-1f1f3", "🇻🇳", ":flag_vn:"], ["1f1fb-1f1ee", "🇻🇮", ":flag_vi:"], ["1f1fb-1f1ec", "🇻🇬", ":flag_vg:"], ["1f1fb-1f1ea", "🇻🇪", ":flag_ve:"], ["1f1fb-1f1e8", "🇻🇨", ":flag_vc:"], ["1f1fb-1f1e6", "🇻🇦", ":flag_va:"], ["1f1fa-1f1ff", "🇺🇿", ":flag_uz:"], ["1f1fa-1f1fe", "🇺🇾", ":flag_uy:"], ["1f1fa-1f1f8", "🇺🇸", ":flag_us:"], ["1f1fa-1f1f2", "🇺🇲", ":flag_um:"], ["1f1fa-1f1ec", "🇺🇬", ":flag_ug:"], ["1f1fa-1f1e6", "🇺🇦", ":flag_ua:"], ["1f1f9-1f1ff", "🇹🇿", ":flag_tz:"], ["1f1f9-1f1fc", "🇹🇼", ":flag_tw:"], ["1f1f9-1f1fb", "🇹🇻", ":flag_tv:"], ["1f1f9-1f1f9", "🇹🇹", ":flag_tt:"], ["1f1f9-1f1f7", "🇹🇷", ":flag_tr:"], ["1f1f9-1f1f4", "🇹🇴", ":flag_to:"], ["1f1f9-1f1f3", "🇹🇳", ":flag_tn:"], ["1f1f9-1f1f2", "🇹🇲", ":flag_tm:"], ["1f1f9-1f1f1", "🇹🇱", ":flag_tl:"], ["1f1f9-1f1f0", "🇹🇰", ":flag_tk:"], ["1f1f9-1f1ef", "🇹🇯", ":flag_tj:"], ["1f1f9-1f1ed", "🇹🇭", ":flag_th:"], ["1f1f9-1f1ec", "🇹🇬", ":flag_tg:"], ["1f1f9-1f1eb", "🇹🇫", ":flag_tf:"], ["1f1f9-1f1e9", "🇹🇩", ":flag_td:"], ["1f1f9-1f1e8", "🇹🇨", ":flag_tc:"], ["1f1f9-1f1e6", "🇹🇦", ":flag_ta:"], ["1f1f8-1f1ff", "🇸🇿", ":flag_sz:"], ["1f1f8-1f1fe", "🇸🇾", ":flag_sy:"], ["1f1f8-1f1fd", "🇸🇽", ":flag_sx:"], ["1f1f8-1f1fb", "🇸🇻", ":flag_sv:"], ["1f1f8-1f1f9", "🇸🇹", ":flag_st:"], ["1f1f8-1f1f8", "🇸🇸", ":flag_ss:"], ["1f1f8-1f1f7", "🇸🇷", ":flag_sr:"], ["1f1f8-1f1f4", "🇸🇴", ":flag_so:"], ["1f1f8-1f1f3", "🇸🇳", ":flag_sn:"], ["1f1f8-1f1f2", "🇸🇲", ":flag_sm:"], ["1f1f8-1f1f1", "🇸🇱", ":flag_sl:"], ["1f1f8-1f1f0", "🇸🇰", ":flag_sk:"], ["1f1f8-1f1ef", "🇸🇯", ":flag_sj:"], ["1f1f8-1f1ee", "🇸🇮", ":flag_si:"], ["1f1f8-1f1ed", "🇸🇭", ":flag_sh:"], ["1f1f8-1f1ec", "🇸🇬", ":flag_sg:"], ["1f1f8-1f1ea", "🇸🇪", ":flag_se:"], ["1f1f8-1f1e9", "🇸🇩", ":flag_sd:"], ["1f1f8-1f1e8", "🇸🇨", ":flag_sc:"], ["1f1f8-1f1e7", "🇸🇧", ":flag_sb:"], ["1f1f8-1f1e6", "🇸🇦", ":flag_sa:"], ["1f1f7-1f1fc", "🇷🇼", ":flag_rw:"], ["1f1f7-1f1fa", "🇷🇺", ":flag_ru:"], ["1f1f7-1f1f8", "🇷🇸", ":flag_rs:"], ["1f1f7-1f1f4", "🇷🇴", ":flag_ro:"], ["1f1f7-1f1ea", "🇷🇪", ":flag_re:"], ["1f1f6-1f1e6", "🇶🇦", ":flag_qa:"], ["1f1f5-1f1fe", "🇵🇾", ":flag_py:"], ["1f1f5-1f1fc", "🇵🇼", ":flag_pw:"], ["1f1f5-1f1f9", "🇵🇹", ":flag_pt:"], ["1f1f5-1f1f8", "🇵🇸", ":flag_ps:"], ["1f1f5-1f1f7", "🇵🇷", ":flag_pr:"], ["1f1f5-1f1f3", "🇵🇳", ":flag_pn:"], ["1f1f5-1f1f2", "🇵🇲", ":flag_pm:"], ["1f1f5-1f1f1", "🇵🇱", ":flag_pl:"], ["1f1f5-1f1f0", "🇵🇰", ":flag_pk:"], ["1f1f5-1f1ed", "🇵🇭", ":flag_ph:"], ["1f1f5-1f1ec", "🇵🇬", ":flag_pg:"], ["1f1f5-1f1eb", "🇵🇫", ":flag_pf:"], ["1f1f5-1f1ea", "🇵🇪", ":flag_pe:"], ["1f1f5-1f1e6", "🇵🇦", ":flag_pa:"], ["1f1f4-1f1f2", "🇴🇲", ":flag_om:"], ["1f1f3-1f1ff", "🇳🇿", ":flag_nz:"], ["1f1f3-1f1fa", "🇳🇺", ":flag_nu:"], ["1f1f3-1f1f7", "🇳🇷", ":flag_nr:"], ["1f1f3-1f1f5", "🇳🇵", ":flag_np:"], ["1f1f3-1f1f4", "🇳🇴", ":flag_no:"], ["1f1f3-1f1f1", "🇳🇱", ":flag_nl:"], ["1f1f3-1f1ee", "🇳🇮", ":flag_ni:"], ["1f1f3-1f1ec", "🇳🇬", ":flag_ng:"], ["1f1f3-1f1eb", "🇳🇫", ":flag_nf:"], ["1f1f3-1f1ea", "🇳🇪", ":flag_ne:"], ["1f1f3-1f1e8", "🇳🇨", ":flag_nc:"], ["1f1f3-1f1e6", "🇳🇦", ":flag_na:"], ["1f1f2-1f1ff", "🇲🇿", ":flag_mz:"], ["1f1f2-1f1fe", "🇲🇾", ":flag_my:"], ["1f1f2-1f1fd", "🇲🇽", ":flag_mx:"], ["1f1f2-1f1fc", "🇲🇼", ":flag_mw:"], ["1f1f2-1f1fb", "🇲🇻", ":flag_mv:"], ["1f1f2-1f1fa", "🇲🇺", ":flag_mu:"], ["1f1f2-1f1f9", "🇲🇹", ":flag_mt:"], ["1f1f2-1f1f8", "🇲🇸", ":flag_ms:"], ["1f1f2-1f1f7", "🇲🇷", ":flag_mr:"], ["1f1f2-1f1f6", "🇲🇶", ":flag_mq:"], ["1f1f2-1f1f5", "🇲🇵", ":flag_mp:"], ["1f1f2-1f1f4", "🇲🇴", ":flag_mo:"], ["1f1f2-1f1f3", "🇲🇳", ":flag_mn:"], ["1f1f2-1f1f2", "🇲🇲", ":flag_mm:"], ["1f1f2-1f1f1", "🇲🇱", ":flag_ml:"], ["1f1f2-1f1f0", "🇲🇰", ":flag_mk:"], ["1f1f2-1f1ed", "🇲🇭", ":flag_mh:"], ["1f1f2-1f1ec", "🇲🇬", ":flag_mg:"], ["1f1f2-1f1eb", "🇲🇫", ":flag_mf:"], ["1f1f2-1f1ea", "🇲🇪", ":flag_me:"], ["1f1f2-1f1e9", "🇲🇩", ":flag_md:"], ["1f1f2-1f1e8", "🇲🇨", ":flag_mc:"], ["1f1f2-1f1e6", "🇲🇦", ":flag_ma:"], ["1f1f1-1f1fe", "🇱🇾", ":flag_ly:"], ["1f1f1-1f1fb", "🇱🇻", ":flag_lv:"], ["1f1f1-1f1fa", "🇱🇺", ":flag_lu:"], ["1f1f1-1f1f9", "🇱🇹", ":flag_lt:"], ["1f1f1-1f1f8", "🇱🇸", ":flag_ls:"], ["1f1f1-1f1f7", "🇱🇷", ":flag_lr:"], ["1f1f1-1f1f0", "🇱🇰", ":flag_lk:"], ["1f1f1-1f1ee", "🇱🇮", ":flag_li:"], ["1f1f1-1f1e8", "🇱🇨", ":flag_lc:"], ["1f1f1-1f1e7", "🇱🇧", ":flag_lb:"], ["1f1ec-1f1ed", "🇬🇭", ":flag_gh:"], ["1f1ec-1f1ec", "🇬🇬", ":flag_gg:"], ["1f1ec-1f1eb", "🇬🇫", ":flag_gf:"], ["1f1ec-1f1ea", "🇬🇪", ":flag_ge:"], ["1f1ec-1f1e9", "🇬🇩", ":flag_gd:"], ["1f1ec-1f1e7", "🇬🇧", ":flag_gb:"], ["1f1ec-1f1e6", "🇬🇦", ":flag_ga:"], ["1f1eb-1f1f7", "🇫🇷", ":flag_fr:"], ["1f1eb-1f1f4", "🇫🇴", ":flag_fo:"], ["1f1eb-1f1f2", "🇫🇲", ":flag_fm:"], ["1f1eb-1f1f0", "🇫🇰", ":flag_fk:"], ["1f1eb-1f1ef", "🇫🇯", ":flag_fj:"], ["1f1f1-1f1e6", "🇱🇦", ":flag_la:"], ["1f1f0-1f1ff", "🇰🇿", ":flag_kz:"], ["1f1f0-1f1fe", "🇰🇾", ":flag_ky:"], ["1f1f0-1f1fc", "🇰🇼", ":flag_kw:"], ["1f1f0-1f1f7", "🇰🇷", ":flag_kr:"], ["1f1f0-1f1f5", "🇰🇵", ":flag_kp:"], ["1f1f0-1f1f3", "🇰🇳", ":flag_kn:"], ["1f1f0-1f1f2", "🇰🇲", ":flag_km:"], ["1f1f0-1f1ee", "🇰🇮", ":flag_ki:"], ["1f1f0-1f1ed", "🇰🇭", ":flag_kh:"], ["1f1f0-1f1ec", "🇰🇬", ":flag_kg:"], ["1f1f0-1f1ea", "🇰🇪", ":flag_ke:"], ["1f1ef-1f1f5", "🇯🇵", ":flag_jp:"], ["1f1ef-1f1f4", "🇯🇴", ":flag_jo:"], ["1f3f3-1f308", "🏳🌈", ":rainbow_flag:"], ["1f1e6-1f1e8", "🇦🇨", ":flag_ac:"], ["1f1e6-1f1e9", "🇦🇩", ":flag_ad:"], ["1f1e6-1f1ea", "🇦🇪", ":flag_ae:"], ["1f1e6-1f1eb", "🇦🇫", ":flag_af:"], ["1f1e6-1f1ec", "🇦🇬", ":flag_ag:"], ["1f1e6-1f1ee", "🇦🇮", ":flag_ai:"], ["1f1e6-1f1f1", "🇦🇱", ":flag_al:"], ["1f1e6-1f1f2", "🇦🇲", ":flag_am:"], ["1f1e6-1f1f4", "🇦🇴", ":flag_ao:"], ["1f1e6-1f1f6", "🇦🇶", ":flag_aq:"], ["1f1e6-1f1f7", "🇦🇷", ":flag_ar:"], ["1f1e6-1f1f8", "🇦🇸", ":flag_as:"], ["1f1e6-1f1f9", "🇦🇹", ":flag_at:"], ["1f1e6-1f1fa", "🇦🇺", ":flag_au:"], ["1f1e6-1f1fc", "🇦🇼", ":flag_aw:"], ["1f1e6-1f1fd", "🇦🇽", ":flag_ax:"], ["1f1e6-1f1ff", "🇦🇿", ":flag_az:"], ["1f1e7-1f1e6", "🇧🇦", ":flag_ba:"], ["1f1e7-1f1e7", "🇧🇧", ":flag_bb:"], ["1f1e7-1f1e9", "🇧🇩", ":flag_bd:"], ["1f1e7-1f1ea", "🇧🇪", ":flag_be:"], ["1f1e7-1f1eb", "🇧🇫", ":flag_bf:"], ["1f1e7-1f1ec", "🇧🇬", ":flag_bg:"], ["1f1e7-1f1ed", "🇧🇭", ":flag_bh:"], ["1f1e7-1f1ee", "🇧🇮", ":flag_bi:"], ["1f1e7-1f1ef", "🇧🇯", ":flag_bj:"], ["1f1e7-1f1f1", "🇧🇱", ":flag_bl:"], ["1f1e7-1f1f2", "🇧🇲", ":flag_bm:"], ["1f1e7-1f1f3", "🇧🇳", ":flag_bn:"], ["1f1e7-1f1f4", "🇧🇴", ":flag_bo:"], ["1f1e7-1f1f6", "🇧🇶", ":flag_bq:"], ["1f1e7-1f1f7", "🇧🇷", ":flag_br:"], ["1f1e7-1f1f8", "🇧🇸", ":flag_bs:"], ["1f1e7-1f1f9", "🇧🇹", ":flag_bt:"], ["1f1e7-1f1fb", "🇧🇻", ":flag_bv:"], ["1f1e7-1f1fc", "🇧🇼", ":flag_bw:"], ["1f1e7-1f1fe", "🇧🇾", ":flag_by:"], ["1f1e7-1f1ff", "🇧🇿", ":flag_bz:"], ["1f1e8-1f1e6", "🇨🇦", ":flag_ca:"], ["1f1e8-1f1e8", "🇨🇨", ":flag_cc:"], ["1f1e8-1f1e9", "🇨🇩", ":flag_cd:"], ["1f1e8-1f1eb", "🇨🇫", ":flag_cf:"], ["1f1e8-1f1ec", "🇨🇬", ":flag_cg:"], ["1f1e8-1f1ed", "🇨🇭", ":flag_ch:"], ["1f1e8-1f1ee", "🇨🇮", ":flag_ci:"], ["1f1e8-1f1f0", "🇨🇰", ":flag_ck:"], ["1f1e8-1f1f1", "🇨🇱", ":flag_cl:"], ["1f1e8-1f1f2", "🇨🇲", ":flag_cm:"], ["1f1e8-1f1f3", "🇨🇳", ":flag_cn:"], ["1f1e8-1f1f4", "🇨🇴", ":flag_co:"], ["1f1e8-1f1f5", "🇨🇵", ":flag_cp:"], ["1f1e8-1f1f7", "🇨🇷", ":flag_cr:"], ["1f1e8-1f1fa", "🇨🇺", ":flag_cu:"], ["1f1e8-1f1fb", "🇨🇻", ":flag_cv:"], ["1f1e8-1f1fc", "🇨🇼", ":flag_cw:"], ["1f1e8-1f1fd", "🇨🇽", ":flag_cx:"], ["1f1e8-1f1fe", "🇨🇾", ":flag_cy:"], ["1f1e8-1f1ff", "🇨🇿", ":flag_cz:"], ["1f1e9-1f1ea", "🇩🇪", ":flag_de:"], ["1f1e9-1f1ec", "🇩🇬", ":flag_dg:"], ["1f1e9-1f1ef", "🇩🇯", ":flag_dj:"], ["1f1e9-1f1f0", "🇩🇰", ":flag_dk:"], ["1f1e9-1f1f2", "🇩🇲", ":flag_dm:"], ["1f1e9-1f1f4", "🇩🇴", ":flag_do:"], ["1f1e9-1f1ff", "🇩🇿", ":flag_dz:"], ["1f1ea-1f1e6", "🇪🇦", ":flag_ea:"], ["1f1ea-1f1e8", "🇪🇨", ":flag_ec:"], ["1f1ea-1f1ea", "🇪🇪", ":flag_ee:"], ["1f1ea-1f1ec", "🇪🇬", ":flag_eg:"], ["1f1ea-1f1ed", "🇪🇭", ":flag_eh:"], ["1f1ea-1f1f7", "🇪🇷", ":flag_er:"], ["1f1ea-1f1f8", "🇪🇸", ":flag_es:"], ["1f1ea-1f1f9", "🇪🇹", ":flag_et:"], ["1f1ea-1f1fa", "🇪🇺", ":flag_eu:"], ["1f1eb-1f1ee", "🇫🇮", ":flag_fi:"], ["270c-1f3ff", "✌🏿", ":v_tone5:"], ["270a-1f3fb", "✊🏻", ":fist_tone1:"], ["270d-1f3fe", "✍🏾", ":writing_hand_tone4:"], ["270d-1f3fd", "✍🏽", ":writing_hand_tone3:"], ["270d-1f3fc", "✍🏼", ":writing_hand_tone2:"], ["270d-1f3fb", "✍🏻", ":writing_hand_tone1:"], ["270a-1f3ff", "✊🏿", ":fist_tone5:"], ["270a-1f3fe", "✊🏾", ":fist_tone4:"], ["270a-1f3fd", "✊🏽", ":fist_tone3:"], ["270a-1f3fc", "✊🏼", ":fist_tone2:"], ["270b-1f3ff", "✋🏿", ":raised_hand_tone5:"], ["270b-1f3fe", "✋🏾", ":raised_hand_tone4:"], ["270b-1f3fd", "✋🏽", ":raised_hand_tone3:"], ["270b-1f3fc", "✋🏼", ":raised_hand_tone2:"], ["270b-1f3fb", "✋🏻", ":raised_hand_tone1:"], ["270d-1f3ff", "✍🏿", ":writing_hand_tone5:"], ["270c-1f3fe", "✌🏾", ":v_tone4:"], ["270c-1f3fd", "✌🏽", ":v_tone3:"], ["270c-1f3fc", "✌🏼", ":v_tone2:"], ["270c-1f3fb", "✌🏻", ":v_tone1:"], ["261d-1f3ff", "☝🏿", ":point_up_tone5:"], ["261d-1f3fe", "☝🏾", ":point_up_tone4:"], ["261d-1f3fd", "☝🏽", ":point_up_tone3:"], ["261d-1f3fc", "☝🏼", ":point_up_tone2:"], ["261d-1f3fb", "☝🏻", ":point_up_tone1:"], ["26f9-1f3ff", "⛹🏿", ":basketball_player_tone5:"], ["26f9-1f3fe", "⛹🏾", ":basketball_player_tone4:"], ["26f9-1f3fd", "⛹🏽", ":basketball_player_tone3:"], ["26f9-1f3fc", "⛹🏼", ":basketball_player_tone2:"], ["26f9-1f3fb", "⛹🏻", ":basketball_player_tone1:"], ["0032-20e3", "2⃣", ":two:"], ["0031-20e3", "1⃣", ":one:"], ["0030-20e3", "0⃣", ":zero:"], ["0038-20e3", "8⃣", ":eight:"], ["002a-20e3", "*⃣", ":asterisk:"], ["0023-20e3", "#⃣", ":hash:"], ["0039-20e3", "9⃣", ":nine:"], ["0037-20e3", "7⃣", ":seven:"], ["0036-20e3", "6⃣", ":six:"], ["0035-20e3", "5⃣", ":five:"], ["0034-20e3", "4⃣", ":four:"], ["0033-20e3", "3⃣", ":three:"], ["1f522", "🔢", ":1234:"], ["1f431", "🐱", ":cat:"], ["1f408", "🐈", ":cat2:"], ["1f981", "🦁", ":lion_face:"], ["1f42f", "🐯", ":tiger:"], ["1f405", "🐅", ":tiger2:"], ["1f406", "🐆", ":leopard:"], ["1f434", "🐴", ":horse:"], ["1f40e", "🐎", ":racehorse:"], ["1f98c", "🦌", ":deer:"], ["1f984", "🦄", ":unicorn:"], ["1f42e", "🐮", ":cow:"], ["1f402", "🐂", ":ox:"], ["1f403", "🐃", ":water_buffalo:"], ["1f404", "🐄", ":cow2:"], ["1f437", "🐷", ":pig:"], ["1f416", "🐖", ":pig2:"], ["1f417", "🐗", ":boar:"], ["1f43d", "🐽", ":pig_nose:"], ["1f40f", "🐏", ":ram:"], ["1f411", "🐑", ":sheep:"], ["1f410", "🐐", ":goat:"], ["1f42a", "🐪", ":dromedary_camel:"], ["1f42b", "🐫", ":camel:"], ["1f418", "🐘", ":elephant:"], ["1f98f", "🦏", ":rhino:"], ["1f42d", "🐭", ":mouse:"], ["1f401", "🐁", ":mouse2:"], ["1f400", "🐀", ":rat:"], ["1f439", "🐹", ":hamster:"], ["1f430", "🐰", ":rabbit:"], ["1f407", "🐇", ":rabbit2:"], ["1f43f", "🐿", ":chipmunk:"], ["1f987", "🦇", ":bat:"], ["1f43b", "🐻", ":bear:"], ["1f428", "🐨", ":koala:"], ["1f43c", "🐼", ":panda_face:"], ["1f43e", "🐾", ":feet:"], ["1f983", "🦃", ":turkey:"], ["1f414", "🐔", ":chicken:"], ["1f413", "🐓", ":rooster:"], ["1f423", "🐣", ":hatching_chick:"], ["1f424", "🐤", ":baby_chick:"], ["1f425", "🐥", ":hatched_chick:"], ["1f426", "🐦", ":bird:"], ["1f427", "🐧", ":penguin:"], ["1f54a", "🕊", ":dove:"], ["1f985", "🦅", ":eagle:"], ["1f986", "🦆", ":duck:"], ["1f989", "🦉", ":owl:"], ["1f438", "🐸", ":frog:"], ["1f40a", "🐊", ":crocodile:"], ["1f422", "🐢", ":turtle:"], ["1f98e", "🦎", ":lizard:"], ["1f40d", "🐍", ":snake:"], ["1f432", "🐲", ":dragon_face:"], ["1f409", "🐉", ":dragon:"], ["1f433", "🐳", ":whale:"], ["1f40b", "🐋", ":whale2:"], ["1f42c", "🐬", ":dolphin:"], ["1f41f", "🐟", ":fish:"], ["1f420", "🐠", ":tropical_fish:"], ["1f421", "🐡", ":blowfish:"], ["1f988", "🦈", ":shark:"], ["1f419", "🐙", ":octopus:"], ["1f41a", "🐚", ":shell:"], ["1f980", "🦀", ":crab:"], ["1f990", "🦐", ":shrimp:"], ["1f991", "🦑", ":squid:"], ["1f98b", "🦋", ":butterfly:"], ["1f40c", "🐌", ":snail:"], ["1f41b", "🐛", ":bug:"], ["1f41c", "🐜", ":ant:"], ["1f41d", "🐝", ":bee:"], ["1f41e", "🐞", ":beetle:"], ["1f577", "🕷", ":spider:"], ["1f578", "🕸", ":spider_web:"], ["1f982", "🦂", ":scorpion:"], ["1f490", "💐", ":bouquet:"], ["1f338", "🌸", ":cherry_blossom:"], ["1f4ae", "💮", ":white_flower:"], ["1f3f5", "🏵", ":rosette:"], ["1f339", "🌹", ":rose:"], ["1f940", "🥀", ":wilted_rose:"], ["1f33a", "🌺", ":hibiscus:"], ["1f33b", "🌻", ":sunflower:"], ["1f33c", "🌼", ":blossom:"], ["1f337", "🌷", ":tulip:"], ["1f331", "🌱", ":seedling:"], ["1f332", "🌲", ":evergreen_tree:"], ["1f333", "🌳", ":deciduous_tree:"], ["1f334", "🌴", ":palm_tree:"], ["1f335", "🌵", ":cactus:"], ["1f33e", "🌾", ":ear_of_rice:"], ["1f33f", "🌿", ":herb:"], ["1f1f4", "🇴", ":regional_indicator_o:"], ["1f340", "🍀", ":four_leaf_clover:"], ["1f341", "🍁", ":maple_leaf:"], ["1f342", "🍂", ":fallen_leaf:"], ["1f343", "🍃", ":leaves:"], ["1f347", "🍇", ":grapes:"], ["1f348", "🍈", ":melon:"], ["1f349", "🍉", ":watermelon:"], ["1f34a", "🍊", ":tangerine:"], ["1f34b", "🍋", ":lemon:"], ["1f34c", "🍌", ":banana:"], ["1f34d", "🍍", ":pineapple:"], ["1f34e", "🍎", ":apple:"], ["1f34f", "🍏", ":green_apple:"], ["1f350", "🍐", ":pear:"], ["1f351", "🍑", ":peach:"], ["1f352", "🍒", ":cherries:"], ["1f353", "🍓", ":strawberry:"], ["1f95d", "🥝", ":kiwi:"], ["1f345", "🍅", ":tomato:"], ["1f951", "🥑", ":avocado:"], ["1f346", "🍆", ":eggplant:"], ["1f954", "🥔", ":potato:"], ["1f955", "🥕", ":carrot:"], ["1f33d", "🌽", ":corn:"], ["1f336", "🌶", ":hot_pepper:"], ["1f952", "🥒", ":cucumber:"], ["1f344", "🍄", ":mushroom:"], ["1f95c", "🥜", ":peanuts:"], ["1f330", "🌰", ":chestnut:"], ["1f35e", "🍞", ":bread:"], ["1f950", "🥐", ":croissant:"], ["1f956", "🥖", ":french_bread:"], ["1f95e", "🥞", ":pancakes:"], ["1f9c0", "🧀", ":cheese:"], ["1f356", "🍖", ":meat_on_bone:"], ["1f357", "🍗", ":poultry_leg:"], ["1f953", "🥓", ":bacon:"], ["1f354", "🍔", ":hamburger:"], ["1f35f", "🍟", ":fries:"], ["1f355", "🍕", ":pizza:"], ["1f32d", "🌭", ":hotdog:"], ["1f32e", "🌮", ":taco:"], ["1f32f", "🌯", ":burrito:"], ["1f959", "🥙", ":stuffed_flatbread:"], ["1f95a", "🥚", ":egg:"], ["1f373", "🍳", ":cooking:"], ["1f958", "🥘", ":shallow_pan_of_food:"], ["1f372", "🍲", ":stew:"], ["1f957", "🥗", ":salad:"], ["1f37f", "🍿", ":popcorn:"], ["1f371", "🍱", ":bento:"], ["1f358", "🍘", ":rice_cracker:"], ["1f359", "🍙", ":rice_ball:"], ["1f35a", "🍚", ":rice:"], ["1f35b", "🍛", ":curry:"], ["1f35c", "🍜", ":ramen:"], ["1f35d", "🍝", ":spaghetti:"], ["1f360", "🍠", ":sweet_potato:"], ["1f362", "🍢", ":oden:"], ["1f363", "🍣", ":sushi:"], ["1f364", "🍤", ":fried_shrimp:"], ["1f365", "🍥", ":fish_cake:"], ["1f361", "🍡", ":dango:"], ["1f366", "🍦", ":icecream:"], ["1f367", "🍧", ":shaved_ice:"], ["1f368", "🍨", ":ice_cream:"], ["1f369", "🍩", ":doughnut:"], ["1f36a", "🍪", ":cookie:"], ["1f382", "🎂", ":birthday:"], ["1f370", "🍰", ":cake:"], ["1f36b", "🍫", ":chocolate_bar:"], ["1f36c", "🍬", ":candy:"], ["1f36d", "🍭", ":lollipop:"], ["1f36e", "🍮", ":custard:"], ["1f36f", "🍯", ":honey_pot:"], ["1f37c", "🍼", ":baby_bottle:"], ["1f95b", "🥛", ":milk:"], ["1f1f5", "🇵", ":regional_indicator_p:"], ["1f375", "🍵", ":tea:"], ["1f376", "🍶", ":sake:"], ["1f37e", "🍾", ":champagne:"], ["1f377", "🍷", ":wine_glass:"], ["1f378", "🍸", ":cocktail:"], ["1f379", "🍹", ":tropical_drink:"], ["1f37a", "🍺", ":beer:"], ["1f37b", "🍻", ":beers:"], ["1f942", "🥂", ":champagne_glass:"], ["1f943", "🥃", ":tumbler_glass:"], ["1f37d", "🍽", ":fork_knife_plate:"], ["1f374", "🍴", ":fork_and_knife:"], ["1f944", "🥄", ":spoon:"], ["1f52a", "🔪", ":knife:"], ["1f3fa", "🏺", ":amphora:"], ["1f30d", "🌍", ":earth_africa:"], ["1f30e", "🌎", ":earth_americas:"], ["1f30f", "🌏", ":earth_asia:"], ["1f310", "🌐", ":globe_with_meridians:"], ["1f5fa", "🗺", ":map:"], ["1f5fe", "🗾", ":japan:"], ["1f3d4", "🏔", ":mountain_snow:"], ["1f1f6", "🇶", ":regional_indicator_q:"], ["1f30b", "🌋", ":volcano:"], ["1f5fb", "🗻", ":mount_fuji:"], ["1f3d5", "🏕", ":camping:"], ["1f3d6", "🏖", ":beach:"], ["1f3dc", "🏜", ":desert:"], ["1f3dd", "🏝", ":island:"], ["1f3de", "🏞", ":park:"], ["1f3df", "🏟", ":stadium:"], ["1f3db", "🏛", ":classical_building:"], ["1f3d7", "🏗", ":construction_site:"], ["1f3d8", "🏘", ":homes:"], ["1f3d9", "🏙", ":cityscape:"], ["1f3da", "🏚", ":house_abandoned:"], ["1f3e0", "🏠", ":house:"], ["1f3e1", "🏡", ":house_with_garden:"], ["1f3e2", "🏢", ":office:"], ["1f3e3", "🏣", ":post_office:"], ["1f3e4", "🏤", ":european_post_office:"], ["1f3e5", "🏥", ":hospital:"], ["1f3e6", "🏦", ":bank:"], ["1f3e8", "🏨", ":hotel:"], ["1f3e9", "🏩", ":love_hotel:"], ["1f3ea", "🏪", ":convenience_store:"], ["1f3eb", "🏫", ":school:"], ["1f3ec", "🏬", ":department_store:"], ["1f3ed", "🏭", ":factory:"], ["1f3ef", "🏯", ":japanese_castle:"], ["1f3f0", "🏰", ":european_castle:"], ["1f492", "💒", ":wedding:"], ["1f5fc", "🗼", ":tokyo_tower:"], ["1f5fd", "🗽", ":statue_of_liberty:"], ["1f1f7", "🇷", ":regional_indicator_r:"], ["1f54c", "🕌", ":mosque:"], ["1f54d", "🕍", ":synagogue:"], ["1f1f8", "🇸", ":regional_indicator_s:"], ["1f54b", "🕋", ":kaaba:"], ["1f1f9", "🇹", ":regional_indicator_t:"], ["1f1fa", "🇺", ":regional_indicator_u:"], ["1f301", "🌁", ":foggy:"], ["1f303", "🌃", ":night_with_stars:"], ["1f304", "🌄", ":sunrise_over_mountains:"], ["1f305", "🌅", ":sunrise:"], ["1f306", "🌆", ":city_dusk:"], ["1f307", "🌇", ":city_sunset:"], ["1f309", "🌉", ":bridge_at_night:"], ["1f1fb", "🇻", ":regional_indicator_v:"], ["1f30c", "🌌", ":milky_way:"], ["1f3a0", "🎠", ":carousel_horse:"], ["1f3a1", "🎡", ":ferris_wheel:"], ["1f3a2", "🎢", ":roller_coaster:"], ["1f488", "💈", ":barber:"], ["1f3aa", "🎪", ":circus_tent:"], ["1f3ad", "🎭", ":performing_arts:"], ["1f5bc", "🖼", ":frame_photo:"], ["1f3a8", "🎨", ":art:"], ["1f3b0", "🎰", ":slot_machine:"], ["1f682", "🚂", ":steam_locomotive:"], ["1f683", "🚃", ":railway_car:"], ["1f684", "🚄", ":bullettrain_side:"], ["1f685", "🚅", ":bullettrain_front:"], ["1f686", "🚆", ":train2:"], ["1f687", "🚇", ":metro:"], ["1f688", "🚈", ":light_rail:"], ["1f689", "🚉", ":station:"], ["1f68a", "🚊", ":tram:"], ["1f69d", "🚝", ":monorail:"], ["1f69e", "🚞", ":mountain_railway:"], ["1f68b", "🚋", ":train:"], ["1f68c", "🚌", ":bus:"], ["1f68d", "🚍", ":oncoming_bus:"], ["1f68e", "🚎", ":trolleybus:"], ["1f690", "🚐", ":minibus:"], ["1f691", "🚑", ":ambulance:"], ["1f692", "🚒", ":fire_engine:"], ["1f693", "🚓", ":police_car:"], ["1f694", "🚔", ":oncoming_police_car:"], ["1f695", "🚕", ":taxi:"], ["1f696", "🚖", ":oncoming_taxi:"], ["1f697", "🚗", ":red_car:"], ["1f698", "🚘", ":oncoming_automobile:"], ["1f699", "🚙", ":blue_car:"], ["1f69a", "🚚", ":truck:"], ["1f69b", "🚛", ":articulated_lorry:"], ["1f69c", "🚜", ":tractor:"], ["1f6b2", "🚲", ":bike:"], ["1f6f4", "🛴", ":scooter:"], ["1f6f5", "🛵", ":motor_scooter:"], ["1f68f", "🚏", ":busstop:"], ["1f6e3", "🛣", ":motorway:"], ["1f6e4", "🛤", ":railway_track:"], ["1f1fc", "🇼", ":regional_indicator_w:"], ["1f6a8", "🚨", ":rotating_light:"], ["1f6a5", "🚥", ":traffic_light:"], ["1f6a6", "🚦", ":vertical_traffic_light:"], ["1f6a7", "🚧", ":construction:"], ["1f6d1", "🛑", ":octagonal_sign:"], ["1f1fd", "🇽", ":regional_indicator_x:"], ["1f1fe", "🇾", ":regional_indicator_y:"], ["1f6f6", "🛶", ":canoe:"], ["1f6a4", "🚤", ":speedboat:"], ["1f6f3", "🛳", ":cruise_ship:"], ["1f1ff", "🇿", ":regional_indicator_z:"], ["1f6e5", "🛥", ":motorboat:"], ["1f6a2", "🚢", ":ship:"], ["1f3fb", "🏻", ":tone1:"], ["1f6e9", "🛩", ":airplane_small:"], ["1f6eb", "🛫", ":airplane_departure:"], ["1f6ec", "🛬", ":airplane_arriving:"], ["1f4ba", "💺", ":seat:"], ["1f681", "🚁", ":helicopter:"], ["1f69f", "🚟", ":suspension_railway:"], ["1f6a0", "🚠", ":mountain_cableway:"], ["1f6a1", "🚡", ":aerial_tramway:"], ["1f680", "🚀", ":rocket:"], ["1f6f0", "🛰", ":satellite_orbital:"], ["1f6ce", "🛎", ":bellhop:"], ["1f6aa", "🚪", ":door:"], ["1f6cc", "🛌", ":sleeping_accommodation:"], ["1f6cf", "🛏", ":bed:"], ["1f6cb", "🛋", ":couch:"], ["1f6bd", "🚽", ":toilet:"], ["1f6bf", "🚿", ":shower:"], ["1f6c0", "🛀", ":bath:"], ["1f3fc", "🏼", ":tone2:"], ["1f3fd", "🏽", ":tone3:"], ["1f3fe", "🏾", ":tone4:"], ["1f3ff", "🏿", ":tone5:"], ["1f4aa", "💪", ":muscle:"], ["1f6c1", "🛁", ":bathtub:"], ["1f634", "😴", ":sleeping:"], ["1f47c", "👼", ":angel:"], ["1f60c", "😌", ":relieved:"], ["1f913", "🤓", ":nerd:"], ["1f61b", "😛", ":stuck_out_tongue:"], ["1f933", "🤳", ":selfie:"], ["1f570", "🕰", ":clock:"], ["1f55b", "🕛", ":clock12:"], ["1f567", "🕧", ":clock1230:"], ["1f550", "🕐", ":clock1:"], ["1f55c", "🕜", ":clock130:"], ["1f551", "🕑", ":clock2:"], ["1f55d", "🕝", ":clock230:"], ["1f552", "🕒", ":clock3:"], ["1f55e", "🕞", ":clock330:"], ["1f553", "🕓", ":clock4:"], ["1f55f", "🕟", ":clock430:"], ["1f554", "🕔", ":clock5:"], ["1f560", "🕠", ":clock530:"], ["1f555", "🕕", ":clock6:"], ["1f561", "🕡", ":clock630:"], ["1f556", "🕖", ":clock7:"], ["1f562", "🕢", ":clock730:"], ["1f557", "🕗", ":clock8:"], ["1f563", "🕣", ":clock830:"], ["1f558", "🕘", ":clock9:"], ["1f564", "🕤", ":clock930:"], ["1f559", "🕙", ":clock10:"], ["1f565", "🕥", ":clock1030:"], ["1f55a", "🕚", ":clock11:"], ["1f566", "🕦", ":clock1130:"], ["1f311", "🌑", ":new_moon:"], ["1f312", "🌒", ":waxing_crescent_moon:"], ["1f313", "🌓", ":first_quarter_moon:"], ["1f314", "🌔", ":waxing_gibbous_moon:"], ["1f315", "🌕", ":full_moon:"], ["1f316", "🌖", ":waning_gibbous_moon:"], ["1f317", "🌗", ":last_quarter_moon:"], ["1f318", "🌘", ":waning_crescent_moon:"], ["1f319", "🌙", ":crescent_moon:"], ["1f31a", "🌚", ":new_moon_with_face:"], ["1f31b", "🌛", ":first_quarter_moon_with_face:"], ["1f31c", "🌜", ":last_quarter_moon_with_face:"], ["1f321", "🌡", ":thermometer:"], ["1f926", "🤦", ":face_palm:"], ["1f31d", "🌝", ":full_moon_with_face:"], ["1f31e", "🌞", ":sun_with_face:"], ["1f61c", "😜", ":stuck_out_tongue_winking_eye:"], ["1f31f", "🌟", ":star2:"], ["1f320", "🌠", ":stars:"], ["1f61d", "😝", ":stuck_out_tongue_closed_eyes:"], ["1f46e", "👮", ":cop:"], ["1f924", "🤤", ":drooling_face:"], ["1f324", "🌤", ":white_sun_small_cloud:"], ["1f325", "🌥", ":white_sun_cloud:"], ["1f326", "🌦", ":white_sun_rain_cloud:"], ["1f327", "🌧", ":cloud_rain:"], ["1f328", "🌨", ":cloud_snow:"], ["1f329", "🌩", ":cloud_lightning:"], ["1f32a", "🌪", ":cloud_tornado:"], ["1f32b", "🌫", ":fog:"], ["1f32c", "🌬", ":wind_blowing_face:"], ["1f300", "🌀", ":cyclone:"], ["1f308", "🌈", ":rainbow:"], ["1f302", "🌂", ":closed_umbrella:"], ["1f448", "👈", ":point_left:"], ["1f612", "😒", ":unamused:"], ["1f937", "🤷", ":shrug:"], ["1f613", "😓", ":sweat:"], ["1f614", "😔", ":pensive:"], ["1f615", "😕", ":confused:"], ["1f449", "👉", ":point_right:"], ["1f575", "🕵", ":spy:"], ["1f525", "🔥", ":fire:"], ["1f4a7", "💧", ":droplet:"], ["1f30a", "🌊", ":ocean:"], ["1f383", "🎃", ":jack_o_lantern:"], ["1f384", "🎄", ":christmas_tree:"], ["1f386", "🎆", ":fireworks:"], ["1f387", "🎇", ":sparkler:"], ["1f643", "🙃", ":upside_down:"], ["1f388", "🎈", ":balloon:"], ["1f389", "🎉", ":tada:"], ["1f38a", "🎊", ":confetti_ball:"], ["1f38b", "🎋", ":tanabata_tree:"], ["1f38d", "🎍", ":bamboo:"], ["1f38e", "🎎", ":dolls:"], ["1f38f", "🎏", ":flags:"], ["1f390", "🎐", ":wind_chime:"], ["1f391", "🎑", ":rice_scene:"], ["1f380", "🎀", ":ribbon:"], ["1f381", "🎁", ":gift:"], ["1f397", "🎗", ":reminder_ribbon:"], ["1f39f", "🎟", ":tickets:"], ["1f3ab", "🎫", ":ticket:"], ["1f396", "🎖", ":military_medal:"], ["1f3c6", "🏆", ":trophy:"], ["1f3c5", "🏅", ":medal:"], ["1f947", "🥇", ":first_place:"], ["1f948", "🥈", ":second_place:"], ["1f949", "🥉", ":third_place:"], ["1f486", "💆", ":massage:"], ["1f911", "🤑", ":money_mouth:"], ["1f3c0", "🏀", ":basketball:"], ["1f3d0", "🏐", ":volleyball:"], ["1f3c8", "🏈", ":football:"], ["1f3c9", "🏉", ":rugby_football:"], ["1f3be", "🎾", ":tennis:"], ["1f3b1", "🎱", ":8ball:"], ["1f3b3", "🎳", ":bowling:"], ["1f3cf", "🏏", ":cricket:"], ["1f3d1", "🏑", ":field_hockey:"], ["1f3d2", "🏒", ":hockey:"], ["1f3d3", "🏓", ":ping_pong:"], ["1f3f8", "🏸", ":badminton:"], ["1f94a", "🥊", ":boxing_glove:"], ["1f94b", "🥋", ":martial_arts_uniform:"], ["1f945", "🥅", ":goal:"], ["1f3af", "🎯", ":dart:"], ["1f632", "😲", ":astonished:"], ["1f1ec", "🇬", ":regional_indicator_g:"], ["1f3a3", "🎣", ":fishing_pole_and_fish:"], ["1f3bd", "🎽", ":running_shirt_with_sash:"], ["1f3bf", "🎿", ":ski:"], ["1f3ae", "🎮", ":video_game:"], ["1f579", "🕹", ":joystick:"], ["1f3b2", "🎲", ":game_die:"], ["1f1e8", "🇨", ":regional_indicator_c:"], ["1f641", "🙁", ":slight_frown:"], ["1f482", "💂", ":guardsman:"], ["1f487", "💇", ":haircut:"], ["1f0cf", "🃏", ":black_joker:"], ["1f004", "🀄", ":mahjong:"], ["1f3b4", "🎴", ":flower_playing_cards:"], ["1f507", "🔇", ":mute:"], ["1f508", "🔈", ":speaker:"], ["1f509", "🔉", ":sound:"], ["1f50a", "🔊", ":loud_sound:"], ["1f4e2", "📢", ":loudspeaker:"], ["1f4e3", "📣", ":mega:"], ["1f4ef", "📯", ":postal_horn:"], ["1f514", "🔔", ":bell:"], ["1f515", "🔕", ":no_bell:"], ["1f3bc", "🎼", ":musical_score:"], ["1f3b5", "🎵", ":musical_note:"], ["1f3b6", "🎶", ":notes:"], ["1f399", "🎙", ":microphone2:"], ["1f39a", "🎚", ":level_slider:"], ["1f39b", "🎛", ":control_knobs:"], ["1f3a4", "🎤", ":microphone:"], ["1f3a7", "🎧", ":headphones:"], ["1f4fb", "📻", ":radio:"], ["1f3b7", "🎷", ":saxophone:"], ["1f3b8", "🎸", ":guitar:"], ["1f3b9", "🎹", ":musical_keyboard:"], ["1f3ba", "🎺", ":trumpet:"], ["1f3bb", "🎻", ":violin:"], ["1f941", "🥁", ":drum:"], ["1f4f1", "📱", ":iphone:"], ["1f4f2", "📲", ":calling:"], ["1f616", "😖", ":confounded:"], ["1f4de", "📞", ":telephone_receiver:"], ["1f4df", "📟", ":pager:"], ["1f4e0", "📠", ":fax:"], ["1f50b", "🔋", ":battery:"], ["1f50c", "🔌", ":electric_plug:"], ["1f4bb", "💻", ":computer:"], ["1f5a5", "🖥", ":desktop:"], ["1f5a8", "🖨", ":printer:"], ["1f446", "👆", ":point_up_2:"], ["1f5b1", "🖱", ":mouse_three_button:"], ["1f5b2", "🖲", ":trackball:"], ["1f4bd", "💽", ":minidisc:"], ["1f4be", "💾", ":floppy_disk:"], ["1f4bf", "💿", ":cd:"], ["1f4c0", "📀", ":dvd:"], ["1f3a5", "🎥", ":movie_camera:"], ["1f39e", "🎞", ":film_frames:"], ["1f4fd", "📽", ":projector:"], ["1f3ac", "🎬", ":clapper:"], ["1f4fa", "📺", ":tv:"], ["1f4f7", "📷", ":camera:"], ["1f4f8", "📸", ":camera_with_flash:"], ["1f4f9", "📹", ":video_camera:"], ["1f4fc", "📼", ":vhs:"], ["1f50d", "🔍", ":mag:"], ["1f50e", "🔎", ":mag_right:"], ["1f52c", "🔬", ":microscope:"], ["1f52d", "🔭", ":telescope:"], ["1f4e1", "📡", ":satellite:"], ["1f56f", "🕯", ":candle:"], ["1f4a1", "💡", ":bulb:"], ["1f526", "🔦", ":flashlight:"], ["1f3ee", "🏮", ":izakaya_lantern:"], ["1f4d4", "📔", ":notebook_with_decorative_cover:"], ["1f4d5", "📕", ":closed_book:"], ["1f4d6", "📖", ":book:"], ["1f4d7", "📗", ":green_book:"], ["1f4d8", "📘", ":blue_book:"], ["1f4d9", "📙", ":orange_book:"], ["1f4da", "📚", ":books:"], ["1f4d3", "📓", ":notebook:"], ["1f4d2", "📒", ":ledger:"], ["1f4c3", "📃", ":page_with_curl:"], ["1f4dc", "📜", ":scroll:"], ["1f4c4", "📄", ":page_facing_up:"], ["1f4f0", "📰", ":newspaper:"], ["1f5de", "🗞", ":newspaper2:"], ["1f4d1", "📑", ":bookmark_tabs:"], ["1f516", "🔖", ":bookmark:"], ["1f3f7", "🏷", ":label:"], ["1f4b0", "💰", ":moneybag:"], ["1f4b4", "💴", ":yen:"], ["1f4b5", "💵", ":dollar:"], ["1f4b6", "💶", ":euro:"], ["1f4b7", "💷", ":pound:"], ["1f4b8", "💸", ":money_with_wings:"], ["1f4b3", "💳", ":credit_card:"], ["1f4b9", "💹", ":chart:"], ["1f4b1", "💱", ":currency_exchange:"], ["1f4b2", "💲", ":heavy_dollar_sign:"], ["1f61e", "😞", ":disappointed:"], ["1f4e7", "📧", ":e-mail:"], ["1f4e8", "📨", ":incoming_envelope:"], ["1f4e9", "📩", ":envelope_with_arrow:"], ["1f4e4", "📤", ":outbox_tray:"], ["1f4e5", "📥", ":inbox_tray:"], ["1f4e6", "📦", ":package:"], ["1f4eb", "📫", ":mailbox:"], ["1f4ea", "📪", ":mailbox_closed:"], ["1f4ec", "📬", ":mailbox_with_mail:"], ["1f4ed", "📭", ":mailbox_with_no_mail:"], ["1f4ee", "📮", ":postbox:"], ["1f5f3", "🗳", ":ballot_box:"], ["1f61f", "😟", ":worried:"], ["1f624", "😤", ":triumph:"], ["1f58b", "🖋", ":pen_fountain:"], ["1f58a", "🖊", ":pen_ballpoint:"], ["1f58c", "🖌", ":paintbrush:"], ["1f58d", "🖍", ":crayon:"], ["1f4dd", "📝", ":pencil:"], ["1f4bc", "💼", ":briefcase:"], ["1f4c1", "📁", ":file_folder:"], ["1f4c2", "📂", ":open_file_folder:"], ["1f5c2", "🗂", ":dividers:"], ["1f4c5", "📅", ":date:"], ["1f4c6", "📆", ":calendar:"], ["1f5d2", "🗒", ":notepad_spiral:"], ["1f5d3", "🗓", ":calendar_spiral:"], ["1f4c7", "📇", ":card_index:"], ["1f4c8", "📈", ":chart_with_upwards_trend:"], ["1f4c9", "📉", ":chart_with_downwards_trend:"], ["1f4ca", "📊", ":bar_chart:"], ["1f4cb", "📋", ":clipboard:"], ["1f4cc", "📌", ":pushpin:"], ["1f4cd", "📍", ":round_pushpin:"], ["1f4ce", "📎", ":paperclip:"], ["1f587", "🖇", ":paperclips:"], ["1f4cf", "📏", ":straight_ruler:"], ["1f4d0", "📐", ":triangular_ruler:"], ["1f622", "😢", ":cry:"], ["1f5c3", "🗃", ":card_box:"], ["1f5c4", "🗄", ":file_cabinet:"], ["1f5d1", "🗑", ":wastebasket:"], ["1f512", "🔒", ":lock:"], ["1f513", "🔓", ":unlock:"], ["1f50f", "🔏", ":lock_with_ink_pen:"], ["1f510", "🔐", ":closed_lock_with_key:"], ["1f511", "🔑", ":key:"], ["1f5dd", "🗝", ":key2:"], ["1f528", "🔨", ":hammer:"], ["1f6b6", "🚶", ":walking:"], ["1f595", "🖕", ":middle_finger:"], ["1f6e0", "🛠", ":tools:"], ["1f5e1", "🗡", ":dagger:"], ["1f477", "👷", ":construction_worker:"], ["1f52b", "🔫", ":gun:"], ["1f3f9", "🏹", ":bow_and_arrow:"], ["1f6e1", "🛡", ":shield:"], ["1f527", "🔧", ":wrench:"], ["1f529", "🔩", ":nut_and_bolt:"], ["1f62d", "😭", ":sob:"], ["1f5dc", "🗜", ":compression:"], ["1f626", "😦", ":frowning:"], ["1f627", "😧", ":anguished:"], ["1f517", "🔗", ":link:"], ["1f628", "😨", ":fearful:"], ["1f489", "💉", ":syringe:"], ["1f48a", "💊", ":pill:"], ["1f6ac", "🚬", ":smoking:"], ["1f447", "👇", ":point_down:"], ["1f3c3", "🏃", ":runner:"], ["1f5ff", "🗿", ":moyai:"], ["1f6e2", "🛢", ":oil:"], ["1f52e", "🔮", ":crystal_ball:"], ["1f6d2", "🛒", ":shopping_cart:"], ["1f3e7", "🏧", ":atm:"], ["1f6ae", "🚮", ":put_litter_in_its_place:"], ["1f6b0", "🚰", ":potable_water:"], ["1f629", "😩", ":weary:"], ["1f6b9", "🚹", ":mens:"], ["1f6ba", "🚺", ":womens:"], ["1f6bb", "🚻", ":restroom:"], ["1f6bc", "🚼", ":baby_symbol:"], ["1f6be", "🚾", ":wc:"], ["1f6c2", "🛂", ":passport_control:"], ["1f6c3", "🛃", ":customs:"], ["1f6c4", "🛄", ":baggage_claim:"], ["1f6c5", "🛅", ":left_luggage:"], ["1f473", "👳", ":man_with_turban:"], ["1f6b8", "🚸", ":children_crossing:"], ["1f62c", "😬", ":grimacing:"], ["1f6ab", "🚫", ":no_entry_sign:"], ["1f6b3", "🚳", ":no_bicycles:"], ["1f6ad", "🚭", ":no_smoking:"], ["1f6af", "🚯", ":do_not_litter:"], ["1f6b1", "🚱", ":non-potable_water:"], ["1f6b7", "🚷", ":no_pedestrians:"], ["1f4f5", "📵", ":no_mobile_phones:"], ["1f51e", "🔞", ":underage:"], ["1f630", "😰", ":cold_sweat:"], ["1f1ed", "🇭", ":regional_indicator_h:"], ["1f631", "😱", ":scream:"], ["1f483", "💃", ":dancer:"], ["1f633", "😳", ":flushed:"], ["1f635", "😵", ":dizzy_face:"], ["1f471", "👱", ":person_with_blond_hair:"], ["1f91e", "🤞", ":fingers_crossed:"], ["1f621", "😡", ":rage:"], ["1f620", "😠", ":angry:"], ["1f57a", "🕺", ":man_dancing:"], ["1f607", "😇", ":innocent:"], ["1f920", "🤠", ":cowboy:"], ["1f596", "🖖", ":vulcan:"], ["1f921", "🤡", ":clown:"], ["1f385", "🎅", ":santa:"], ["1f503", "🔃", ":arrows_clockwise:"], ["1f504", "🔄", ":arrows_counterclockwise:"], ["1f519", "🔙", ":back:"], ["1f51a", "🔚", ":end:"], ["1f51b", "🔛", ":on:"], ["1f51c", "🔜", ":soon:"], ["1f51d", "🔝", ":top:"], ["1f6d0", "🛐", ":place_of_worship:"], ["1f925", "🤥", ":lying_face:"], ["1f549", "🕉", ":om_symbol:"], ["1f46f", "👯", ":dancers:"], ["1f574", "🕴", ":levitate:"], ["1f918", "🤘", ":metal:"], ["1f5e3", "🗣", ":speaking_head:"], ["1f464", "👤", ":bust_in_silhouette:"], ["1f465", "👥", ":busts_in_silhouette:"], ["1f93a", "🤺", ":fencer:"], ["1f54e", "🕎", ":menorah:"], ["1f52f", "🔯", ":six_pointed_star:"], ["1f3c7", "🏇", ":horse_racing:"], ["1f919", "🤙", ":call_me:"], ["1f637", "😷", ":mask:"], ["1f912", "🤒", ":thermometer_face:"], ["1f915", "🤕", ":head_bandage:"], ["1f922", "🤢", ":nauseated_face:"], ["1f936", "🤶", ":mrs_claus:"], ["1f590", "🖐", ":hand_splayed:"], ["1f1ea", "🇪", ":regional_indicator_e:"], ["1f3c2", "🏂", ":snowboarder:"], ["1f3cc", "🏌", ":golfer:"], ["1f3c4", "🏄", ":surfer:"], ["1f927", "🤧", ":sneezing_face:"], ["1f500", "🔀", ":twisted_rightwards_arrows:"], ["1f501", "🔁", ":repeat:"], ["1f502", "🔂", ":repeat_one:"], ["1f1ee", "🇮", ":regional_indicator_i:"], ["1f608", "😈", ":smiling_imp:"], ["1f47f", "👿", ":imp:"], ["1f479", "👹", ":japanese_ogre:"], ["1f47a", "👺", ":japanese_goblin:"], ["1f6a3", "🚣", ":rowboat:"], ["1f44c", "👌", ":ok_hand:"], ["1f53c", "🔼", ":arrow_up_small:"], ["1f478", "👸", ":princess:"], ["1f53d", "🔽", ":arrow_down_small:"], ["1f480", "💀", ":skull:"], ["1f1e9", "🇩", ":regional_indicator_d:"], ["1f47b", "👻", ":ghost:"], ["1f47d", "👽", ":alien:"], ["1f44d", "👍", ":thumbsup:"], ["1f3a6", "🎦", ":cinema:"], ["1f505", "🔅", ":low_brightness:"], ["1f506", "🔆", ":high_brightness:"], ["1f4f6", "📶", ":signal_strength:"], ["1f4f3", "📳", ":vibration_mode:"], ["1f4f4", "📴", ":mobile_phone_off:"], ["1f3ca", "🏊", ":swimmer:"], ["1f4db", "📛", ":name_badge:"], ["1f47e", "👾", ":space_invader:"], ["1f530", "🔰", ":beginner:"], ["1f531", "🔱", ":trident:"], ["1f934", "🤴", ":prince:"], ["1f916", "🤖", ":robot:"], ["1f4a9", "💩", ":poop:"], ["1f44e", "👎", ":thumbsdown:"], ["1f63a", "😺", ":smiley_cat:"], ["1f1eb", "🇫", ":regional_indicator_f:"], ["1f638", "😸", ":smile_cat:"], ["1f639", "😹", ":joy_cat:"], ["1f470", "👰", ":bride_with_veil:"], ["1f1ef", "🇯", ":regional_indicator_j:"], ["1f63b", "😻", ":heart_eyes_cat:"], ["1f63c", "😼", ":smirk_cat:"], ["1f3cb", "🏋", ":lifter:"], ["1f63d", "😽", ":kissing_cat:"], ["1f640", "🙀", ":scream_cat:"], ["1f44a", "👊", ":punch:"], ["1f63f", "😿", ":crying_cat_face:"], ["1f935", "🤵", ":man_in_tuxedo:"], ["1f63e", "😾", ":pouting_cat:"], ["1f6b4", "🚴", ":bicyclist:"], ["1f648", "🙈", ":see_no_evil:"], ["1f91b", "🤛", ":left_facing_fist:"], ["1f649", "🙉", ":hear_no_evil:"], ["1f64a", "🙊", ":speak_no_evil:"], ["1f466", "👦", ":boy:"], ["1f930", "🤰", ":pregnant_woman:"], ["1f6b5", "🚵", ":mountain_bicyclist:"], ["1f91c", "🤜", ":right_facing_fist:"], ["1f4af", "💯", ":100:"], ["1f600", "😀", ":grinning:"], ["1f601", "😁", ":grin:"], ["1f602", "😂", ":joy:"], ["1f923", "🤣", ":rofl:"], ["1f91a", "🤚", ":raised_back_of_hand:"], ["1f3ce", "🏎", ":race_car:"], ["1f3cd", "🏍", ":motorcycle:"], ["1f938", "🤸", ":cartwheel:"], ["1f472", "👲", ":man_with_gua_pi_mao:"], ["1f51f", "🔟", ":keycap_ten:"], ["1f520", "🔠", ":capital_abcd:"], ["1f521", "🔡", ":abcd:"], ["1f523", "🔣", ":symbols:"], ["1f524", "🔤", ":abc:"], ["1f170", "🅰", ":a:"], ["1f18e", "🆎", ":ab:"], ["1f171", "🅱", ":b:"], ["1f191", "🆑", ":cl:"], ["1f192", "🆒", ":cool:"], ["1f193", "🆓", ":free:"], ["1f467", "👧", ":girl:"], ["1f194", "🆔", ":id:"], ["1f44b", "👋", ":wave:"], ["1f195", "🆕", ":new:"], ["1f196", "🆖", ":ng:"], ["1f17e", "🅾", ":o2:"], ["1f197", "🆗", ":ok:"], ["1f17f", "🅿", ":parking:"], ["1f198", "🆘", ":sos:"], ["1f199", "🆙", ":up:"], ["1f19a", "🆚", ":vs:"], ["1f201", "🈁", ":koko:"], ["1f202", "🈂", ":sa:"], ["1f237", "🈷", ":u6708:"], ["1f236", "🈶", ":u6709:"], ["1f22f", "🈯", ":u6307:"], ["1f250", "🉐", ":ideograph_advantage:"], ["1f239", "🈹", ":u5272:"], ["1f21a", "🈚", ":u7121:"], ["1f232", "🈲", ":u7981:"], ["1f251", "🉑", ":accept:"], ["1f238", "🈸", ":u7533:"], ["1f234", "🈴", ":u5408:"], ["1f233", "🈳", ":u7a7a:"], ["1f603", "😃", ":smiley:"], ["1f604", "😄", ":smile:"], ["1f23a", "🈺", ":u55b6:"], ["1f235", "🈵", ":u6e80:"], ["1f605", "😅", ":sweat_smile:"], ["1f93c", "🤼", ":wrestlers:"], ["1f606", "😆", ":laughing:"], ["1f44f", "👏", ":clap:"], ["1f64d", "🙍", ":person_frowning:"], ["1f609", "😉", ":wink:"], ["1f468", "👨", ":man:"], ["1f60a", "😊", ":blush:"], ["1f536", "🔶", ":large_orange_diamond:"], ["1f537", "🔷", ":large_blue_diamond:"], ["1f538", "🔸", ":small_orange_diamond:"], ["1f539", "🔹", ":small_blue_diamond:"], ["1f53a", "🔺", ":small_red_triangle:"], ["1f53b", "🔻", ":small_red_triangle_down:"], ["1f4a0", "💠", ":diamond_shape_with_a_dot_inside:"], ["1f518", "🔘", ":radio_button:"], ["1f532", "🔲", ":black_square_button:"], ["1f533", "🔳", ":white_square_button:"], ["1f93d", "🤽", ":water_polo:"], ["1f1f0", "🇰", ":regional_indicator_k:"], ["1f534", "🔴", ":red_circle:"], ["1f535", "🔵", ":blue_circle:"], ["1f3c1", "🏁", ":checkered_flag:"], ["1f6a9", "🚩", ":triangular_flag_on_post:"], ["1f38c", "🎌", ":crossed_flags:"], ["1f3f4", "🏴", ":flag_black:"], ["1f3f3", "🏳", ":flag_white:"], ["1f60b", "😋", ":yum:"], ["1f60e", "😎", ":sunglasses:"], ["1f64e", "🙎", ":person_with_pouting_face:"], ["1f60d", "😍", ":heart_eyes:"], ["1f618", "😘", ":kissing_heart:"], ["1f450", "👐", ":open_hands:"], ["1f93e", "🤾", ":handball:"], ["1f469", "👩", ":woman:"], ["1f617", "😗", ":kissing:"], ["1f619", "😙", ":kissing_smiling_eyes:"], ["1f645", "🙅", ":no_good:"], ["1f64c", "🙌", ":raised_hands:"], ["1f61a", "😚", ":kissing_closed_eyes:"], ["1f939", "🤹", ":juggling:"], ["1f1e7", "🇧", ":regional_indicator_b:"], ["1f642", "🙂", ":slight_smile:"], ["1f474", "👴", ":older_man:"], ["1f64f", "🙏", ":pray:"], ["1f917", "🤗", ":hugging:"], ["1f646", "🙆", ":ok_woman:"], ["1f46b", "👫", ":couple:"], ["1f46c", "👬", ":two_men_holding_hands:"], ["1f46d", "👭", ":two_women_holding_hands:"], ["1f91d", "🤝", ":handshake:"], ["1f48f", "💏", ":couplekiss:"], ["1f914", "🤔", ":thinking:"], ["1f610", "😐", ":neutral_face:"], ["1f491", "💑", ":couple_with_heart:"], ["1f611", "😑", ":expressionless:"], ["1f485", "💅", ":nail_care:"], ["1f636", "😶", ":no_mouth:"], ["1f46a", "👪", ":family:"], ["1f475", "👵", ":older_woman:"], ["1f481", "💁", ":information_desk_person:"], ["1f644", "🙄", ":rolling_eyes:"], ["1f442", "👂", ":ear:"], ["1f60f", "😏", ":smirk:"], ["1f623", "😣", ":persevere:"], ["1f625", "😥", ":disappointed_relieved:"], ["1f62e", "😮", ":open_mouth:"], ["1f64b", "🙋", ":raising_hand:"], ["1f443", "👃", ":nose:"], ["1f476", "👶", ":baby:"], ["1f910", "🤐", ":zipper_mouth:"], ["1f62f", "😯", ":hushed:"], ["1f62a", "😪", ":sleepy:"], ["1f62b", "😫", ":tired_face:"], ["1f463", "👣", ":footprints:"], ["1f440", "👀", ":eyes:"], ["1f441", "👁", ":eye:"], ["1f647", "🙇", ":bow:"], ["1f445", "👅", ":tongue:"], ["1f444", "👄", ":lips:"], ["1f48b", "💋", ":kiss:"], ["1f498", "💘", ":cupid:"], ["1f1f1", "🇱", ":regional_indicator_l:"], ["1f493", "💓", ":heartbeat:"], ["1f494", "💔", ":broken_heart:"], ["1f495", "💕", ":two_hearts:"], ["1f496", "💖", ":sparkling_heart:"], ["1f497", "💗", ":heartpulse:"], ["1f499", "💙", ":blue_heart:"], ["1f49a", "💚", ":green_heart:"], ["1f49b", "💛", ":yellow_heart:"], ["1f49c", "💜", ":purple_heart:"], ["1f5a4", "🖤", ":black_heart:"], ["1f49d", "💝", ":gift_heart:"], ["1f49e", "💞", ":revolving_hearts:"], ["1f49f", "💟", ":heart_decoration:"], ["1f1f2", "🇲", ":regional_indicator_m:"], ["1f48c", "💌", ":love_letter:"], ["1f4a4", "💤", ":zzz:"], ["1f4a2", "💢", ":anger:"], ["1f4a3", "💣", ":bomb:"], ["1f4a5", "💥", ":boom:"], ["1f4a6", "💦", ":sweat_drops:"], ["1f4a8", "💨", ":dash:"], ["1f4ab", "💫", ":dizzy:"], ["1f4ac", "💬", ":speech_balloon:"], ["1f5e8", "🗨", ":speech_left:"], ["1f5ef", "🗯", ":anger_right:"], ["1f4ad", "💭", ":thought_balloon:"], ["1f573", "🕳", ":hole:"], ["1f453", "👓", ":eyeglasses:"], ["1f576", "🕶", ":dark_sunglasses:"], ["1f454", "👔", ":necktie:"], ["1f455", "👕", ":shirt:"], ["1f456", "👖", ":jeans:"], ["1f457", "👗", ":dress:"], ["1f458", "👘", ":kimono:"], ["1f459", "👙", ":bikini:"], ["1f45a", "👚", ":womans_clothes:"], ["1f45b", "👛", ":purse:"], ["1f45c", "👜", ":handbag:"], ["1f45d", "👝", ":pouch:"], ["1f6cd", "🛍", ":shopping_bags:"], ["1f392", "🎒", ":school_satchel:"], ["1f45e", "👞", ":mans_shoe:"], ["1f45f", "👟", ":athletic_shoe:"], ["1f460", "👠", ":high_heel:"], ["1f461", "👡", ":sandal:"], ["1f462", "👢", ":boot:"], ["1f451", "👑", ":crown:"], ["1f452", "👒", ":womans_hat:"], ["1f3a9", "🎩", ":tophat:"], ["1f393", "🎓", ":mortar_board:"], ["1f1f3", "🇳", ":regional_indicator_n:"], ["1f4ff", "📿", ":prayer_beads:"], ["1f484", "💄", ":lipstick:"], ["1f48d", "💍", ":ring:"], ["1f48e", "💎", ":gem:"], ["1f435", "🐵", ":monkey_face:"], ["1f412", "🐒", ":monkey:"], ["1f98d", "🦍", ":gorilla:"], ["1f436", "🐶", ":dog:"], ["1f415", "🐕", ":dog2:"], ["1f429", "🐩", ":poodle:"], ["1f43a", "🐺", ":wolf:"], ["1f98a", "🦊", ":fox:"], ["1f1e6", "🇦", ":regional_indicator_a:"], ["26ab", "⚫", ":black_circle:"], ["2b1c", "⬜", ":white_large_square:"], ["2b1b", "⬛", ":black_large_square:"], ["25fe", "◾", ":black_medium_small_square:"], ["25fd", "◽", ":white_medium_small_square:"], ["25fc", "◼", ":black_medium_square:"], ["25fb", "◻", ":white_medium_square:"], ["25ab", "▫", ":white_small_square:"], ["25aa", "▪", ":black_small_square:"], ["3299", "㊙", ":secret:"], ["3297", "㊗", ":congratulations:"], ["24c2", "Ⓜ", ":m:"], ["2139", "ℹ", ":information_source:"], ["2122", "™", ":tm:"], ["00ae", "®", ":registered:"], ["00a9", "©", ":copyright:"], ["3030", "〰", ":wavy_dash:"], ["2757", "❗", ":exclamation:"], ["2755", "❕", ":grey_exclamation:"], ["2754", "❔", ":grey_question:"], ["2753", "❓", ":question:"], ["2049", "⁉", ":interrobang:"], ["203c", "‼", ":bangbang:"], ["2747", "❇", ":sparkle:"], ["2734", "✴", ":eight_pointed_black_star:"], ["2733", "✳", ":eight_spoked_asterisk:"], ["303d", "〽", ":part_alternation_mark:"], ["27bf", "➿", ":loop:"], ["27b0", "➰", ":curly_loop:"], ["2797", "➗", ":heavy_division_sign:"], ["2796", "➖", ":heavy_minus_sign:"], ["2795", "➕", ":heavy_plus_sign:"], ["274e", "❎", ":negative_squared_cross_mark:"], ["274c", "❌", ":x:"], ["2716", "✖", ":heavy_multiplication_x:"], ["2714", "✔", ":heavy_check_mark:"], ["2611", "☑", ":ballot_box_with_check:"], ["2705", "✅", ":white_check_mark:"], ["2b55", "⭕", ":o:"], ["269c", "⚜", ":fleur-de-lis:"], ["267b", "♻", ":recycle:"], ["23cf", "⏏", ":eject:"], ["23fa", "⏺", ":record_button:"], ["23f9", "⏹", ":stop_button:"], ["23f8", "⏸", ":pause_button:"], ["23ec", "⏬", ":arrow_double_down:"], ["23eb", "⏫", ":arrow_double_up:"], ["23ee", "⏮", ":track_previous:"], ["23ea", "⏪", ":rewind:"], ["25c0", "◀", ":arrow_backward:"], ["23ef", "⏯", ":play_pause:"], ["23ed", "⏭", ":track_next:"], ["23e9", "⏩", ":fast_forward:"], ["25b6", "▶", ":arrow_forward:"], ["26ce", "⛎", ":ophiuchus:"], ["2653", "♓", ":pisces:"], ["2652", "♒", ":aquarius:"], ["2651", "♑", ":capricorn:"], ["2650", "♐", ":sagittarius:"], ["264f", "♏", ":scorpius:"], ["264e", "♎", ":libra:"], ["264d", "♍", ":virgo:"], ["264c", "♌", ":leo:"], ["264b", "♋", ":cancer:"], ["264a", "♊", ":gemini:"], ["2649", "♉", ":taurus:"], ["2648", "♈", ":aries:"], ["262e", "☮", ":peace:"], ["262a", "☪", ":star_and_crescent:"], ["2626", "☦", ":orthodox_cross:"], ["271d", "✝", ":cross:"], ["262f", "☯", ":yin_yang:"], ["2638", "☸", ":wheel_of_dharma:"], ["2721", "✡", ":star_of_david:"], ["269b", "⚛", ":atom:"], ["2935", "⤵", ":arrow_heading_down:"], ["2934", "⤴", ":arrow_heading_up:"], ["21aa", "↪", ":arrow_right_hook:"], ["21a9", "↩", ":leftwards_arrow_with_hook:"], ["2194", "↔", ":left_right_arrow:"], ["2195", "↕", ":arrow_up_down:"], ["26aa", "⚪", ":white_circle:"], ["2b05", "⬅", ":arrow_left:"], ["2199", "↙", ":arrow_lower_left:"], ["2b07", "⬇", ":arrow_down:"], ["2198", "↘", ":arrow_lower_right:"], ["27a1", "➡", ":arrow_right:"], ["2197", "↗", ":arrow_upper_right:"], ["2b06", "⬆", ":arrow_up:"], ["2623", "☣", ":biohazard:"], ["2622", "☢", ":radioactive:"], ["26d4", "⛔", ":no_entry:"], ["26a0", "⚠", ":warning:"], ["267f", "♿", ":wheelchair:"], ["26b1", "⚱", ":urn:"], ["26b0", "⚰", ":coffin:"], ["26d3", "⛓", ":chains:"], ["2696", "⚖", ":scales:"], ["2697", "⚗", ":alembic:"], ["2699", "⚙", ":gear:"], ["2694", "⚔", ":crossed_swords:"], ["2692", "⚒", ":hammer_pick:"], ["26cf", "⛏", ":pick:"], ["2702", "✂", ":scissors:"], ["2712", "✒", ":black_nib:"], ["270f", "✏", ":pencil2:"], ["2709", "✉", ":envelope:"], ["2328", "⌨", ":keyboard:"], ["260e", "☎", ":telephone:"], ["2663", "♣", ":clubs:"], ["2666", "♦", ":diamonds:"], ["2665", "♥", ":hearts:"], ["2660", "♠", ":spades:"], ["26f8", "⛸", ":ice_skate:"], ["26f3", "⛳", ":golf:"], ["26be", "⚾", ":baseball:"], ["26bd", "⚽", ":soccer:"], ["2728", "✨", ":sparkles:"], ["2604", "☄", ":comet:"], ["26c4", "⛄", ":snowman:"], ["2603", "☃", ":snowman2:"], ["2744", "❄", ":snowflake:"], ["26a1", "⚡", ":zap:"], ["26f1", "⛱", ":beach_umbrella:"], ["2614", "☔", ":umbrella:"], ["2602", "☂", ":umbrella2:"], ["26c8", "⛈", ":thunder_cloud_rain:"], ["26c5", "⛅", ":partly_sunny:"], ["2601", "☁", ":cloud:"], ["2b50", "⭐", ":star:"], ["2600", "☀", ":sunny:"], ["23f2", "⏲", ":timer:"], ["23f1", "⏱", ":stopwatch:"], ["23f0", "⏰", ":alarm_clock:"], ["231a", "⌚", ":watch:"], ["23f3", "⏳", ":hourglass_flowing_sand:"], ["231b", "⌛", ":hourglass:"], ["2708", "✈", ":airplane:"], ["26f4", "⛴", ":ferry:"], ["26f5", "⛵", ":sailboat:"], ["2693", "⚓", ":anchor:"], ["26fd", "⛽", ":fuelpump:"], ["2668", "♨", ":hotsprings:"], ["26fa", "⛺", ":tent:"], ["26f2", "⛲", ":fountain:"], ["26e9", "⛩", ":shinto_shrine:"], ["26ea", "⛪", ":church:"], ["26f0", "⛰", ":mountain:"], ["2615", "☕", ":coffee:"], ["2618", "☘", ":shamrock:"], ["26d1", "⛑", ":helmet_with_cross:"], ["2763", "❣", ":heart_exclamation:"], ["2764", "❤", ":heart:"], ["270d", "✍", ":writing_hand:"], ["270a", "✊", ":fist:"], ["270b", "✋", ":raised_hand:"], ["270c", "✌", ":v:"], ["261d", "☝", ":point_up:"], ["26f9", "⛹", ":basketball_player:"], ["26f7", "⛷", ":skier:"], ["2620", "☠", ":skull_crossbones:"], ["2639", "☹", ":frowning2:"], ["263a", "☺", ":relaxed:"], ["2196", "↖", ":arrow_upper_left:"]];

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.emojify = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * react-emojione
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Copyright(c) 2017 Pedro Ladaria
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * MIT Licensed
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Emoji provided free by http://emojione.com
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */


var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _asciiToUnicode = __webpack_require__(39);

var _asciiToUnicode2 = _interopRequireDefault(_asciiToUnicode);

var _rendererFactory = __webpack_require__(43);

var _rendererFactory2 = _interopRequireDefault(_rendererFactory);

var _emojiFormatConversion = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_OPTIONS = {
    convertShortnames: true,
    convertUnicode: true,
    convertAscii: true,
    style: {
        backgroundImage: 'url(https://cdnjs.cloudflare.com/ajax/libs/emojione/2.2.7/assets/sprites/emojione.sprites.png)'
    },
    onClick: undefined,
    output: 'emoji' // valid options: 'emoji', 'unicode'
};

var asciiToUnicodeCache = new Map();
var asciiRegExpToUnicode = new Map();

_asciiToUnicode2.default.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        reStr = _ref2[0],
        unicode = _ref2[1];

    return asciiRegExpToUnicode.set(RegExp(reStr), unicode);
});

// Escape RegExp code borrowed from lodash
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reHasRegExpChar = RegExp(reRegExpChar.source);
var escapeRegExp = function escapeRegExp(s) {
    return s && reHasRegExpChar.test(s) ? s.replace(reRegExpChar, '\\$&') : s;
};

var convertAsciiToUnicodeOrNull = function convertAsciiToUnicodeOrNull(text) {
    if (!text) {
        return '';
    }
    var str = String(text);
    if (asciiToUnicodeCache.has(str)) {
        return asciiToUnicodeCache.get(str);
    }
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = asciiRegExpToUnicode.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _step$value = _slicedToArray(_step.value, 2),
                regExp = _step$value[0],
                unicode = _step$value[1];

            if (str.replace(regExp, unicode) === unicode) {
                asciiToUnicodeCache.set(str, unicode);
                return unicode;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return null;
};

var asciiRegexStr = _asciiToUnicode2.default.map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
        reStr = _ref4[0];

    return reStr;
}).join('|');
var unicodesRegexStr = _emojiFormatConversion.unicodes.map(escapeRegExp).join('|');
var shortnamesRegexStr = ':\\w+:';

var REGEX_CACHE = [];

var getRegex = function getRegex(withUnicode, withAscii, withShortnames) {
    var index = (withUnicode ? 1 : 0) + (withAscii ? 2 : 0) + (withShortnames ? 4 : 0);
    if (!REGEX_CACHE[index]) {
        var parts = [withShortnames ? shortnamesRegexStr : '', withUnicode ? unicodesRegexStr : '', withAscii ? asciiRegexStr : ''].filter(Boolean);
        REGEX_CACHE[index] = RegExp('(' + parts.join('|') + ')');
    }
    return REGEX_CACHE[index];
};

var startsWithSpace = function startsWithSpace(str) {
    return (/^\s/.test(str)
    );
};
var endsWithSpace = function endsWithSpace(str) {
    return (/\s$/.test(str)
    );
};

var shouldConvertAscii = function shouldConvertAscii(parts, index) {
    if (parts.length === 1) {
        return true;
    }
    if (index === 0) {
        return startsWithSpace(parts[index + 1]);
    }
    if (index === parts.length - 1) {
        return endsWithSpace(parts[index - 1]);
    }
    return endsWithSpace(parts[index - 1]) && startsWithSpace(parts[index + 1]);
};

var emojify = exports.emojify = function emojify(str) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


    var mergedOptions = Object.assign({}, DEFAULT_OPTIONS, options);

    var convertShortnames = mergedOptions.convertShortnames,
        convertUnicode = mergedOptions.convertUnicode,
        convertAscii = mergedOptions.convertAscii;


    var regExp = getRegex(convertUnicode, convertAscii, convertShortnames);

    var renderCodepoint = (0, _rendererFactory2.default)(mergedOptions);

    var convertedParts = str.split(regExp).filter(Boolean).map(function (part, index, parts) {
        if (convertAscii && shouldConvertAscii(parts, index)) {
            var unicode = convertAsciiToUnicodeOrNull(part);
            if (unicode) {
                return renderCodepoint(_emojiFormatConversion.unicodeToCodepoint.get(unicode), 'a-' + index);
            }
        }
        if (convertShortnames && _emojiFormatConversion.shortToCodepoint.has(part)) {
            return renderCodepoint(_emojiFormatConversion.shortToCodepoint.get(part), 's-' + index);
        }
        if (convertUnicode && _emojiFormatConversion.unicodeToCodepoint.has(part)) {
            return renderCodepoint(_emojiFormatConversion.unicodeToCodepoint.get(part), 'u-' + index);
        }
        return part;
    });

    return mergedOptions.output === 'unicode' ? convertedParts.join('') : convertedParts;
};

var Emojify = function (_React$Component) {
    _inherits(Emojify, _React$Component);

    function Emojify() {
        _classCallCheck(this, Emojify);

        return _possibleConstructorReturn(this, (Emojify.__proto__ || Object.getPrototypeOf(Emojify)).apply(this, arguments));
    }

    _createClass(Emojify, [{
        key: 'traverse',
        value: function traverse(children, options) {
            var _this2 = this;

            return _react2.default.Children.map(children, function (child) {
                if (_react2.default.isValidElement(child)) {
                    return _react2.default.cloneElement(child, {}, _this2.traverse(child.props.children, options));
                }
                if (typeof child === 'string') {
                    return emojify(child, options);
                }
                return child;
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var children = this.props.children;
            return _react2.default.Children.count(children) ? _react2.default.createElement('span', {}, this.traverse(children, this.props)) : null;
        }
    }]);

    return Emojify;
}(_react2.default.Component);

exports.default = Emojify;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _emojioneSprite = __webpack_require__(46);

var _emojiFormatConversion = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Emoji = function Emoji(_ref) {
    var codepoint = _ref.codepoint,
        _ref$style = _ref.style,
        style = _ref$style === undefined ? {} : _ref$style,
        onClick = _ref.onClick;
    return _react2.default.createElement(
        'span',
        {
            onClick: onClick,
            style: (0, _emojioneSprite.sprite)(codepoint, style),
            title: _emojiFormatConversion.codepointToShort.get(codepoint)
        },
        _emojiFormatConversion.codepointToUnicode.get(codepoint)
    );
};

var getRenderer = function getRenderer(_ref2) {
    var style = _ref2.style,
        onClick = _ref2.onClick;
    return function (codepoint, key) {
        return _react2.default.createElement(Emoji, {
            codepoint: codepoint,
            style: style,
            onClick: onClick,
            key: key
        });
    };
};

exports.default = getRenderer;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _emojiRenderer = __webpack_require__(42);

var _emojiRenderer2 = _interopRequireDefault(_emojiRenderer);

var _unicodeRenderer = __webpack_require__(44);

var _unicodeRenderer2 = _interopRequireDefault(_unicodeRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rendererForOutputFormat = {
    emoji: _emojiRenderer2.default,
    unicode: _unicodeRenderer2.default
};

var getRenderer = function getRenderer(config) {
    var renderer = rendererForOutputFormat[config.output] || rendererForOutputFormat.emoji;
    return renderer(config);
};

exports.default = getRenderer;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _emojiFormatConversion = __webpack_require__(2);

var getRenderer = function getRenderer() {
  return function (codepoint) {
    return _emojiFormatConversion.codepointToUnicode.get(codepoint);
  };
};

exports.default = getRenderer;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*eslint-disable*/
// Do not edit!
// This file was auto-generated by create-styles.js
exports.default = {
  '0023-20e3': [-65, 0],
  '0023': [-1365, -1820],
  '002a-20e3': [0, -65],
  '002a': [-65, -65],
  '0030-20e3': [-130, 0],
  '0030': [-130, -65],
  '0031-20e3': [0, -130],
  '0031': [-65, -130],
  '0032-20e3': [-130, -130],
  '0032': [-195, 0],
  '0033-20e3': [-195, -65],
  '0033': [-195, -130],
  '0034-20e3': [0, -195],
  '0034': [-65, -195],
  '0035-20e3': [-130, -195],
  '0035': [-195, -195],
  '0036-20e3': [-260, 0],
  '0036': [-260, -65],
  '0037-20e3': [-260, -130],
  '0037': [-260, -195],
  '0038-20e3': [0, -260],
  '0038': [-65, -260],
  '0039-20e3': [-130, -260],
  '0039': [-195, -260],
  '00a9': [-260, -260],
  '00ae': [-325, 0],
  '1f004': [-325, -65],
  '1f0cf': [-325, -130],
  '1f170': [-325, -195],
  '1f171': [-325, -260],
  '1f17e': [0, -325],
  '1f17f': [-65, -325],
  '1f18e': [-130, -325],
  '1f191': [-195, -325],
  '1f192': [-260, -325],
  '1f193': [-325, -325],
  '1f194': [-390, 0],
  '1f195': [-390, -65],
  '1f196': [-390, -130],
  '1f197': [-390, -195],
  '1f198': [-390, -260],
  '1f199': [-390, -325],
  '1f19a': [0, -390],
  '1f1e6-1f1e8': [-65, -390],
  '1f1e6-1f1e9': [-130, -390],
  '1f1e6-1f1ea': [-195, -390],
  '1f1e6-1f1eb': [-260, -390],
  '1f1e6-1f1ec': [-325, -390],
  '1f1e6-1f1ee': [-390, -390],
  '1f1e6-1f1f1': [-455, 0],
  '1f1e6-1f1f2': [-455, -65],
  '1f1e6-1f1f4': [-455, -130],
  '1f1e6-1f1f6': [-455, -195],
  '1f1e6-1f1f7': [-455, -260],
  '1f1e6-1f1f8': [-455, -325],
  '1f1e6-1f1f9': [-455, -390],
  '1f1e6-1f1fa': [0, -455],
  '1f1e6-1f1fc': [-65, -455],
  '1f1e6-1f1fd': [-130, -455],
  '1f1e6-1f1ff': [-195, -455],
  '1f1e6': [-260, -455],
  '1f1e7-1f1e6': [-325, -455],
  '1f1e7-1f1e7': [-390, -455],
  '1f1e7-1f1e9': [-455, -455],
  '1f1e7-1f1ea': [-520, 0],
  '1f1e7-1f1eb': [-520, -65],
  '1f1e7-1f1ec': [-520, -130],
  '1f1e7-1f1ed': [-520, -195],
  '1f1e7-1f1ee': [-520, -260],
  '1f1e7-1f1ef': [-520, -325],
  '1f1e7-1f1f1': [-520, -390],
  '1f1e7-1f1f2': [-520, -455],
  '1f1e7-1f1f3': [0, -520],
  '1f1e7-1f1f4': [-65, -520],
  '1f1e7-1f1f6': [-130, -520],
  '1f1e7-1f1f7': [-195, -520],
  '1f1e7-1f1f8': [-260, -520],
  '1f1e7-1f1f9': [-325, -520],
  '1f1e7-1f1fb': [-390, -520],
  '1f1e7-1f1fc': [-455, -520],
  '1f1e7-1f1fe': [-520, -520],
  '1f1e7-1f1ff': [-585, 0],
  '1f1e7': [-585, -65],
  '1f1e8-1f1e6': [-585, -130],
  '1f1e8-1f1e8': [-585, -195],
  '1f1e8-1f1e9': [-585, -260],
  '1f1e8-1f1eb': [-585, -325],
  '1f1e8-1f1ec': [-585, -390],
  '1f1e8-1f1ed': [-585, -455],
  '1f1e8-1f1ee': [-585, -520],
  '1f1e8-1f1f0': [0, -585],
  '1f1e8-1f1f1': [-65, -585],
  '1f1e8-1f1f2': [-130, -585],
  '1f1e8-1f1f3': [-195, -585],
  '1f1e8-1f1f4': [-260, -585],
  '1f1e8-1f1f5': [-325, -585],
  '1f1e8-1f1f7': [-390, -585],
  '1f1e8-1f1fa': [-455, -585],
  '1f1e8-1f1fb': [-520, -585],
  '1f1e8-1f1fc': [-585, -585],
  '1f1e8-1f1fd': [-650, 0],
  '1f1e8-1f1fe': [-650, -65],
  '1f1e8-1f1ff': [-650, -130],
  '1f1e8': [-650, -195],
  '1f1e9-1f1ea': [-650, -260],
  '1f1e9-1f1ec': [-650, -325],
  '1f1e9-1f1ef': [-650, -390],
  '1f1e9-1f1f0': [-650, -455],
  '1f1e9-1f1f2': [-650, -520],
  '1f1e9-1f1f4': [-650, -585],
  '1f1e9-1f1ff': [0, -650],
  '1f1e9': [-65, -650],
  '1f1ea-1f1e6': [-130, -650],
  '1f1ea-1f1e8': [-195, -650],
  '1f1ea-1f1ea': [-260, -650],
  '1f1ea-1f1ec': [-325, -650],
  '1f1ea-1f1ed': [-390, -650],
  '1f1ea-1f1f7': [-455, -650],
  '1f1ea-1f1f8': [-520, -650],
  '1f1ea-1f1f9': [-585, -650],
  '1f1ea-1f1fa': [-650, -650],
  '1f1ea': [-715, 0],
  '1f1eb-1f1ee': [-715, -65],
  '1f1eb-1f1ef': [-715, -130],
  '1f1eb-1f1f0': [-715, -195],
  '1f1eb-1f1f2': [-715, -260],
  '1f1eb-1f1f4': [-715, -325],
  '1f1eb-1f1f7': [-715, -390],
  '1f1eb': [-715, -455],
  '1f1ec-1f1e6': [-715, -520],
  '1f1ec-1f1e7': [-715, -585],
  '1f1ec-1f1e9': [-715, -650],
  '1f1ec-1f1ea': [0, -715],
  '1f1ec-1f1eb': [-65, -715],
  '1f1ec-1f1ec': [-130, -715],
  '1f1ec-1f1ed': [-195, -715],
  '1f1ec-1f1ee': [-260, -715],
  '1f1ec-1f1f1': [-325, -715],
  '1f1ec-1f1f2': [-390, -715],
  '1f1ec-1f1f3': [-455, -715],
  '1f1ec-1f1f5': [-520, -715],
  '1f1ec-1f1f6': [-585, -715],
  '1f1ec-1f1f7': [-650, -715],
  '1f1ec-1f1f8': [-715, -715],
  '1f1ec-1f1f9': [-780, 0],
  '1f1ec-1f1fa': [-780, -65],
  '1f1ec-1f1fc': [-780, -130],
  '1f1ec-1f1fe': [-780, -195],
  '1f1ec': [-780, -260],
  '1f1ed-1f1f0': [-780, -325],
  '1f1ed-1f1f2': [-780, -390],
  '1f1ed-1f1f3': [-780, -455],
  '1f1ed-1f1f7': [-780, -520],
  '1f1ed-1f1f9': [-780, -585],
  '1f1ed-1f1fa': [-780, -650],
  '1f1ed': [-780, -715],
  '1f1ee-1f1e8': [0, -780],
  '1f1ee-1f1e9': [-65, -780],
  '1f1ee-1f1ea': [-130, -780],
  '1f1ee-1f1f1': [-195, -780],
  '1f1ee-1f1f2': [-260, -780],
  '1f1ee-1f1f3': [-325, -780],
  '1f1ee-1f1f4': [-390, -780],
  '1f1ee-1f1f6': [-455, -780],
  '1f1ee-1f1f7': [-520, -780],
  '1f1ee-1f1f8': [-585, -780],
  '1f1ee-1f1f9': [-650, -780],
  '1f1ee': [-715, -780],
  '1f1ef-1f1ea': [-780, -780],
  '1f1ef-1f1f2': [-845, 0],
  '1f1ef-1f1f4': [-845, -65],
  '1f1ef-1f1f5': [-845, -130],
  '1f1ef': [-845, -195],
  '1f1f0-1f1ea': [-845, -260],
  '1f1f0-1f1ec': [-845, -325],
  '1f1f0-1f1ed': [-845, -390],
  '1f1f0-1f1ee': [-845, -455],
  '1f1f0-1f1f2': [-845, -520],
  '1f1f0-1f1f3': [-845, -585],
  '1f1f0-1f1f5': [-845, -650],
  '1f1f0-1f1f7': [-845, -715],
  '1f1f0-1f1fc': [-845, -780],
  '1f1f0-1f1fe': [0, -845],
  '1f1f0-1f1ff': [-65, -845],
  '1f1f0': [-130, -845],
  '1f1f1-1f1e6': [-195, -845],
  '1f1f1-1f1e7': [-260, -845],
  '1f1f1-1f1e8': [-325, -845],
  '1f1f1-1f1ee': [-390, -845],
  '1f1f1-1f1f0': [-455, -845],
  '1f1f1-1f1f7': [-520, -845],
  '1f1f1-1f1f8': [-585, -845],
  '1f1f1-1f1f9': [-650, -845],
  '1f1f1-1f1fa': [-715, -845],
  '1f1f1-1f1fb': [-780, -845],
  '1f1f1-1f1fe': [-845, -845],
  '1f1f1': [-910, 0],
  '1f1f2-1f1e6': [-910, -65],
  '1f1f2-1f1e8': [-910, -130],
  '1f1f2-1f1e9': [-910, -195],
  '1f1f2-1f1ea': [-910, -260],
  '1f1f2-1f1eb': [-910, -325],
  '1f1f2-1f1ec': [-910, -390],
  '1f1f2-1f1ed': [-910, -455],
  '1f1f2-1f1f0': [-910, -520],
  '1f1f2-1f1f1': [-910, -585],
  '1f1f2-1f1f2': [-910, -650],
  '1f1f2-1f1f3': [-910, -715],
  '1f1f2-1f1f4': [-910, -780],
  '1f1f2-1f1f5': [-910, -845],
  '1f1f2-1f1f6': [0, -910],
  '1f1f2-1f1f7': [-65, -910],
  '1f1f2-1f1f8': [-130, -910],
  '1f1f2-1f1f9': [-195, -910],
  '1f1f2-1f1fa': [-260, -910],
  '1f1f2-1f1fb': [-325, -910],
  '1f1f2-1f1fc': [-390, -910],
  '1f1f2-1f1fd': [-455, -910],
  '1f1f2-1f1fe': [-520, -910],
  '1f1f2-1f1ff': [-585, -910],
  '1f1f2': [-650, -910],
  '1f1f3-1f1e6': [-715, -910],
  '1f1f3-1f1e8': [-780, -910],
  '1f1f3-1f1ea': [-845, -910],
  '1f1f3-1f1eb': [-910, -910],
  '1f1f3-1f1ec': [-975, 0],
  '1f1f3-1f1ee': [-975, -65],
  '1f1f3-1f1f1': [-975, -130],
  '1f1f3-1f1f4': [-975, -195],
  '1f1f3-1f1f5': [-975, -260],
  '1f1f3-1f1f7': [-975, -325],
  '1f1f3-1f1fa': [-975, -390],
  '1f1f3-1f1ff': [-975, -455],
  '1f1f3': [-975, -520],
  '1f1f4-1f1f2': [-975, -585],
  '1f1f4': [-975, -650],
  '1f1f5-1f1e6': [-975, -715],
  '1f1f5-1f1ea': [-975, -780],
  '1f1f5-1f1eb': [-975, -845],
  '1f1f5-1f1ec': [-975, -910],
  '1f1f5-1f1ed': [0, -975],
  '1f1f5-1f1f0': [-65, -975],
  '1f1f5-1f1f1': [-130, -975],
  '1f1f5-1f1f2': [-195, -975],
  '1f1f5-1f1f3': [-260, -975],
  '1f1f5-1f1f7': [-325, -975],
  '1f1f5-1f1f8': [-390, -975],
  '1f1f5-1f1f9': [-455, -975],
  '1f1f5-1f1fc': [-520, -975],
  '1f1f5-1f1fe': [-585, -975],
  '1f1f5': [-650, -975],
  '1f1f6-1f1e6': [-715, -975],
  '1f1f6': [-780, -975],
  '1f1f7-1f1ea': [-845, -975],
  '1f1f7-1f1f4': [-910, -975],
  '1f1f7-1f1f8': [-975, -975],
  '1f1f7-1f1fa': [-1040, 0],
  '1f1f7-1f1fc': [-1040, -65],
  '1f1f7': [-1040, -130],
  '1f1f8-1f1e6': [-1040, -195],
  '1f1f8-1f1e7': [-1040, -260],
  '1f1f8-1f1e8': [-1040, -325],
  '1f1f8-1f1e9': [-1040, -390],
  '1f1f8-1f1ea': [-1040, -455],
  '1f1f8-1f1ec': [-1040, -520],
  '1f1f8-1f1ed': [-1040, -585],
  '1f1f8-1f1ee': [-1040, -650],
  '1f1f8-1f1ef': [-1040, -715],
  '1f1f8-1f1f0': [-1040, -780],
  '1f1f8-1f1f1': [-1040, -845],
  '1f1f8-1f1f2': [-1040, -910],
  '1f1f8-1f1f3': [-1040, -975],
  '1f1f8-1f1f4': [0, -1040],
  '1f1f8-1f1f7': [-65, -1040],
  '1f1f8-1f1f8': [-130, -1040],
  '1f1f8-1f1f9': [-195, -1040],
  '1f1f8-1f1fb': [-260, -1040],
  '1f1f8-1f1fd': [-325, -1040],
  '1f1f8-1f1fe': [-390, -1040],
  '1f1f8-1f1ff': [-455, -1040],
  '1f1f8': [-520, -1040],
  '1f1f9-1f1e6': [-585, -1040],
  '1f1f9-1f1e8': [-650, -1040],
  '1f1f9-1f1e9': [-715, -1040],
  '1f1f9-1f1eb': [-780, -1040],
  '1f1f9-1f1ec': [-845, -1040],
  '1f1f9-1f1ed': [-910, -1040],
  '1f1f9-1f1ef': [-975, -1040],
  '1f1f9-1f1f0': [-1040, -1040],
  '1f1f9-1f1f1': [-1105, 0],
  '1f1f9-1f1f2': [-1105, -65],
  '1f1f9-1f1f3': [-1105, -130],
  '1f1f9-1f1f4': [-1105, -195],
  '1f1f9-1f1f7': [-1105, -260],
  '1f1f9-1f1f9': [-1105, -325],
  '1f1f9-1f1fb': [-1105, -390],
  '1f1f9-1f1fc': [-1105, -455],
  '1f1f9-1f1ff': [-1105, -520],
  '1f1f9': [-1105, -585],
  '1f1fa-1f1e6': [-1105, -650],
  '1f1fa-1f1ec': [-1105, -715],
  '1f1fa-1f1f2': [-1105, -780],
  '1f1fa-1f1f8': [-1105, -845],
  '1f1fa-1f1fe': [-1105, -910],
  '1f1fa-1f1ff': [-1105, -975],
  '1f1fa': [-1105, -1040],
  '1f1fb-1f1e6': [0, -1105],
  '1f1fb-1f1e8': [-65, -1105],
  '1f1fb-1f1ea': [-130, -1105],
  '1f1fb-1f1ec': [-195, -1105],
  '1f1fb-1f1ee': [-260, -1105],
  '1f1fb-1f1f3': [-325, -1105],
  '1f1fb-1f1fa': [-390, -1105],
  '1f1fb': [-455, -1105],
  '1f1fc-1f1eb': [-520, -1105],
  '1f1fc-1f1f8': [-585, -1105],
  '1f1fc': [-650, -1105],
  '1f1fd-1f1f0': [-715, -1105],
  '1f1fd': [-780, -1105],
  '1f1fe-1f1ea': [-845, -1105],
  '1f1fe-1f1f9': [-910, -1105],
  '1f1fe': [-975, -1105],
  '1f1ff-1f1e6': [-1040, -1105],
  '1f1ff-1f1f2': [-1105, -1105],
  '1f1ff-1f1fc': [-1170, 0],
  '1f1ff': [-1170, -65],
  '1f201': [-1170, -130],
  '1f202': [-1170, -195],
  '1f21a': [-1170, -260],
  '1f22f': [-1170, -325],
  '1f232': [-1170, -390],
  '1f233': [-1170, -455],
  '1f234': [-1170, -520],
  '1f235': [-1170, -585],
  '1f236': [-1170, -650],
  '1f237': [-1170, -715],
  '1f238': [-1170, -780],
  '1f239': [-1170, -845],
  '1f23a': [-1170, -910],
  '1f250': [-1170, -975],
  '1f251': [-1170, -1040],
  '1f300': [-1170, -1105],
  '1f301': [0, -1170],
  '1f302': [-65, -1170],
  '1f303': [-130, -1170],
  '1f304': [-195, -1170],
  '1f305': [-260, -1170],
  '1f306': [-325, -1170],
  '1f307': [-390, -1170],
  '1f308': [-455, -1170],
  '1f309': [-520, -1170],
  '1f30a': [-585, -1170],
  '1f30b': [-650, -1170],
  '1f30c': [-715, -1170],
  '1f30d': [-780, -1170],
  '1f30e': [-845, -1170],
  '1f30f': [-910, -1170],
  '1f310': [-975, -1170],
  '1f311': [-1040, -1170],
  '1f312': [-1105, -1170],
  '1f313': [-1170, -1170],
  '1f314': [-1235, 0],
  '1f315': [-1235, -65],
  '1f316': [-1235, -130],
  '1f317': [-1235, -195],
  '1f318': [-1235, -260],
  '1f319': [-1235, -325],
  '1f31a': [-1235, -390],
  '1f31b': [-1235, -455],
  '1f31c': [-1235, -520],
  '1f31d': [-1235, -585],
  '1f31e': [-1235, -650],
  '1f31f': [-1235, -715],
  '1f320': [-1235, -780],
  '1f321': [-1235, -845],
  '1f324': [-1235, -910],
  '1f325': [-1235, -975],
  '1f326': [-1235, -1040],
  '1f327': [-1235, -1105],
  '1f328': [-1235, -1170],
  '1f329': [0, -1235],
  '1f32a': [-65, -1235],
  '1f32b': [-130, -1235],
  '1f32c': [-195, -1235],
  '1f32d': [-260, -1235],
  '1f32e': [-325, -1235],
  '1f32f': [-390, -1235],
  '1f330': [-455, -1235],
  '1f331': [-520, -1235],
  '1f332': [-585, -1235],
  '1f333': [-650, -1235],
  '1f334': [-715, -1235],
  '1f335': [-780, -1235],
  '1f336': [-845, -1235],
  '1f337': [-910, -1235],
  '1f338': [-975, -1235],
  '1f339': [-1040, -1235],
  '1f33a': [-1105, -1235],
  '1f33b': [-1170, -1235],
  '1f33c': [-1235, -1235],
  '1f33d': [-1300, 0],
  '1f33e': [-1300, -65],
  '1f33f': [-1300, -130],
  '1f340': [-1300, -195],
  '1f341': [-1300, -260],
  '1f342': [-1300, -325],
  '1f343': [-1300, -390],
  '1f344': [-1300, -455],
  '1f345': [-1300, -520],
  '1f346': [-1300, -585],
  '1f347': [-1300, -650],
  '1f348': [-1300, -715],
  '1f349': [-1300, -780],
  '1f34a': [-1300, -845],
  '1f34b': [-1300, -910],
  '1f34c': [-1300, -975],
  '1f34d': [-1300, -1040],
  '1f34e': [-1300, -1105],
  '1f34f': [-1300, -1170],
  '1f350': [-1300, -1235],
  '1f351': [0, -1300],
  '1f352': [-65, -1300],
  '1f353': [-130, -1300],
  '1f354': [-195, -1300],
  '1f355': [-260, -1300],
  '1f356': [-325, -1300],
  '1f357': [-390, -1300],
  '1f358': [-455, -1300],
  '1f359': [-520, -1300],
  '1f35a': [-585, -1300],
  '1f35b': [-650, -1300],
  '1f35c': [-715, -1300],
  '1f35d': [-780, -1300],
  '1f35e': [-845, -1300],
  '1f35f': [-910, -1300],
  '1f360': [-975, -1300],
  '1f361': [-1040, -1300],
  '1f362': [-1105, -1300],
  '1f363': [-1170, -1300],
  '1f364': [-1235, -1300],
  '1f365': [-1300, -1300],
  '1f366': [-1365, 0],
  '1f367': [-1365, -65],
  '1f368': [-1365, -130],
  '1f369': [-1365, -195],
  '1f36a': [-1365, -260],
  '1f36b': [-1365, -325],
  '1f36c': [-1365, -390],
  '1f36d': [-1365, -455],
  '1f36e': [-1365, -520],
  '1f36f': [-1365, -585],
  '1f370': [-1365, -650],
  '1f371': [-1365, -715],
  '1f372': [-1365, -780],
  '1f373': [-1365, -845],
  '1f374': [-1365, -910],
  '1f375': [-1365, -975],
  '1f376': [-1365, -1040],
  '1f377': [-1365, -1105],
  '1f378': [-1365, -1170],
  '1f379': [-1365, -1235],
  '1f37a': [-1365, -1300],
  '1f37b': [0, -1365],
  '1f37c': [-65, -1365],
  '1f37d': [-130, -1365],
  '1f37e': [-195, -1365],
  '1f37f': [-260, -1365],
  '1f380': [-325, -1365],
  '1f381': [-390, -1365],
  '1f382': [-455, -1365],
  '1f383': [-520, -1365],
  '1f384': [-585, -1365],
  '1f385-1f3fb': [-650, -1365],
  '1f385-1f3fc': [-715, -1365],
  '1f385-1f3fd': [-780, -1365],
  '1f385-1f3fe': [-845, -1365],
  '1f385-1f3ff': [-910, -1365],
  '1f385': [-975, -1365],
  '1f386': [-1040, -1365],
  '1f387': [-1105, -1365],
  '1f388': [-1170, -1365],
  '1f389': [-1235, -1365],
  '1f38a': [-1300, -1365],
  '1f38b': [-1365, -1365],
  '1f38c': [-1430, 0],
  '1f38d': [-1430, -65],
  '1f38e': [-1430, -130],
  '1f38f': [-1430, -195],
  '1f390': [-1430, -260],
  '1f391': [-1430, -325],
  '1f392': [-1430, -390],
  '1f393': [-1430, -455],
  '1f396': [-1430, -520],
  '1f397': [-1430, -585],
  '1f399': [-1430, -650],
  '1f39a': [-1430, -715],
  '1f39b': [-1430, -780],
  '1f39e': [-1430, -845],
  '1f39f': [-1430, -910],
  '1f3a0': [-1430, -975],
  '1f3a1': [-1430, -1040],
  '1f3a2': [-1430, -1105],
  '1f3a3': [-1430, -1170],
  '1f3a4': [-1430, -1235],
  '1f3a5': [-1430, -1300],
  '1f3a6': [-1430, -1365],
  '1f3a7': [0, -1430],
  '1f3a8': [-65, -1430],
  '1f3a9': [-130, -1430],
  '1f3aa': [-195, -1430],
  '1f3ab': [-260, -1430],
  '1f3ac': [-325, -1430],
  '1f3ad': [-390, -1430],
  '1f3ae': [-455, -1430],
  '1f3af': [-520, -1430],
  '1f3b0': [-585, -1430],
  '1f3b1': [-650, -1430],
  '1f3b2': [-715, -1430],
  '1f3b3': [-780, -1430],
  '1f3b4': [-845, -1430],
  '1f3b5': [-910, -1430],
  '1f3b6': [-975, -1430],
  '1f3b7': [-1040, -1430],
  '1f3b8': [-1105, -1430],
  '1f3b9': [-1170, -1430],
  '1f3ba': [-1235, -1430],
  '1f3bb': [-1300, -1430],
  '1f3bc': [-1365, -1430],
  '1f3bd': [-1430, -1430],
  '1f3be': [-1495, 0],
  '1f3bf': [-1495, -65],
  '1f3c0': [-1495, -130],
  '1f3c1': [-1495, -195],
  '1f3c2': [-1495, -260],
  '1f3c3-1f3fb': [-1495, -325],
  '1f3c3-1f3fc': [-1495, -390],
  '1f3c3-1f3fd': [-1495, -455],
  '1f3c3-1f3fe': [-1495, -520],
  '1f3c3-1f3ff': [-1495, -585],
  '1f3c3': [-1495, -650],
  '1f3c4-1f3fb': [-1495, -715],
  '1f3c4-1f3fc': [-1495, -780],
  '1f3c4-1f3fd': [-1495, -845],
  '1f3c4-1f3fe': [-1495, -910],
  '1f3c4-1f3ff': [-1495, -975],
  '1f3c4': [-1495, -1040],
  '1f3c5': [-1495, -1105],
  '1f3c6': [-1495, -1170],
  '1f3c7-1f3fb': [-1495, -1235],
  '1f3c7-1f3fc': [-1495, -1300],
  '1f3c7-1f3fd': [-1495, -1365],
  '1f3c7-1f3fe': [-1495, -1430],
  '1f3c7-1f3ff': [0, -1495],
  '1f3c7': [-65, -1495],
  '1f3c8': [-130, -1495],
  '1f3c9': [-195, -1495],
  '1f3ca-1f3fb': [-260, -1495],
  '1f3ca-1f3fc': [-325, -1495],
  '1f3ca-1f3fd': [-390, -1495],
  '1f3ca-1f3fe': [-455, -1495],
  '1f3ca-1f3ff': [-520, -1495],
  '1f3ca': [-585, -1495],
  '1f3cb-1f3fb': [-650, -1495],
  '1f3cb-1f3fc': [-715, -1495],
  '1f3cb-1f3fd': [-780, -1495],
  '1f3cb-1f3fe': [-845, -1495],
  '1f3cb-1f3ff': [-910, -1495],
  '1f3cb': [-975, -1495],
  '1f3cc': [-1040, -1495],
  '1f3cd': [-1105, -1495],
  '1f3ce': [-1170, -1495],
  '1f3cf': [-1235, -1495],
  '1f3d0': [-1300, -1495],
  '1f3d1': [-1365, -1495],
  '1f3d2': [-1430, -1495],
  '1f3d3': [-1495, -1495],
  '1f3d4': [-1560, 0],
  '1f3d5': [-1560, -65],
  '1f3d6': [-1560, -130],
  '1f3d7': [-1560, -195],
  '1f3d8': [-1560, -260],
  '1f3d9': [-1560, -325],
  '1f3da': [-1560, -390],
  '1f3db': [-1560, -455],
  '1f3dc': [-1560, -520],
  '1f3dd': [-1560, -585],
  '1f3de': [-1560, -650],
  '1f3df': [-1560, -715],
  '1f3e0': [-1560, -780],
  '1f3e1': [-1560, -845],
  '1f3e2': [-1560, -910],
  '1f3e3': [-1560, -975],
  '1f3e4': [-1560, -1040],
  '1f3e5': [-1560, -1105],
  '1f3e6': [-1560, -1170],
  '1f3e7': [-1560, -1235],
  '1f3e8': [-1560, -1300],
  '1f3e9': [-1560, -1365],
  '1f3ea': [-1560, -1430],
  '1f3eb': [-1560, -1495],
  '1f3ec': [0, -1560],
  '1f3ed': [-65, -1560],
  '1f3ee': [-130, -1560],
  '1f3ef': [-195, -1560],
  '1f3f0': [-260, -1560],
  '1f3f3-1f308': [-325, -1560],
  '1f3f3': [-390, -1560],
  '1f3f4': [-455, -1560],
  '1f3f5': [-520, -1560],
  '1f3f7': [-585, -1560],
  '1f3f8': [-650, -1560],
  '1f3f9': [-715, -1560],
  '1f3fa': [-780, -1560],
  '1f3fb': [-845, -1560],
  '1f3fc': [-910, -1560],
  '1f3fd': [-975, -1560],
  '1f3fe': [-1040, -1560],
  '1f3ff': [-1105, -1560],
  '1f400': [-1170, -1560],
  '1f401': [-1235, -1560],
  '1f402': [-1300, -1560],
  '1f403': [-1365, -1560],
  '1f404': [-1430, -1560],
  '1f405': [-1495, -1560],
  '1f406': [-1560, -1560],
  '1f407': [-1625, 0],
  '1f408': [-1625, -65],
  '1f409': [-1625, -130],
  '1f40a': [-1625, -195],
  '1f40b': [-1625, -260],
  '1f40c': [-1625, -325],
  '1f40d': [-1625, -390],
  '1f40e': [-1625, -455],
  '1f40f': [-1625, -520],
  '1f410': [-1625, -585],
  '1f411': [-1625, -650],
  '1f412': [-1625, -715],
  '1f413': [-1625, -780],
  '1f414': [-1625, -845],
  '1f415': [-1625, -910],
  '1f416': [-1625, -975],
  '1f417': [-1625, -1040],
  '1f418': [-1625, -1105],
  '1f419': [-1625, -1170],
  '1f41a': [-1625, -1235],
  '1f41b': [-1625, -1300],
  '1f41c': [-1625, -1365],
  '1f41d': [-1625, -1430],
  '1f41e': [-1625, -1495],
  '1f41f': [-1625, -1560],
  '1f420': [0, -1625],
  '1f421': [-65, -1625],
  '1f422': [-130, -1625],
  '1f423': [-195, -1625],
  '1f424': [-260, -1625],
  '1f425': [-325, -1625],
  '1f426': [-390, -1625],
  '1f427': [-455, -1625],
  '1f428': [-520, -1625],
  '1f429': [-585, -1625],
  '1f42a': [-650, -1625],
  '1f42b': [-715, -1625],
  '1f42c': [-780, -1625],
  '1f42d': [-845, -1625],
  '1f42e': [-910, -1625],
  '1f42f': [-975, -1625],
  '1f430': [-1040, -1625],
  '1f431': [-1105, -1625],
  '1f432': [-1170, -1625],
  '1f433': [-1235, -1625],
  '1f434': [-1300, -1625],
  '1f435': [-1365, -1625],
  '1f436': [-1430, -1625],
  '1f437': [-1495, -1625],
  '1f438': [-1560, -1625],
  '1f439': [-1625, -1625],
  '1f43a': [-1690, 0],
  '1f43b': [-1690, -65],
  '1f43c': [-1690, -130],
  '1f43d': [-1690, -195],
  '1f43e': [-1690, -260],
  '1f43f': [-1690, -325],
  '1f440': [-1690, -390],
  '1f441-1f5e8': [-1690, -455],
  '1f441': [-1690, -520],
  '1f442-1f3fb': [-1690, -585],
  '1f442-1f3fc': [-1690, -650],
  '1f442-1f3fd': [-1690, -715],
  '1f442-1f3fe': [-1690, -780],
  '1f442-1f3ff': [-1690, -845],
  '1f442': [-1690, -910],
  '1f443-1f3fb': [-1690, -975],
  '1f443-1f3fc': [-1690, -1040],
  '1f443-1f3fd': [-1690, -1105],
  '1f443-1f3fe': [-1690, -1170],
  '1f443-1f3ff': [-1690, -1235],
  '1f443': [-1690, -1300],
  '1f444': [-1690, -1365],
  '1f445': [-1690, -1430],
  '1f446-1f3fb': [-1690, -1495],
  '1f446-1f3fc': [-1690, -1560],
  '1f446-1f3fd': [-1690, -1625],
  '1f446-1f3fe': [0, -1690],
  '1f446-1f3ff': [-65, -1690],
  '1f446': [-130, -1690],
  '1f447-1f3fb': [-195, -1690],
  '1f447-1f3fc': [-260, -1690],
  '1f447-1f3fd': [-325, -1690],
  '1f447-1f3fe': [-390, -1690],
  '1f447-1f3ff': [-455, -1690],
  '1f447': [-520, -1690],
  '1f448-1f3fb': [-585, -1690],
  '1f448-1f3fc': [-650, -1690],
  '1f448-1f3fd': [-715, -1690],
  '1f448-1f3fe': [-780, -1690],
  '1f448-1f3ff': [-845, -1690],
  '1f448': [-910, -1690],
  '1f449-1f3fb': [-975, -1690],
  '1f449-1f3fc': [-1040, -1690],
  '1f449-1f3fd': [-1105, -1690],
  '1f449-1f3fe': [-1170, -1690],
  '1f449-1f3ff': [-1235, -1690],
  '1f449': [-1300, -1690],
  '1f44a-1f3fb': [-1365, -1690],
  '1f44a-1f3fc': [-1430, -1690],
  '1f44a-1f3fd': [-1495, -1690],
  '1f44a-1f3fe': [-1560, -1690],
  '1f44a-1f3ff': [-1625, -1690],
  '1f44a': [-1690, -1690],
  '1f44b-1f3fb': [-1755, 0],
  '1f44b-1f3fc': [-1755, -65],
  '1f44b-1f3fd': [-1755, -130],
  '1f44b-1f3fe': [-1755, -195],
  '1f44b-1f3ff': [-1755, -260],
  '1f44b': [-1755, -325],
  '1f44c-1f3fb': [-1755, -390],
  '1f44c-1f3fc': [-1755, -455],
  '1f44c-1f3fd': [-1755, -520],
  '1f44c-1f3fe': [-1755, -585],
  '1f44c-1f3ff': [-1755, -650],
  '1f44c': [-1755, -715],
  '1f44d-1f3fb': [-1755, -780],
  '1f44d-1f3fc': [-1755, -845],
  '1f44d-1f3fd': [-1755, -910],
  '1f44d-1f3fe': [-1755, -975],
  '1f44d-1f3ff': [-1755, -1040],
  '1f44d': [-1755, -1105],
  '1f44e-1f3fb': [-1755, -1170],
  '1f44e-1f3fc': [-1755, -1235],
  '1f44e-1f3fd': [-1755, -1300],
  '1f44e-1f3fe': [-1755, -1365],
  '1f44e-1f3ff': [-1755, -1430],
  '1f44e': [-1755, -1495],
  '1f44f-1f3fb': [-1755, -1560],
  '1f44f-1f3fc': [-1755, -1625],
  '1f44f-1f3fd': [-1755, -1690],
  '1f44f-1f3fe': [0, -1755],
  '1f44f-1f3ff': [-65, -1755],
  '1f44f': [-130, -1755],
  '1f450-1f3fb': [-195, -1755],
  '1f450-1f3fc': [-260, -1755],
  '1f450-1f3fd': [-325, -1755],
  '1f450-1f3fe': [-390, -1755],
  '1f450-1f3ff': [-455, -1755],
  '1f450': [-520, -1755],
  '1f451': [-585, -1755],
  '1f452': [-650, -1755],
  '1f453': [-715, -1755],
  '1f454': [-780, -1755],
  '1f455': [-845, -1755],
  '1f456': [-910, -1755],
  '1f457': [-975, -1755],
  '1f458': [-1040, -1755],
  '1f459': [-1105, -1755],
  '1f45a': [-1170, -1755],
  '1f45b': [-1235, -1755],
  '1f45c': [-1300, -1755],
  '1f45d': [-1365, -1755],
  '1f45e': [-1430, -1755],
  '1f45f': [-1495, -1755],
  '1f460': [-1560, -1755],
  '1f461': [-1625, -1755],
  '1f462': [-1690, -1755],
  '1f463': [-1755, -1755],
  '1f464': [-1820, 0],
  '1f465': [-1820, -65],
  '1f466-1f3fb': [-1820, -130],
  '1f466-1f3fc': [-1820, -195],
  '1f466-1f3fd': [-1820, -260],
  '1f466-1f3fe': [-1820, -325],
  '1f466-1f3ff': [-1820, -390],
  '1f466': [-1820, -455],
  '1f467-1f3fb': [-1820, -520],
  '1f467-1f3fc': [-1820, -585],
  '1f467-1f3fd': [-1820, -650],
  '1f467-1f3fe': [-1820, -715],
  '1f467-1f3ff': [-1820, -780],
  '1f467': [-1820, -845],
  '1f468-1f3fb': [-1820, -910],
  '1f468-1f3fc': [-1820, -975],
  '1f468-1f3fd': [-1820, -1040],
  '1f468-1f3fe': [-1820, -1105],
  '1f468-1f3ff': [-1820, -1170],
  '1f468-1f468-1f466-1f466': [-1820, -1235],
  '1f468-1f468-1f466': [-1820, -1300],
  '1f468-1f468-1f467-1f466': [-1820, -1365],
  '1f468-1f468-1f467-1f467': [-1820, -1430],
  '1f468-1f468-1f467': [-1820, -1495],
  '1f468-1f469-1f466-1f466': [-1820, -1560],
  '1f468-1f469-1f467-1f466': [-1820, -1625],
  '1f468-1f469-1f467-1f467': [-1820, -1690],
  '1f468-1f469-1f467': [-1820, -1755],
  '1f468-2764-1f468': [0, -1820],
  '1f468-2764-1f48b-1f468': [-65, -1820],
  '1f468': [-130, -1820],
  '1f469-1f3fb': [-195, -1820],
  '1f469-1f3fc': [-260, -1820],
  '1f469-1f3fd': [-325, -1820],
  '1f469-1f3fe': [-390, -1820],
  '1f469-1f3ff': [-455, -1820],
  '1f469-1f469-1f466-1f466': [-520, -1820],
  '1f469-1f469-1f466': [-585, -1820],
  '1f469-1f469-1f467-1f466': [-650, -1820],
  '1f469-1f469-1f467-1f467': [-715, -1820],
  '1f469-1f469-1f467': [-780, -1820],
  '1f469-2764-1f469': [-845, -1820],
  '1f469-2764-1f48b-1f469': [-910, -1820],
  '1f469': [-975, -1820],
  '1f46a': [-1040, -1820],
  '1f46b': [-1105, -1820],
  '1f46c': [-1170, -1820],
  '1f46d': [-1235, -1820],
  '1f46e-1f3fb': [-1300, -1820],
  '1f46e-1f3fc': [0, 0],
  '1f46e-1f3fd': [-1430, -1820],
  '1f46e-1f3fe': [-1495, -1820],
  '1f46e-1f3ff': [-1560, -1820],
  '1f46e': [-1625, -1820],
  '1f46f': [-1690, -1820],
  '1f470-1f3fb': [-1755, -1820],
  '1f470-1f3fc': [-1820, -1820],
  '1f470-1f3fd': [-1885, 0],
  '1f470-1f3fe': [-1885, -65],
  '1f470-1f3ff': [-1885, -130],
  '1f470': [-1885, -195],
  '1f471-1f3fb': [-1885, -260],
  '1f471-1f3fc': [-1885, -325],
  '1f471-1f3fd': [-1885, -390],
  '1f471-1f3fe': [-1885, -455],
  '1f471-1f3ff': [-1885, -520],
  '1f471': [-1885, -585],
  '1f472-1f3fb': [-1885, -650],
  '1f472-1f3fc': [-1885, -715],
  '1f472-1f3fd': [-1885, -780],
  '1f472-1f3fe': [-1885, -845],
  '1f472-1f3ff': [-1885, -910],
  '1f472': [-1885, -975],
  '1f473-1f3fb': [-1885, -1040],
  '1f473-1f3fc': [-1885, -1105],
  '1f473-1f3fd': [-1885, -1170],
  '1f473-1f3fe': [-1885, -1235],
  '1f473-1f3ff': [-1885, -1300],
  '1f473': [-1885, -1365],
  '1f474-1f3fb': [-1885, -1430],
  '1f474-1f3fc': [-1885, -1495],
  '1f474-1f3fd': [-1885, -1560],
  '1f474-1f3fe': [-1885, -1625],
  '1f474-1f3ff': [-1885, -1690],
  '1f474': [-1885, -1755],
  '1f475-1f3fb': [-1885, -1820],
  '1f475-1f3fc': [0, -1885],
  '1f475-1f3fd': [-65, -1885],
  '1f475-1f3fe': [-130, -1885],
  '1f475-1f3ff': [-195, -1885],
  '1f475': [-260, -1885],
  '1f476-1f3fb': [-325, -1885],
  '1f476-1f3fc': [-390, -1885],
  '1f476-1f3fd': [-455, -1885],
  '1f476-1f3fe': [-520, -1885],
  '1f476-1f3ff': [-585, -1885],
  '1f476': [-650, -1885],
  '1f477-1f3fb': [-715, -1885],
  '1f477-1f3fc': [-780, -1885],
  '1f477-1f3fd': [-845, -1885],
  '1f477-1f3fe': [-910, -1885],
  '1f477-1f3ff': [-975, -1885],
  '1f477': [-1040, -1885],
  '1f478-1f3fb': [-1105, -1885],
  '1f478-1f3fc': [-1170, -1885],
  '1f478-1f3fd': [-1235, -1885],
  '1f478-1f3fe': [-1300, -1885],
  '1f478-1f3ff': [-1365, -1885],
  '1f478': [-1430, -1885],
  '1f479': [-1495, -1885],
  '1f47a': [-1560, -1885],
  '1f47b': [-1625, -1885],
  '1f47c-1f3fb': [-1690, -1885],
  '1f47c-1f3fc': [-1755, -1885],
  '1f47c-1f3fd': [-1820, -1885],
  '1f47c-1f3fe': [-1885, -1885],
  '1f47c-1f3ff': [-1950, 0],
  '1f47c': [-1950, -65],
  '1f47d': [-1950, -130],
  '1f47e': [-1950, -195],
  '1f47f': [-1950, -260],
  '1f480': [-1950, -325],
  '1f481-1f3fb': [-1950, -390],
  '1f481-1f3fc': [-1950, -455],
  '1f481-1f3fd': [-1950, -520],
  '1f481-1f3fe': [-1950, -585],
  '1f481-1f3ff': [-1950, -650],
  '1f481': [-1950, -715],
  '1f482-1f3fb': [-1950, -780],
  '1f482-1f3fc': [-1950, -845],
  '1f482-1f3fd': [-1950, -910],
  '1f482-1f3fe': [-1950, -975],
  '1f482-1f3ff': [-1950, -1040],
  '1f482': [-1950, -1105],
  '1f483-1f3fb': [-1950, -1170],
  '1f483-1f3fc': [-1950, -1235],
  '1f483-1f3fd': [-1950, -1300],
  '1f483-1f3fe': [-1950, -1365],
  '1f483-1f3ff': [-1950, -1430],
  '1f483': [-1950, -1495],
  '1f484': [-1950, -1560],
  '1f485-1f3fb': [-1950, -1625],
  '1f485-1f3fc': [-1950, -1690],
  '1f485-1f3fd': [-1950, -1755],
  '1f485-1f3fe': [-1950, -1820],
  '1f485-1f3ff': [-1950, -1885],
  '1f485': [0, -1950],
  '1f486-1f3fb': [-65, -1950],
  '1f486-1f3fc': [-130, -1950],
  '1f486-1f3fd': [-195, -1950],
  '1f486-1f3fe': [-260, -1950],
  '1f486-1f3ff': [-325, -1950],
  '1f486': [-390, -1950],
  '1f487-1f3fb': [-455, -1950],
  '1f487-1f3fc': [-520, -1950],
  '1f487-1f3fd': [-585, -1950],
  '1f487-1f3fe': [-650, -1950],
  '1f487-1f3ff': [-715, -1950],
  '1f487': [-780, -1950],
  '1f488': [-845, -1950],
  '1f489': [-910, -1950],
  '1f48a': [-975, -1950],
  '1f48b': [-1040, -1950],
  '1f48c': [-1105, -1950],
  '1f48d': [-1170, -1950],
  '1f48e': [-1235, -1950],
  '1f48f': [-1300, -1950],
  '1f490': [-1365, -1950],
  '1f491': [-1430, -1950],
  '1f492': [-1495, -1950],
  '1f493': [-1560, -1950],
  '1f494': [-1625, -1950],
  '1f495': [-1690, -1950],
  '1f496': [-1755, -1950],
  '1f497': [-1820, -1950],
  '1f498': [-1885, -1950],
  '1f499': [-1950, -1950],
  '1f49a': [-2015, 0],
  '1f49b': [-2015, -65],
  '1f49c': [-2015, -130],
  '1f49d': [-2015, -195],
  '1f49e': [-2015, -260],
  '1f49f': [-2015, -325],
  '1f4a0': [-2015, -390],
  '1f4a1': [-2015, -455],
  '1f4a2': [-2015, -520],
  '1f4a3': [-2015, -585],
  '1f4a4': [-2015, -650],
  '1f4a5': [-2015, -715],
  '1f4a6': [-2015, -780],
  '1f4a7': [-2015, -845],
  '1f4a8': [-2015, -910],
  '1f4a9': [-2015, -975],
  '1f4aa-1f3fb': [-2015, -1040],
  '1f4aa-1f3fc': [-2015, -1105],
  '1f4aa-1f3fd': [-2015, -1170],
  '1f4aa-1f3fe': [-2015, -1235],
  '1f4aa-1f3ff': [-2015, -1300],
  '1f4aa': [-2015, -1365],
  '1f4ab': [-2015, -1430],
  '1f4ac': [-2015, -1495],
  '1f4ad': [-2015, -1560],
  '1f4ae': [-2015, -1625],
  '1f4af': [-2015, -1690],
  '1f4b0': [-2015, -1755],
  '1f4b1': [-2015, -1820],
  '1f4b2': [-2015, -1885],
  '1f4b3': [-2015, -1950],
  '1f4b4': [0, -2015],
  '1f4b5': [-65, -2015],
  '1f4b6': [-130, -2015],
  '1f4b7': [-195, -2015],
  '1f4b8': [-260, -2015],
  '1f4b9': [-325, -2015],
  '1f4ba': [-390, -2015],
  '1f4bb': [-455, -2015],
  '1f4bc': [-520, -2015],
  '1f4bd': [-585, -2015],
  '1f4be': [-650, -2015],
  '1f4bf': [-715, -2015],
  '1f4c0': [-780, -2015],
  '1f4c1': [-845, -2015],
  '1f4c2': [-910, -2015],
  '1f4c3': [-975, -2015],
  '1f4c4': [-1040, -2015],
  '1f4c5': [-1105, -2015],
  '1f4c6': [-1170, -2015],
  '1f4c7': [-1235, -2015],
  '1f4c8': [-1300, -2015],
  '1f4c9': [-1365, -2015],
  '1f4ca': [-1430, -2015],
  '1f4cb': [-1495, -2015],
  '1f4cc': [-1560, -2015],
  '1f4cd': [-1625, -2015],
  '1f4ce': [-1690, -2015],
  '1f4cf': [-1755, -2015],
  '1f4d0': [-1820, -2015],
  '1f4d1': [-1885, -2015],
  '1f4d2': [-1950, -2015],
  '1f4d3': [-2015, -2015],
  '1f4d4': [-2080, 0],
  '1f4d5': [-2080, -65],
  '1f4d6': [-2080, -130],
  '1f4d7': [-2080, -195],
  '1f4d8': [-2080, -260],
  '1f4d9': [-2080, -325],
  '1f4da': [-2080, -390],
  '1f4db': [-2080, -455],
  '1f4dc': [-2080, -520],
  '1f4dd': [-2080, -585],
  '1f4de': [-2080, -650],
  '1f4df': [-2080, -715],
  '1f4e0': [-2080, -780],
  '1f4e1': [-2080, -845],
  '1f4e2': [-2080, -910],
  '1f4e3': [-2080, -975],
  '1f4e4': [-2080, -1040],
  '1f4e5': [-2080, -1105],
  '1f4e6': [-2080, -1170],
  '1f4e7': [-2080, -1235],
  '1f4e8': [-2080, -1300],
  '1f4e9': [-2080, -1365],
  '1f4ea': [-2080, -1430],
  '1f4eb': [-2080, -1495],
  '1f4ec': [-2080, -1560],
  '1f4ed': [-2080, -1625],
  '1f4ee': [-2080, -1690],
  '1f4ef': [-2080, -1755],
  '1f4f0': [-2080, -1820],
  '1f4f1': [-2080, -1885],
  '1f4f2': [-2080, -1950],
  '1f4f3': [-2080, -2015],
  '1f4f4': [0, -2080],
  '1f4f5': [-65, -2080],
  '1f4f6': [-130, -2080],
  '1f4f7': [-195, -2080],
  '1f4f8': [-260, -2080],
  '1f4f9': [-325, -2080],
  '1f4fa': [-390, -2080],
  '1f4fb': [-455, -2080],
  '1f4fc': [-520, -2080],
  '1f4fd': [-585, -2080],
  '1f4ff': [-650, -2080],
  '1f500': [-715, -2080],
  '1f501': [-780, -2080],
  '1f502': [-845, -2080],
  '1f503': [-910, -2080],
  '1f504': [-975, -2080],
  '1f505': [-1040, -2080],
  '1f506': [-1105, -2080],
  '1f507': [-1170, -2080],
  '1f508': [-1235, -2080],
  '1f509': [-1300, -2080],
  '1f50a': [-1365, -2080],
  '1f50b': [-1430, -2080],
  '1f50c': [-1495, -2080],
  '1f50d': [-1560, -2080],
  '1f50e': [-1625, -2080],
  '1f50f': [-1690, -2080],
  '1f510': [-1755, -2080],
  '1f511': [-1820, -2080],
  '1f512': [-1885, -2080],
  '1f513': [-1950, -2080],
  '1f514': [-2015, -2080],
  '1f515': [-2080, -2080],
  '1f516': [-2145, 0],
  '1f517': [-2145, -65],
  '1f518': [-2145, -130],
  '1f519': [-2145, -195],
  '1f51a': [-2145, -260],
  '1f51b': [-2145, -325],
  '1f51c': [-2145, -390],
  '1f51d': [-2145, -455],
  '1f51e': [-2145, -520],
  '1f51f': [-2145, -585],
  '1f520': [-2145, -650],
  '1f521': [-2145, -715],
  '1f522': [-2145, -780],
  '1f523': [-2145, -845],
  '1f524': [-2145, -910],
  '1f525': [-2145, -975],
  '1f526': [-2145, -1040],
  '1f527': [-2145, -1105],
  '1f528': [-2145, -1170],
  '1f529': [-2145, -1235],
  '1f52a': [-2145, -1300],
  '1f52b': [-2145, -1365],
  '1f52c': [-2145, -1430],
  '1f52d': [-2145, -1495],
  '1f52e': [-2145, -1560],
  '1f52f': [-2145, -1625],
  '1f530': [-2145, -1690],
  '1f531': [-2145, -1755],
  '1f532': [-2145, -1820],
  '1f533': [-2145, -1885],
  '1f534': [-2145, -1950],
  '1f535': [-2145, -2015],
  '1f536': [-2145, -2080],
  '1f537': [0, -2145],
  '1f538': [-65, -2145],
  '1f539': [-130, -2145],
  '1f53a': [-195, -2145],
  '1f53b': [-260, -2145],
  '1f53c': [-325, -2145],
  '1f53d': [-390, -2145],
  '1f549': [-455, -2145],
  '1f54a': [-520, -2145],
  '1f54b': [-585, -2145],
  '1f54c': [-650, -2145],
  '1f54d': [-715, -2145],
  '1f54e': [-780, -2145],
  '1f550': [-845, -2145],
  '1f551': [-910, -2145],
  '1f552': [-975, -2145],
  '1f553': [-1040, -2145],
  '1f554': [-1105, -2145],
  '1f555': [-1170, -2145],
  '1f556': [-1235, -2145],
  '1f557': [-1300, -2145],
  '1f558': [-1365, -2145],
  '1f559': [-1430, -2145],
  '1f55a': [-1495, -2145],
  '1f55b': [-1560, -2145],
  '1f55c': [-1625, -2145],
  '1f55d': [-1690, -2145],
  '1f55e': [-1755, -2145],
  '1f55f': [-1820, -2145],
  '1f560': [-1885, -2145],
  '1f561': [-1950, -2145],
  '1f562': [-2015, -2145],
  '1f563': [-2080, -2145],
  '1f564': [-2145, -2145],
  '1f565': [-2210, 0],
  '1f566': [-2210, -65],
  '1f567': [-2210, -130],
  '1f56f': [-2210, -195],
  '1f570': [-2210, -260],
  '1f573': [-2210, -325],
  '1f574': [-2210, -390],
  '1f575-1f3fb': [-2210, -455],
  '1f575-1f3fc': [-2210, -520],
  '1f575-1f3fd': [-2210, -585],
  '1f575-1f3fe': [-2210, -650],
  '1f575-1f3ff': [-2210, -715],
  '1f575': [-2210, -780],
  '1f576': [-2210, -845],
  '1f577': [-2210, -910],
  '1f578': [-2210, -975],
  '1f579': [-2210, -1040],
  '1f57a-1f3fb': [-2210, -1105],
  '1f57a-1f3fc': [-2210, -1170],
  '1f57a-1f3fd': [-2210, -1235],
  '1f57a-1f3fe': [-2210, -1300],
  '1f57a-1f3ff': [-2210, -1365],
  '1f57a': [-2210, -1430],
  '1f587': [-2210, -1495],
  '1f58a': [-2210, -1560],
  '1f58b': [-2210, -1625],
  '1f58c': [-2210, -1690],
  '1f58d': [-2210, -1755],
  '1f590-1f3fb': [-2210, -1820],
  '1f590-1f3fc': [-2210, -1885],
  '1f590-1f3fd': [-2210, -1950],
  '1f590-1f3fe': [-2210, -2015],
  '1f590-1f3ff': [-2210, -2080],
  '1f590': [-2210, -2145],
  '1f595-1f3fb': [0, -2210],
  '1f595-1f3fc': [-65, -2210],
  '1f595-1f3fd': [-130, -2210],
  '1f595-1f3fe': [-195, -2210],
  '1f595-1f3ff': [-260, -2210],
  '1f595': [-325, -2210],
  '1f596-1f3fb': [-390, -2210],
  '1f596-1f3fc': [-455, -2210],
  '1f596-1f3fd': [-520, -2210],
  '1f596-1f3fe': [-585, -2210],
  '1f596-1f3ff': [-650, -2210],
  '1f596': [-715, -2210],
  '1f5a4': [-780, -2210],
  '1f5a5': [-845, -2210],
  '1f5a8': [-910, -2210],
  '1f5b1': [-975, -2210],
  '1f5b2': [-1040, -2210],
  '1f5bc': [-1105, -2210],
  '1f5c2': [-1170, -2210],
  '1f5c3': [-1235, -2210],
  '1f5c4': [-1300, -2210],
  '1f5d1': [-1365, -2210],
  '1f5d2': [-1430, -2210],
  '1f5d3': [-1495, -2210],
  '1f5dc': [-1560, -2210],
  '1f5dd': [-1625, -2210],
  '1f5de': [-1690, -2210],
  '1f5e1': [-1755, -2210],
  '1f5e3': [-1820, -2210],
  '1f5e8': [-1885, -2210],
  '1f5ef': [-1950, -2210],
  '1f5f3': [-2015, -2210],
  '1f5fa': [-2080, -2210],
  '1f5fb': [-2145, -2210],
  '1f5fc': [-2210, -2210],
  '1f5fd': [-2275, 0],
  '1f5fe': [-2275, -65],
  '1f5ff': [-2275, -130],
  '1f600': [-2275, -195],
  '1f601': [-2275, -260],
  '1f602': [-2275, -325],
  '1f603': [-2275, -390],
  '1f604': [-2275, -455],
  '1f605': [-2275, -520],
  '1f606': [-2275, -585],
  '1f607': [-2275, -650],
  '1f608': [-2275, -715],
  '1f609': [-2275, -780],
  '1f60a': [-2275, -845],
  '1f60b': [-2275, -910],
  '1f60c': [-2275, -975],
  '1f60d': [-2275, -1040],
  '1f60e': [-2275, -1105],
  '1f60f': [-2275, -1170],
  '1f610': [-2275, -1235],
  '1f611': [-2275, -1300],
  '1f612': [-2275, -1365],
  '1f613': [-2275, -1430],
  '1f614': [-2275, -1495],
  '1f615': [-2275, -1560],
  '1f616': [-2275, -1625],
  '1f617': [-2275, -1690],
  '1f618': [-2275, -1755],
  '1f619': [-2275, -1820],
  '1f61a': [-2275, -1885],
  '1f61b': [-2275, -1950],
  '1f61c': [-2275, -2015],
  '1f61d': [-2275, -2080],
  '1f61e': [-2275, -2145],
  '1f61f': [-2275, -2210],
  '1f620': [0, -2275],
  '1f621': [-65, -2275],
  '1f622': [-130, -2275],
  '1f623': [-195, -2275],
  '1f624': [-260, -2275],
  '1f625': [-325, -2275],
  '1f626': [-390, -2275],
  '1f627': [-455, -2275],
  '1f628': [-520, -2275],
  '1f629': [-585, -2275],
  '1f62a': [-650, -2275],
  '1f62b': [-715, -2275],
  '1f62c': [-780, -2275],
  '1f62d': [-845, -2275],
  '1f62e': [-910, -2275],
  '1f62f': [-975, -2275],
  '1f630': [-1040, -2275],
  '1f631': [-1105, -2275],
  '1f632': [-1170, -2275],
  '1f633': [-1235, -2275],
  '1f634': [-1300, -2275],
  '1f635': [-1365, -2275],
  '1f636': [-1430, -2275],
  '1f637': [-1495, -2275],
  '1f638': [-1560, -2275],
  '1f639': [-1625, -2275],
  '1f63a': [-1690, -2275],
  '1f63b': [-1755, -2275],
  '1f63c': [-1820, -2275],
  '1f63d': [-1885, -2275],
  '1f63e': [-1950, -2275],
  '1f63f': [-2015, -2275],
  '1f640': [-2080, -2275],
  '1f641': [-2145, -2275],
  '1f642': [-2210, -2275],
  '1f643': [-2275, -2275],
  '1f644': [-2340, 0],
  '1f645-1f3fb': [-2340, -65],
  '1f645-1f3fc': [-2340, -130],
  '1f645-1f3fd': [-2340, -195],
  '1f645-1f3fe': [-2340, -260],
  '1f645-1f3ff': [-2340, -325],
  '1f645': [-2340, -390],
  '1f646-1f3fb': [-2340, -455],
  '1f646-1f3fc': [-2340, -520],
  '1f646-1f3fd': [-2340, -585],
  '1f646-1f3fe': [-2340, -650],
  '1f646-1f3ff': [-2340, -715],
  '1f646': [-2340, -780],
  '1f647-1f3fb': [-2340, -845],
  '1f647-1f3fc': [-2340, -910],
  '1f647-1f3fd': [-2340, -975],
  '1f647-1f3fe': [-2340, -1040],
  '1f647-1f3ff': [-2340, -1105],
  '1f647': [-2340, -1170],
  '1f648': [-2340, -1235],
  '1f649': [-2340, -1300],
  '1f64a': [-2340, -1365],
  '1f64b-1f3fb': [-2340, -1430],
  '1f64b-1f3fc': [-2340, -1495],
  '1f64b-1f3fd': [-2340, -1560],
  '1f64b-1f3fe': [-2340, -1625],
  '1f64b-1f3ff': [-2340, -1690],
  '1f64b': [-2340, -1755],
  '1f64c-1f3fb': [-2340, -1820],
  '1f64c-1f3fc': [-2340, -1885],
  '1f64c-1f3fd': [-2340, -1950],
  '1f64c-1f3fe': [-2340, -2015],
  '1f64c-1f3ff': [-2340, -2080],
  '1f64c': [-2340, -2145],
  '1f64d-1f3fb': [-2340, -2210],
  '1f64d-1f3fc': [-2340, -2275],
  '1f64d-1f3fd': [0, -2340],
  '1f64d-1f3fe': [-65, -2340],
  '1f64d-1f3ff': [-130, -2340],
  '1f64d': [-195, -2340],
  '1f64e-1f3fb': [-260, -2340],
  '1f64e-1f3fc': [-325, -2340],
  '1f64e-1f3fd': [-390, -2340],
  '1f64e-1f3fe': [-455, -2340],
  '1f64e-1f3ff': [-520, -2340],
  '1f64e': [-585, -2340],
  '1f64f-1f3fb': [-650, -2340],
  '1f64f-1f3fc': [-715, -2340],
  '1f64f-1f3fd': [-780, -2340],
  '1f64f-1f3fe': [-845, -2340],
  '1f64f-1f3ff': [-910, -2340],
  '1f64f': [-975, -2340],
  '1f680': [-1040, -2340],
  '1f681': [-1105, -2340],
  '1f682': [-1170, -2340],
  '1f683': [-1235, -2340],
  '1f684': [-1300, -2340],
  '1f685': [-1365, -2340],
  '1f686': [-1430, -2340],
  '1f687': [-1495, -2340],
  '1f688': [-1560, -2340],
  '1f689': [-1625, -2340],
  '1f68a': [-1690, -2340],
  '1f68b': [-1755, -2340],
  '1f68c': [-1820, -2340],
  '1f68d': [-1885, -2340],
  '1f68e': [-1950, -2340],
  '1f68f': [-2015, -2340],
  '1f690': [-2080, -2340],
  '1f691': [-2145, -2340],
  '1f692': [-2210, -2340],
  '1f693': [-2275, -2340],
  '1f694': [-2340, -2340],
  '1f695': [-2405, 0],
  '1f696': [-2405, -65],
  '1f697': [-2405, -130],
  '1f698': [-2405, -195],
  '1f699': [-2405, -260],
  '1f69a': [-2405, -325],
  '1f69b': [-2405, -390],
  '1f69c': [-2405, -455],
  '1f69d': [-2405, -520],
  '1f69e': [-2405, -585],
  '1f69f': [-2405, -650],
  '1f6a0': [-2405, -715],
  '1f6a1': [-2405, -780],
  '1f6a2': [-2405, -845],
  '1f6a3-1f3fb': [-2405, -910],
  '1f6a3-1f3fc': [-2405, -975],
  '1f6a3-1f3fd': [-2405, -1040],
  '1f6a3-1f3fe': [-2405, -1105],
  '1f6a3-1f3ff': [-2405, -1170],
  '1f6a3': [-2405, -1235],
  '1f6a4': [-2405, -1300],
  '1f6a5': [-2405, -1365],
  '1f6a6': [-2405, -1430],
  '1f6a7': [-2405, -1495],
  '1f6a8': [-2405, -1560],
  '1f6a9': [-2405, -1625],
  '1f6aa': [-2405, -1690],
  '1f6ab': [-2405, -1755],
  '1f6ac': [-2405, -1820],
  '1f6ad': [-2405, -1885],
  '1f6ae': [-2405, -1950],
  '1f6af': [-2405, -2015],
  '1f6b0': [-2405, -2080],
  '1f6b1': [-2405, -2145],
  '1f6b2': [-2405, -2210],
  '1f6b3': [-2405, -2275],
  '1f6b4-1f3fb': [-2405, -2340],
  '1f6b4-1f3fc': [0, -2405],
  '1f6b4-1f3fd': [-65, -2405],
  '1f6b4-1f3fe': [-130, -2405],
  '1f6b4-1f3ff': [-195, -2405],
  '1f6b4': [-260, -2405],
  '1f6b5-1f3fb': [-325, -2405],
  '1f6b5-1f3fc': [-390, -2405],
  '1f6b5-1f3fd': [-455, -2405],
  '1f6b5-1f3fe': [-520, -2405],
  '1f6b5-1f3ff': [-585, -2405],
  '1f6b5': [-650, -2405],
  '1f6b6-1f3fb': [-715, -2405],
  '1f6b6-1f3fc': [-780, -2405],
  '1f6b6-1f3fd': [-845, -2405],
  '1f6b6-1f3fe': [-910, -2405],
  '1f6b6-1f3ff': [-975, -2405],
  '1f6b6': [-1040, -2405],
  '1f6b7': [-1105, -2405],
  '1f6b8': [-1170, -2405],
  '1f6b9': [-1235, -2405],
  '1f6ba': [-1300, -2405],
  '1f6bb': [-1365, -2405],
  '1f6bc': [-1430, -2405],
  '1f6bd': [-1495, -2405],
  '1f6be': [-1560, -2405],
  '1f6bf': [-1625, -2405],
  '1f6c0-1f3fb': [-1690, -2405],
  '1f6c0-1f3fc': [-1755, -2405],
  '1f6c0-1f3fd': [-1820, -2405],
  '1f6c0-1f3fe': [-1885, -2405],
  '1f6c0-1f3ff': [-1950, -2405],
  '1f6c0': [-2015, -2405],
  '1f6c1': [-2080, -2405],
  '1f6c2': [-2145, -2405],
  '1f6c3': [-2210, -2405],
  '1f6c4': [-2275, -2405],
  '1f6c5': [-2340, -2405],
  '1f6cb': [-2405, -2405],
  '1f6cc': [-2470, 0],
  '1f6cd': [-2470, -65],
  '1f6ce': [-2470, -130],
  '1f6cf': [-2470, -195],
  '1f6d0': [-2470, -260],
  '1f6d1': [-2470, -325],
  '1f6d2': [-2470, -390],
  '1f6e0': [-2470, -455],
  '1f6e1': [-2470, -520],
  '1f6e2': [-2470, -585],
  '1f6e3': [-2470, -650],
  '1f6e4': [-2470, -715],
  '1f6e5': [-2470, -780],
  '1f6e9': [-2470, -845],
  '1f6eb': [-2470, -910],
  '1f6ec': [-2470, -975],
  '1f6f0': [-2470, -1040],
  '1f6f3': [-2470, -1105],
  '1f6f4': [-2470, -1170],
  '1f6f5': [-2470, -1235],
  '1f6f6': [-2470, -1300],
  '1f910': [-2470, -1365],
  '1f911': [-2470, -1430],
  '1f912': [-2470, -1495],
  '1f913': [-2470, -1560],
  '1f914': [-2470, -1625],
  '1f915': [-2470, -1690],
  '1f916': [-2470, -1755],
  '1f917': [-2470, -1820],
  '1f918-1f3fb': [-2470, -1885],
  '1f918-1f3fc': [-2470, -1950],
  '1f918-1f3fd': [-2470, -2015],
  '1f918-1f3fe': [-2470, -2080],
  '1f918-1f3ff': [-2470, -2145],
  '1f918': [-2470, -2210],
  '1f919-1f3fb': [-2470, -2275],
  '1f919-1f3fc': [-2470, -2340],
  '1f919-1f3fd': [-2470, -2405],
  '1f919-1f3fe': [0, -2470],
  '1f919-1f3ff': [-65, -2470],
  '1f919': [-130, -2470],
  '1f91a-1f3fb': [-195, -2470],
  '1f91a-1f3fc': [-260, -2470],
  '1f91a-1f3fd': [-325, -2470],
  '1f91a-1f3fe': [-390, -2470],
  '1f91a-1f3ff': [-455, -2470],
  '1f91a': [-520, -2470],
  '1f91b-1f3fb': [-585, -2470],
  '1f91b-1f3fc': [-650, -2470],
  '1f91b-1f3fd': [-715, -2470],
  '1f91b-1f3fe': [-780, -2470],
  '1f91b-1f3ff': [-845, -2470],
  '1f91b': [-910, -2470],
  '1f91c-1f3fb': [-975, -2470],
  '1f91c-1f3fc': [-1040, -2470],
  '1f91c-1f3fd': [-1105, -2470],
  '1f91c-1f3fe': [-1170, -2470],
  '1f91c-1f3ff': [-1235, -2470],
  '1f91c': [-1300, -2470],
  '1f91d-1f3fb': [-1365, -2470],
  '1f91d-1f3fc': [-1430, -2470],
  '1f91d-1f3fd': [-1495, -2470],
  '1f91d-1f3fe': [-1560, -2470],
  '1f91d-1f3ff': [-1625, -2470],
  '1f91d': [-1690, -2470],
  '1f91e-1f3fb': [-1755, -2470],
  '1f91e-1f3fc': [-1820, -2470],
  '1f91e-1f3fd': [-1885, -2470],
  '1f91e-1f3fe': [-1950, -2470],
  '1f91e-1f3ff': [-2015, -2470],
  '1f91e': [-2080, -2470],
  '1f920': [-2145, -2470],
  '1f921': [-2210, -2470],
  '1f922': [-2275, -2470],
  '1f923': [-2340, -2470],
  '1f924': [-2405, -2470],
  '1f925': [-2470, -2470],
  '1f926-1f3fb': [-2535, 0],
  '1f926-1f3fc': [-2535, -65],
  '1f926-1f3fd': [-2535, -130],
  '1f926-1f3fe': [-2535, -195],
  '1f926-1f3ff': [-2535, -260],
  '1f926': [-2535, -325],
  '1f927': [-2535, -390],
  '1f930-1f3fb': [-2535, -455],
  '1f930-1f3fc': [-2535, -520],
  '1f930-1f3fd': [-2535, -585],
  '1f930-1f3fe': [-2535, -650],
  '1f930-1f3ff': [-2535, -715],
  '1f930': [-2535, -780],
  '1f933-1f3fb': [-2535, -845],
  '1f933-1f3fc': [-2535, -910],
  '1f933-1f3fd': [-2535, -975],
  '1f933-1f3fe': [-2535, -1040],
  '1f933-1f3ff': [-2535, -1105],
  '1f933': [-2535, -1170],
  '1f934-1f3fb': [-2535, -1235],
  '1f934-1f3fc': [-2535, -1300],
  '1f934-1f3fd': [-2535, -1365],
  '1f934-1f3fe': [-2535, -1430],
  '1f934-1f3ff': [-2535, -1495],
  '1f934': [-2535, -1560],
  '1f935-1f3fb': [-2535, -1625],
  '1f935-1f3fc': [-2535, -1690],
  '1f935-1f3fd': [-2535, -1755],
  '1f935-1f3fe': [-2535, -1820],
  '1f935-1f3ff': [-2535, -1885],
  '1f935': [-2535, -1950],
  '1f936-1f3fb': [-2535, -2015],
  '1f936-1f3fc': [-2535, -2080],
  '1f936-1f3fd': [-2535, -2145],
  '1f936-1f3fe': [-2535, -2210],
  '1f936-1f3ff': [-2535, -2275],
  '1f936': [-2535, -2340],
  '1f937-1f3fb': [-2535, -2405],
  '1f937-1f3fc': [-2535, -2470],
  '1f937-1f3fd': [0, -2535],
  '1f937-1f3fe': [-65, -2535],
  '1f937-1f3ff': [-130, -2535],
  '1f937': [-195, -2535],
  '1f938-1f3fb': [-260, -2535],
  '1f938-1f3fc': [-325, -2535],
  '1f938-1f3fd': [-390, -2535],
  '1f938-1f3fe': [-455, -2535],
  '1f938-1f3ff': [-520, -2535],
  '1f938': [-585, -2535],
  '1f939-1f3fb': [-650, -2535],
  '1f939-1f3fc': [-715, -2535],
  '1f939-1f3fd': [-780, -2535],
  '1f939-1f3fe': [-845, -2535],
  '1f939-1f3ff': [-910, -2535],
  '1f939': [-975, -2535],
  '1f93a': [-1040, -2535],
  '1f93c-1f3fb': [-1105, -2535],
  '1f93c-1f3fc': [-1170, -2535],
  '1f93c-1f3fd': [-1235, -2535],
  '1f93c-1f3fe': [-1300, -2535],
  '1f93c-1f3ff': [-1365, -2535],
  '1f93c': [-1430, -2535],
  '1f93d-1f3fb': [-1495, -2535],
  '1f93d-1f3fc': [-1560, -2535],
  '1f93d-1f3fd': [-1625, -2535],
  '1f93d-1f3fe': [-1690, -2535],
  '1f93d-1f3ff': [-1755, -2535],
  '1f93d': [-1820, -2535],
  '1f93e-1f3fb': [-1885, -2535],
  '1f93e-1f3fc': [-1950, -2535],
  '1f93e-1f3fd': [-2015, -2535],
  '1f93e-1f3fe': [-2080, -2535],
  '1f93e-1f3ff': [-2145, -2535],
  '1f93e': [-2210, -2535],
  '1f940': [-2275, -2535],
  '1f941': [-2340, -2535],
  '1f942': [-2405, -2535],
  '1f943': [-2470, -2535],
  '1f944': [-2535, -2535],
  '1f945': [-2600, 0],
  '1f947': [-2600, -65],
  '1f948': [-2600, -130],
  '1f949': [-2600, -195],
  '1f94a': [-2600, -260],
  '1f94b': [-2600, -325],
  '1f950': [-2600, -390],
  '1f951': [-2600, -455],
  '1f952': [-2600, -520],
  '1f953': [-2600, -585],
  '1f954': [-2600, -650],
  '1f955': [-2600, -715],
  '1f956': [-2600, -780],
  '1f957': [-2600, -845],
  '1f958': [-2600, -910],
  '1f959': [-2600, -975],
  '1f95a': [-2600, -1040],
  '1f95b': [-2600, -1105],
  '1f95c': [-2600, -1170],
  '1f95d': [-2600, -1235],
  '1f95e': [-2600, -1300],
  '1f980': [-2600, -1365],
  '1f981': [-2600, -1430],
  '1f982': [-2600, -1495],
  '1f983': [-2600, -1560],
  '1f984': [-2600, -1625],
  '1f985': [-2600, -1690],
  '1f986': [-2600, -1755],
  '1f987': [-2600, -1820],
  '1f988': [-2600, -1885],
  '1f989': [-2600, -1950],
  '1f98a': [-2600, -2015],
  '1f98b': [-2600, -2080],
  '1f98c': [-2600, -2145],
  '1f98d': [-2600, -2210],
  '1f98e': [-2600, -2275],
  '1f98f': [-2600, -2340],
  '1f990': [-2600, -2405],
  '1f991': [-2600, -2470],
  '1f9c0': [-2600, -2535],
  '203c': [0, -2600],
  '2049': [-65, -2600],
  '2122': [-130, -2600],
  '2139': [-195, -2600],
  '2194': [-260, -2600],
  '2195': [-325, -2600],
  '2196': [-390, -2600],
  '2197': [-455, -2600],
  '2198': [-520, -2600],
  '2199': [-585, -2600],
  '21a9': [-650, -2600],
  '21aa': [-715, -2600],
  '231a': [-780, -2600],
  '231b': [-845, -2600],
  '2328': [-910, -2600],
  '23cf': [-975, -2600],
  '23e9': [-1040, -2600],
  '23ea': [-1105, -2600],
  '23eb': [-1170, -2600],
  '23ec': [-1235, -2600],
  '23ed': [-1300, -2600],
  '23ee': [-1365, -2600],
  '23ef': [-1430, -2600],
  '23f0': [-1495, -2600],
  '23f1': [-1560, -2600],
  '23f2': [-1625, -2600],
  '23f3': [-1690, -2600],
  '23f8': [-1755, -2600],
  '23f9': [-1820, -2600],
  '23fa': [-1885, -2600],
  '24c2': [-1950, -2600],
  '25aa': [-2015, -2600],
  '25ab': [-2080, -2600],
  '25b6': [-2145, -2600],
  '25c0': [-2210, -2600],
  '25fb': [-2275, -2600],
  '25fc': [-2340, -2600],
  '25fd': [-2405, -2600],
  '25fe': [-2470, -2600],
  '2600': [-2535, -2600],
  '2601': [-2600, -2600],
  '2602': [-2665, 0],
  '2603': [-2665, -65],
  '2604': [-2665, -130],
  '260e': [-2665, -195],
  '2611': [-2665, -260],
  '2614': [-2665, -325],
  '2615': [-2665, -390],
  '2618': [-2665, -455],
  '261d-1f3fb': [-2665, -520],
  '261d-1f3fc': [-2665, -585],
  '261d-1f3fd': [-2665, -650],
  '261d-1f3fe': [-2665, -715],
  '261d-1f3ff': [-2665, -780],
  '261d': [-2665, -845],
  '2620': [-2665, -910],
  '2622': [-2665, -975],
  '2623': [-2665, -1040],
  '2626': [-2665, -1105],
  '262a': [-2665, -1170],
  '262e': [-2665, -1235],
  '262f': [-2665, -1300],
  '2638': [-2665, -1365],
  '2639': [-2665, -1430],
  '263a': [-2665, -1495],
  '2648': [-2665, -1560],
  '2649': [-2665, -1625],
  '264a': [-2665, -1690],
  '264b': [-2665, -1755],
  '264c': [-2665, -1820],
  '264d': [-2665, -1885],
  '264e': [-2665, -1950],
  '264f': [-2665, -2015],
  '2650': [-2665, -2080],
  '2651': [-2665, -2145],
  '2652': [-2665, -2210],
  '2653': [-2665, -2275],
  '2660': [-2665, -2340],
  '2663': [-2665, -2405],
  '2665': [-2665, -2470],
  '2666': [-2665, -2535],
  '2668': [-2665, -2600],
  '267b': [0, -2665],
  '267f': [-65, -2665],
  '2692': [-130, -2665],
  '2693': [-195, -2665],
  '2694': [-260, -2665],
  '2696': [-325, -2665],
  '2697': [-390, -2665],
  '2699': [-455, -2665],
  '269b': [-520, -2665],
  '269c': [-585, -2665],
  '26a0': [-650, -2665],
  '26a1': [-715, -2665],
  '26aa': [-780, -2665],
  '26ab': [-845, -2665],
  '26b0': [-910, -2665],
  '26b1': [-975, -2665],
  '26bd': [-1040, -2665],
  '26be': [-1105, -2665],
  '26c4': [-1170, -2665],
  '26c5': [-1235, -2665],
  '26c8': [-1300, -2665],
  '26ce': [-1365, -2665],
  '26cf': [-1430, -2665],
  '26d1': [-1495, -2665],
  '26d3': [-1560, -2665],
  '26d4': [-1625, -2665],
  '26e9': [-1690, -2665],
  '26ea': [-1755, -2665],
  '26f0': [-1820, -2665],
  '26f1': [-1885, -2665],
  '26f2': [-1950, -2665],
  '26f3': [-2015, -2665],
  '26f4': [-2080, -2665],
  '26f5': [-2145, -2665],
  '26f7': [-2210, -2665],
  '26f8': [-2275, -2665],
  '26f9-1f3fb': [-2340, -2665],
  '26f9-1f3fc': [-2405, -2665],
  '26f9-1f3fd': [-2470, -2665],
  '26f9-1f3fe': [-2535, -2665],
  '26f9-1f3ff': [-2600, -2665],
  '26f9': [-2665, -2665],
  '26fa': [-2730, 0],
  '26fd': [-2730, -65],
  '2702': [-2730, -130],
  '2705': [-2730, -195],
  '2708': [-2730, -260],
  '2709': [-2730, -325],
  '270a-1f3fb': [-2730, -390],
  '270a-1f3fc': [-2730, -455],
  '270a-1f3fd': [-2730, -520],
  '270a-1f3fe': [-2730, -585],
  '270a-1f3ff': [-2730, -650],
  '270a': [-2730, -715],
  '270b-1f3fb': [-2730, -780],
  '270b-1f3fc': [-2730, -845],
  '270b-1f3fd': [-2730, -910],
  '270b-1f3fe': [-2730, -975],
  '270b-1f3ff': [-2730, -1040],
  '270b': [-2730, -1105],
  '270c-1f3fb': [-2730, -1170],
  '270c-1f3fc': [-2730, -1235],
  '270c-1f3fd': [-2730, -1300],
  '270c-1f3fe': [-2730, -1365],
  '270c-1f3ff': [-2730, -1430],
  '270c': [-2730, -1495],
  '270d-1f3fb': [-2730, -1560],
  '270d-1f3fc': [-2730, -1625],
  '270d-1f3fd': [-2730, -1690],
  '270d-1f3fe': [-2730, -1755],
  '270d-1f3ff': [-2730, -1820],
  '270d': [-2730, -1885],
  '270f': [-2730, -1950],
  '2712': [-2730, -2015],
  '2714': [-2730, -2080],
  '2716': [-2730, -2145],
  '271d': [-2730, -2210],
  '2721': [-2730, -2275],
  '2728': [-2730, -2340],
  '2733': [-2730, -2405],
  '2734': [-2730, -2470],
  '2744': [-2730, -2535],
  '2747': [-2730, -2600],
  '274c': [-2730, -2665],
  '274e': [0, -2730],
  '2753': [-65, -2730],
  '2754': [-130, -2730],
  '2755': [-195, -2730],
  '2757': [-260, -2730],
  '2763': [-325, -2730],
  '2764': [-390, -2730],
  '2795': [-455, -2730],
  '2796': [-520, -2730],
  '2797': [-585, -2730],
  '27a1': [-650, -2730],
  '27b0': [-715, -2730],
  '27bf': [-780, -2730],
  '2934': [-845, -2730],
  '2935': [-910, -2730],
  '2b05': [-975, -2730],
  '2b06': [-1040, -2730],
  '2b07': [-1105, -2730],
  '2b1b': [-1170, -2730],
  '2b1c': [-1235, -2730],
  '2b50': [-1300, -2730],
  '2b55': [-1365, -2730],
  '3030': [-1430, -2730],
  '303d': [-1495, -2730],
  '3297': [-1560, -2730],
  '3299': [-1625, -2730] };

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sprite = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _emojioneSpritePositions = __webpack_require__(45);

var _emojioneSpritePositions2 = _interopRequireDefault(_emojioneSpritePositions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SPRITE_SIZE = 2794;
var EMOJI_SIZE = 64;

var base = {
    textIndent: '-9999em',
    imageRendering: 'optimizeQuality',
    fontSize: 'inherit',
    height: 32,
    width: 32,
    top: -3,
    position: 'relative',
    display: 'inline-block',
    margin: '0 .15em',
    lineHeight: 'normal',
    verticalAlign: 'middle',
    backgroundImage: 'url("https://cdnjs.cloudflare.com/ajax/libs/emojione/2.2.7/assets/sprites/emojione.sprites.png")',
    backgroundRepeat: 'no-repeat'
};

var sprite = exports.sprite = function sprite(codepoint) {
    var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var result = Object.assign({}, base, style);

    // ensure square size
    var size = parseInt(result.height);
    result.height = size;
    result.width = size;

    var scale = size / EMOJI_SIZE;

    var _positions$codepoint = _slicedToArray(_emojioneSpritePositions2.default[codepoint], 2),
        left = _positions$codepoint[0],
        top = _positions$codepoint[1];

    result.backgroundPosition = left * scale + 'px ' + top * scale + 'px';

    var bgSize = SPRITE_SIZE * scale;
    result.backgroundSize = bgSize + 'px ' + bgSize + 'px';

    return result;
};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 48 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 49 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(6);
module.exports = __webpack_require__(7);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.5be90695.js